export default {
  "brandSeo": {
    "pageTitle": "{title} mit Miral AI",
    "toolDescription": "Mit Miral AI: {description}",
    "sectionTitle": "{title} mit Miral AI",
    "faqTitle": "{title} bei Miral AI",
    "toolFreeTrialCta": "Dieses Tool kostenlos auf Miral AI testen",
    "toolProcessCta": "{action} kostenlos",
    "imageFaqs": [
      { "q": "Kann ich die KI-Bildgenerierung auf Miral kostenlos testen?", "a": "Ja. Registrieren Sie sich bei Miral AI, erhalten Sie kostenlose Credits und testen Sie die Generierung. Jedes Ergebnis verbraucht die Credits des gewählten Modells." },
      { "q": "Warum Bilder mit Miral AI erstellen?", "a": "Miral AI vereint führende Bildmodelle an einem Ort, damit Sie Funktionen vergleichen und ohne Plattformwechsel weiterarbeiten können." }
    ],
    "toolFaqs": [
      { "q": "Kann ich dieses Miral AI Tool kostenlos testen?", "a": "Ja. Melden Sie sich bei Miral AI an, um den kostenlosen Test zu starten. Der Zugang hängt von Kontolimits ab und bedeutet keine unbegrenzte Gratisnutzung." },
      { "q": "Warum Kreativtools auf Miral AI verwenden?", "a": "Miral AI verbindet Bildgenerierung und praktische Bearbeitungstools, sodass Erstellung, Verarbeitung und Download in einem Ablauf möglich sind." }
    ]
  },
  "common": {
    "loading": "Laden...",
    "error": "Ein Fehler ist aufgetreten",
    "success": "Erfolg",
    "confirm": "OK",
    "prev": "Zurück",
    "next": "Weiter",
    "optional": "Optional",
    "remove": "Entfernen",
    "generate": "Generieren",
    "generating": "Generierung...",
    "required": "Erforderlich",
    "close": "Schließen",
    "leaveConfirmTitle": "Freundliche Erinnerung",
    "leaveConfirmMessage": "Ihre AI-Arbeit wird noch generiert. Das Wechseln der Seite beeinflusst den Fortschritt nicht. Sie können die Verarbeitung oder abgeschlossenen Werke unter [Mein Konto - Meine Werke] überprüfen.\nMöchten Sie die Seite wirklich verlassen?",
    "leaveConfirmConfirm": "Seite verlassen",
    "leaveConfirmCancel": "Hier bleiben",
    "generateFailedContactSupport": "Generation failed. Please try again or contact support!",
    "localMediaTransferFailed": "Netzwerkschwankungen haben die Datenübertragung oder die Kommunikation mit dem Dienst unterbrochen. Die Generierung wurde abgebrochen. Bitte erneut generieren oder den Support kontaktieren.",
    "errorDetails": "Fehlerdetails",
    "tryAgainOrContactSupportTail": " Bitte versuchen Sie es erneut oder kontaktieren Sie den Support!",
    "errorCategoryImageSizeInvalid": "Die Bildgröße entspricht nicht den Anforderungen. Bitte verwenden Sie ein gültiges Bild",
    "errorCategoryOutputEmptyOrSensitive": "Die Ausgabe wurde aufgrund von Sicherheitsregeln blockiert oder es wurde kein Ergebnis erzeugt. Bitte passen Sie Ihre Eingabe/Ihr Referenzbild an",
    "errorCategoryUpstreamBusy": "Der Dienst ist im Moment beschäftigt (Überlastung auf der Upstream-Seite)",
    "errorCategoryAiNetworkError": "Netzwerkverbindung fehlerhaft. Bitte Netzwerk prüfen und erneut versuchen",
    "errorCategoryAiTimeout": "AI-Anfrage hat das Zeitlimit überschritten. Das Netzwerk könnte instabil sein, bitte versuchen Sie es gleich erneut"
  },
  "api": {
    "errors": {
      "requestFailed": "Anfrage fehlgeschlagen",
      "badRequest": "Ungültige Anfrage",
      "unauthorized": "Nicht autorisiert, bitte melden Sie sich erneut an",
      "forbidden": "Verboten",
      "notFound": "Ressource nicht gefunden",
      "serverError": "Interner Serverfehler",
      "timeout": "Anfrage-Timeout, bitte versuchen Sie es erneut",
      "networkError": "Netzwerkfehler, bitte überprüfen Sie Ihre Verbindung",
      "sessionExpired": "Sitzung abgelaufen, bitte melden Sie sich erneut an",
      "operationFailed": "Operation fehlgeschlagen!"
    }
  },
  "nav": {
    "home": "Startseite",
    "models": "KI-Modelle",
    "pricing": "Preise",
    "faq": "FAQ",
    "login": "Anmelden",
    "signup": "Upgrade",
    "register": "Registrieren",
    "email": "E-Mail",
    "logout": "Abmelden",
    "help": "Hilfe",
    "profile": "Profil",
    "myWorks": "Meine Werke",
    "username": "Benutzername",
    "password": "Passwort",
    "confirmPassword": "Passwort bestätigen",
    "processing": "Verarbeitung...",
    "haveAccount": "Haben Sie bereits ein Konto?",
    "noAccount": "Haben Sie kein Konto?",
    "orContinueWith": "Oder fortfahren mit",
    "loginFailed": "Anmeldung fehlgeschlagen, bitte versuchen Sie es erneut",
    "registerFailed": "Registrierung fehlgeschlagen, bitte versuchen Sie es erneut",
    "fillRequired": "Bitte füllen Sie alle erforderlichen Felder aus",
    "passwordMismatch": "Passwörter stimmen nicht überein",
    "passwordTooShort": "Das Passwort muss mindestens 6 Zeichen lang sein",
    "googleNotLoaded": "Google-Anmeldedienst nicht geladen, bitte aktualisieren Sie die Seite",
    "googleInitFailed": "Initialisierung der Google-Anmeldung fehlgeschlagen",
    "googleUserInfoFailed": "Benutzerinformationen können nicht abgerufen werden",
    "googleCancelled": "Google-Anmeldung abgebrochen",
    "codeLoginHint": "Geben Sie Ihre E-Mail ein, wir senden Ihnen einen Bestätigungscode",
    "verificationCode": "Bestätigungscode",
    "sendCode": "Code senden",
    "resendCode": "Erneut senden",
    "verifyAndLogin": "Verifizieren & Anmelden",
    "enterEmail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
    "invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "sendCodeFailed": "Senden des Bestätigungscodes fehlgeschlagen, bitte versuchen Sie es erneut",
    "checkSpamFolder": "E-Mail nicht gefunden? Überprüfen Sie Ihren Spam/Junk-Ordner",
    "enterValidCode": "Bitte geben Sie den 6-stelligen Bestätigungscode ein",
    "verifyCodeFailed": "Ungültiger oder abgelaufener Bestätigungscode",
    "googleLoginFailed": "Google-Anmeldung fehlgeschlagen, bitte versuchen Sie es erneut",
    "registerHint": "Mit der Registrierung stimmen Sie unseren",
    "and": "und",
    "freeCreditsLabel": "Kostenlose Credits:",
    "freeCreditsDesc": "Erhalten Sie kostenlose Credits durch einfaches Anmelden — keine Zahlung erforderlich!",
    "sidebar": {
      "navigation": "Navigation",
      "home": "Startseite",
      "inspiration": "Inspiration",
      "allModels": "Alle KI-Modelle",
      "videoAI": "Video-KI",
      "videoGenerator": "Video-Generator",
      "newModels": "Neue Modelle",
      "otherModels": "Andere Modelle",
      "videoEnhance": "Video-Verbesserung",
      "musicAI": "KI-Musik",
      "musicGenerator": "KI-Musik",
      "imageAI": "Bild-KI",
      "imageGenerator": "Bild-Generator",
      "hotModels": "Beliebte Modelle",
      "hotTools": "Beliebte Tools",
      "history": "Verlauf",
      "upgrade": "Upgrade"
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - KI-Plattform für Bild-, Video- und Musikerstellung",
    "desc": "Eine All-in-One KI-Plattform für Bild-, Video- und Musikerstellung.",
    "fluxModels": "FLUX-Modelle",
    "aiImages": "KI-Bilder",
    "aiVideos": "KI-Videos",
    "aiMusic": "KI-Musik",
    "product": "Produkt",
    "videoModels": "KI-Videomodelle",
    "imageModels": "KI-Bildmodelle",
    "musicModels": "KI-Musikmodelle",
    "apps": "Apps",
    "company": "Unternehmen",
    "about": "Über uns",
    "contact": "Kontakt",
    "blog": "Blog",
    "tools": "Tools",
    "resources": "Ressourcen",
    "allModels": "Alle KI-Modelle",
    "pricing": "Preise",
    "trustSafety": "Vertrauen & Sicherheit",
    "terms": "Nutzungsbedingungen",
    "privacy": "Datenschutzrichtlinie",
    "faq": "FAQ",
    "musicGenerator": "KI-Musik-Generator",
    "copyright": "© 2025 Miral. Alle Rechte vorbehalten.",
    "langZh": "简体中文",
    "langEn": "English",
    "langDe": "Deutsch"
  },
  "langModal": {
    "title": "Sprache auswählen"
  },
  "about": {
    "tag": "About Miral",
    "title": "About Us",
    "subtitle": "Create images, videos, and music with leading AI models in one place.",
    "paragraphs": [
      "Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.",
      "We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.",
      "Learn more about our data practices on Trust & Safety, or contact support when you need help."
    ]
  },
  "contact": {
    "tag": "Support",
    "title": "Contact Us",
    "subtitle": "We will get back to your questions and feedback as soon as we can.",
    "emailLabel": "Support email",
    "hint": "Email us about billing, credits, or generation issues. We usually reply on business days.",
    "cta": "Send Email"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "Kinematografischer Realismus mit natürlichen Haut-, Textur- und Lichtdetails"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "Multi-Auflösung Bildgenerierung, v2.5 und v3.1 Modi"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "Künstlerischer Stil"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "Künstlerischer Stil"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "Künstlerischer Stil"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "Multifunktional"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "Multifunktional"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "Hochwertige Text-zu-Bild"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "Schnelle Text-zu-Bild"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "Text-zu-Bild der nächsten Generation"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "Hochwertige Text-zu-Bild & Bearbeitung"
      },
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "Text-zu-Bild in hoher Auflösung mit feinen Details"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "Text-zu-Bild mit hoher Auflösung"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Stable Diffusion 3.5 Text-zu-Bild"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "Bewegungssteuerung, Referenzen & Filmstil"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "Text- und Bild-zu-Video, mehrere Auflösungen"
      },
      "seedance": {
        "name": "Seedance AI",
        "desc": "Native Audio-Video-Synchronisation"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "Animationsstil"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "Verbesserte Qualität"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "Mehrere Bildreferenzen"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Fast",
        "desc": "Schnell, unterstützt Endbild"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "Lippen-Synchronisation"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "Lippen-Synchronisation"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4 s / 8 s / 12 s"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "Standard"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "Klassisch"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "Text/Bild zu Video, mehrere Auflösungen"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "Text/Bild zu Video"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "Kreatives Video"
      },
      "runway": {
        "name": "Runway",
        "desc": "Workbench"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "Referenzbild und Bewegungsvideo für Charakteranimation. Standard/Pro, optionales Wasserzeichen."
      }
    }
  },
  "plans": {
    "basic": {
      "name": "Basic",
      "features": [
        "Alle Credits auf einmal geliefert",
        "Erstellen Sie bis zu 2.600 KI-Bilder",
        "Erstellen Sie 520 KI-Videos",
        "Erstellen Sie bis zu 480 KI-Musiktitel",
        "Keine Wasserzeichen",
        "Kommerzielle Lizenz"
      ]
    },
    "pro": {
      "name": "Pro",
      "features": [
        "Alle Credits auf einmal geliefert",
        "Erstellen Sie bis zu 10.600 KI-Bilder",
        "Erstellen Sie bis zu 2.120 KI-Videos",
        "Erstellen Sie bis zu 1.920 KI-Musiktitel",
        "Alle Premium-Modelle",
        "Prioritätswarteschlange",
        "Prioritäts-Support",
        "Privatsphäre-Modus & DPA-Konformität"
      ]
    },
    "ultimate": {
      "name": "Ultimate",
      "features": [
        "Alle Credits auf einmal geliefert",
        "Erstellen Sie bis zu 36.600 KI-Bilder",
        "Erstellen Sie bis zu 7.320 KI-Videos",
        "Erstellen Sie bis zu 6.720 KI-Musiktitel",
        "Alle Premium-Modelle",
        "Dedizierter Support",
        "Privatsphäre-Modus & DPA-Konformität"
      ]
    }
  },
  "home": {
    "generate": "Generieren",
    "chatDisabledGenerateHint": "Bitte gib einen Prompt ein",
    "compactChatPlaceholder": "Prompt eingeben und beeindruckende KI-Bilder, Videos und eigene Musik erstellen",
    "hero": {
      "title": "Miral – All-in-One-KI-Plattform für Bild-, Video- und Musikerstellung",
      "subtitle": "Mit vielseitigen KI-Modellen vereint Miral Bildbearbeitung, Videogenerierung und KI-Musikerstellung. Bearbeiten Sie Fotos, erstellen Sie filmische Porträtvideos und individuelle Hintergrundmusik für private und kommerzielle Projekte.",
      "createVideo": "Video erstellen",
      "createImage": "Bild erstellen"
    },
    "stats": {
      "models": "Top-KI-Modelle",
      "works": "Erstellte Werke",
      "tools": "Professionelle Tools",
      "platforms": "Partner-Plattformen"
    },
    "generatorNew": {
      "promptPlaceholder": "Beschreiben Sie das Video, das Sie generieren möchten...",
      "promptPlaceholderImage": "Beschreiben Sie das Bild, das Sie generieren möchten...",
      "generating": "Wird generiert...",
      "noHistory": "Ergebnisse werden hier angezeigt",
      "generationFailed": "Generierung fehlgeschlagen",
      "historyTitle": "Verlauf",
      "myAssets": "Meine Assets"
    },
    "quickTools": {
      "title": "KI-Schnellwerkzeuge"
    },
    "exploreMore": {
      "title": "Weitere KI-Funktionen entdecken"
    },
    "platform": {
      "tag": "Plattform",
      "title": "KI-Toolbox, die Kreation einfach macht",
      "subtitle": "All-in-One-Bilderstellung, Videokreation, Musikproduktion und professionelle Tools powered by Branchen-führende KI-Modelle.",
      "tabs": {
        "image": "KI-Bilder",
        "video": "KI-Videos",
        "music": "KI-Musik",
        "tools": "KI-Toolbox"
      },
      "image": {
        "title": "Erstellen und bearbeiten Sie atemberaubende Bilder mit Top-KI-Modellen weltweit",
        "desc": "Text-zu-Bild, präzise Bearbeitung, Stilübertragung und HD-Upscaling. Powered by FLUX, Midjourney, Seedream, GPT-Image-1 und Nano Banana.",
        "explore": "Bildmodelle erkunden →"
      },
      "video": {
        "title": "Erstellen Sie filmische Videos mit KI",
        "desc": "Von Text-zu-Video bis Bildanimation, powered by Veo, Sora, Kling, Seedance und Wan-Modelle. Erstellen Sie Videos mit synchronisiertem Audio und professioneller Kameraarbeit.",
        "explore": "Videomodelle erkunden →"
      },
      "music": {
        "title": "KI-gestützte originale Musikerstellung",
        "desc": "Erstellen Sie originale Musik aus Beschreibungen, unterstützt verschiedene Stile und Dauer. Perfekt für Videosoundtracks, Podcast-Hintergrundmusik und mehr.",
        "explore": "KI-Musik erkunden →"
      },
      "tools": {
        "title": "Professionelle KI-Toolbox",
        "desc": "Wasserzeichenentfernung, Fotowiederherstellung, HD-Upscaling, Videoverbesserung und mehr professionelle Tools für alle Ihre Nachbearbeitungsbedürfnisse",
        "explore": "Alle Tools anzeigen →"
      }
    },
    "models": {
      "tag": "Modelle",
      "title": "One-Stop-Integration globaler Top-KI-Modelle",
      "subtitle": "Eine Plattform, die alle gängigen KI-Modelle integriert. Kein Wechsel mehr zwischen mehreren Konten und Abonnements.",
      "imageModels": "Bildmodelle",
      "videoModels": "Videomodelle",
      "musicModels": "KI-Musik",
      "musicDesc": "Erstellen Sie originale Musik aus Beschreibungen",
      "filterAll": "Alle",
      "credits": "Credits",
      "viewAll": "Alle anzeigen →"
    },
    "features": {
      "tag": "Kernfunktionen",
      "title": "Erstellen Sie atemberaubende Bilder, Videos und Musik",
      "subtitle": "Von Text-zu-Bild, Text-zu-Video bis KI-Musikerstellung, plus präzise Bearbeitung und HD-Upscaling — All-in-One-Kreation.",
      "items": {
        "textToImage": {
          "tag": "Text zu Bild",
          "title": "Text zu Bild",
          "desc": "Geben Sie eine Beschreibung ein, erleben Sie die Magie. Egal ob hyperrealistische Porträts oder Fantasie-Landschaften, nutzen Sie Midjourney, Seedream, Nano Banana und andere Modelle, um visuelle Meisterwerke mit einfachen Prompts zu erstellen.",
          "cta": "Bilderstellung",
          "imageAlt": "Erstellen Sie visuelle Meisterwerke mit einfachen Prompts mit Midjourney, Seedream, Nano Banana und anderen Modellen"
        },
        "imageEdit": {
          "tag": "Bildbearbeitung & Stilübertragung",
          "title": "Bildbearbeitung & Stilübertragung",
          "desc": "Nutzen Sie KI zur präzisen Umformung von Bildern. Egal ob Stile ändern, Objekte modifizieren, Hintergründe austauschen oder Text bearbeiten, alles mit hoher Konsistenz.",
          "cta": "Bildbearbeitung",
          "beforeAlt": "Vor der Bildbearbeitung und Stilübertragung",
          "afterAlt": "Nach der Bildbearbeitung und Stilübertragung"
        },
        "textToVideo": {
          "tag": "Text zu Video",
          "title": "Text zu Video",
          "desc": "Geben Sie einfach Prompts ein, um filmische Videos mit synchronisiertem Audio, professioneller Kameraarbeit und realistischer Bewegung zu erstellen. Wählen Sie aus Veo, Sora, Kling, Seedance und Wan-Modellen.",
          "cta": "Videoerstellung"
        },
        "imageToVideo": {
          "tag": "Bild zu Video",
          "title": "Bild zu Video",
          "desc": "Verwandeln Sie statische Bilder in filmische Videos. Egal ob Produktfotos, Illustrationen oder KI-generierte Bilder, bringen Sie sie mit natürlicher Bewegung und Voiceover zum Leben.",
          "cta": "Bildanimation"
        },
        "upscale": {
          "tag": "HD-Upscaling",
          "title": "HD-Upscaling",
          "desc": "Nutzen Sie KI zur Verbesserung der Bild- und Videoqualität. Unterstützt verlustfreies HD-Upscaling und Verbesserung der Videoauflösung auf 4K-Professionellebene.",
          "cta": "Jetzt Upscalen",
          "imageAlt": "Verbessern Sie Bild- und Videoqualität mit KI"
        },
        "templates": {
          "tag": "40+ Bildvorlagen",
          "title": "40+ Bildvorlagen",
          "desc": "Massive Vorlagen zur Inspiration: 3D-Modelle, Ghibli-Stil, Designer-Spielzeuge, Meme-Generator, Magazin-Cover und mehr — Laden Sie ein Foto hoch, sofortige Ergebnisse.",
          "cta": "Vorlagen durchsuchen",
          "imageAlt": "Bildvorlagenbeispiel"
        }
      }
    },
    "whyChoose": {
      "tag": "Warum Miral wählen",
      "title": "All-in-One-Kreation, alles was Sie brauchen",
      "subtitle": "One-Stop-Plattform, der die weltweit besten KI-Bild-, Video- und Musikerstellungsmodelle zusammenbringt.",
      "items": {
        "allModels": {
          "title": "Alle Modelle integriert, eines reicht",
          "desc": "One-Stop-Zugang zu 29+ Top-KI-Modellen von OpenAI, Google, Alibaba, ByteDance und mehr. Kein Wechsel zwischen Tools oder Verwaltung mehrerer Abonnements nötig."
        },
        "fast": {
          "title": "Blitzschnell",
          "desc": "Die meisten Bilderstellungen完成 innerhalb von 30 Sekunden, Videoerstellung dauert etwa 1-6 Minuten. Optimierte Infrastruktur sorgt für keine langen Wartezeiten."
        },
        "credits": {
          "title": "Einfaches Credit-System",
          "desc": "Pay as you go, transparente Preise. Starten Sie mit kostenlosen Credits — kein Abonnement needed, um mit der Kreation zu beginnen."
        },
        "api": {
          "title": "Entwickler-API",
          "desc": "Integrieren Sie KI-Bild-, Video- und Musikerstellung direkt in Ihre Anwendungen durch unsere umfassende API. Bauen Sie Ihr Produkt auf Top-KI-Modellen."
        }
      }
    },
    "testimonials": {
      "tag": "Nutzererfahrungen",
      "title": "Vertraut von Kreativen weltweit",
      "subtitle": "Schließen Sie sich Tausenden von Profis und Kreativen an, die Miral nutzen, um Bilder zu erstellen, Videos zu produzieren und ihre kreativen Workflows zu unterstützen."
    },
    "faq": {
      "tag": "Support",
      "title": "Häufig gestellte Fragen",
      "subtitle": "Ein umfassender Leitfaden zur Plattform, unterstützten Modellen, Preisplänen und Funktionen."
    },
    "cta": {
      "title": "Starten Sie jetzt Ihre KI-Kreationsreise",
      "subtitle": "Schließen Sie sich Tausenden von Kreativen, Designern und Unternehmen an, die Miral nutzen, um ihre Kreativität mit den weltweit besten KI-Modellen zu verwirklichen.",
      "createImage": "Bild erstellen →",
      "createVideo": "Video erstellen →",
      "note": "Neue Nutzer erhalten kostenlose Credits bei der Registrierung. Keine Kreditkarte erforderlich."
    },
    "gallery": {
      "tag": "Gallery",
      "title": "Explore Infinite Possibilities",
      "subtitle": "See what creators are building with Miral — from hyper-realistic images to cinematic videos, inspiration at your fingertips.",
      "images": {
        "alt1": "Midjourney generiertes Bildbeispiel",
        "alt2": "Seedream generiertes Bildbeispiel",
        "alt3": "GPT-Image-1 generiertes Bildbeispiel",
        "alt4": "Flux generiertes Bildbeispiel",
        "alt5": "Flux Pro generiertes Bildbeispiel",
        "alt6": "Midjourney generiertes Bildbeispiel",
        "alt7": "Seedream generiertes Bildbeispiel",
        "alt8": "GPT-Image-1 generiertes Bildbeispiel"
      }
    },
    "apps": {
      "title": "Apps",
      "quickTitle": "KI-Schnell-Apps",
      "more": "Mehr",
      "keywords": {
        "viralVideo": "Virales Kurzvideo",
        "tiktokAds": "TikTok-Anzeigen",
        "productShowcase": "Produkt-Showcase",
        "aiAvatar": "KI-Avatar",
        "homeModernKitchen": "Moderne Küche"
      },
      "social": "Soziale Medien",
      "posters": "Poster",
      "interior": "Zuhause",
      "entertainment": "Unterhaltung",
      "lifestyle": "Lebensstil",
      "comic": "Comic",
      "items": {
        "viralVideo": "Virale Videos",
        "celebrityVideo": "Promi-Video",
        "productShowcase": "Produktpräsentation",
        "tiktokAds": "TikTok-Werbung",
        "aiMeme": "KI-Meme",
        "aiAvatar": "KI-Avatar",
        "logoAnimation": "Logo-Animation",
        "socialShorts": "Social Shorts",
        "brandStory": "Markengeschichte",
        "tutorialClip": "Tutorial",
        "musicVideo": "KI-Musikvideo",
        "animeScene": "Anime-Szene",
        "movieTrailer": "Filmtrailer",
        "gameCinematic": "Spiel-Cinematic",
        "visualPoetry": "Visuelle Poesie",
        "natureDoc": "Naturdokumentation",
        "cyberpunkCity": "Cyberpunk-Stadt",
        "underwaterWorld": "Unterwasserwelt",
        "timelapseArt": "Zeitraffer-Kunst",
        "dailyVlog": "Tägliche Vlogs",
        "cookingShow": "Kochsendung",
        "fitnessCoach": "Fitness-Coach",
        "travelDiary": "Reisetagebuch",
        "fashionShow": "Modeschau",
        "petParadise": "Haustier-Paradies",
        "weddingMoment": "Hochzeitsmoment",
        "yogaFlow": "Yoga-Flow",
        "homeDecor": "Wohndeko",
        "sunsetRun": "Sonnenuntergang-Lauf",
        "instagramReels": "Instagram Reels",
        "youtubeIntro": "YouTube-Intro",
        "linkedinPromo": "LinkedIn-Promo",
        "aiThumbnail": "KI-Vorschaubild",
        "podcastClip": "Podcast-Clip",
        "horrorShort": "Horror-Kurzfilm",
        "danceVideo": "Tanzvideo",
        "aiComic": "KI-Comic",
        "magicShow": "Zaubershow",
        "fantasyWorld": "Fantasy-Welt",
        "diyCraft": "DIY-Basteln",
        "morningRoutine": "Morgenroutine",
        "babyGrowth": "Babywachstum",
        "streetFood": "Street-Food",
        "bookTrailer": "Buch-Trailer",
        "socialLuxuryBag": "Luxus-Taschen-Drop",
        "socialFashionVote": "Mode-Abstimmung",
        "socialSneakerDrop": "Urban Luxe Sneaker",
        "socialTropicalCocktail": "Wochenend-Cocktail",
        "socialCityBillboard": "City-Billboard-Werbung",
        "socialStreetwearDrop": "Streetwear-Drop",
        "socialBoxingGloves": "Boxhandschuh-Werbung",
        "homeEclecticLiving": "Eklektisches Wohnzimmer",
        "homeFarmhouseKitchen": "Bauernhaus-Küche",
        "homeModernKitchen": "Moderne Minimale Küche",
        "homeVictorianStairs": "Viktorianische Treppe",
        "homeScandiLiving": "Skandinavisches Wohnzimmer",
        "homeMediterraneanPatio": "Mediterrane Terrasse",
        "homeBohoSunroom": "Boho-Wintergarten",
        "homeEclecticBedroom": "Eklektisches Schlafzimmer",
        "comicPortrait": "Superhelden-Comic",
        "animeCharacter": "Mecha-Anime",
        "mangaScene": "Regennacht-Manga",
        "comicOilPainting": "Alltags-Comic",
        "comicCover": "Energie-Helden-Comic",
        "animePortrait": "Dachsprung-Comic",
        "comicCouple": "Junger-Held-Comic",
        "mangaWarrior": "Magier-Comic"
      }
    }
  },
  "tools": {
    "demoTitle": "Demo",
    "page": {
      "tag": "KI-Toolbox",
      "title": "Professionelle KI-Toolbox",
      "subtitle": "Wasserzeichenentfernung, Fotowiederherstellung, HD-Upscaling, Videoverbesserung und mehr professionelle Tools für alle Ihre Nachbearbeitungsbedürfnisse.",
      "allTools": "Alle Tools"
    },
    "detail": {
      "useNow": "Jetzt nutzen",
      "clickUpload": "Klicken oder ziehen zum Hochladen ",
      "support": "Unterstützt",
      "reupload": "Neu hochladen",
      "scale": "Skalieren",
      "process": "Verarbeiten",
      "processing": "Verarbeitung...",
      "before": "Vorher",
      "after": "Nachher",
      "download": "Ergebnis herunterladen",
      "processNew": "Neue Datei verarbeiten",
      "howToUse": "Anleitung",
      "moreTools": "Mehr Tools",
      "notFound": "Tool nicht gefunden",
      "backToList": "Zurück zu Tools",
      "loginRequired": "Anmeldung erforderlich",
      "loginRequiredDesc": "Bitte melden Sie sich an, um dieses Tool zu nutzen",
      "loginNow": "Jetzt anmelden",
      "demo": "Demo",
      "uploadOriginalFailed": "Upload des Originalbildes fehlgeschlagen, bitte versuchen Sie es erneut"
    },
    "steps": {
      "upload": {
        "title": "Datei hochladen",
        "desc": "Wählen Sie die Bild- oder Videodatei aus, die Sie verarbeiten möchten, oder ziehen Sie sie hierher."
      },
      "adjust": {
        "title": "Einstellungen anpassen",
        "desc": "Konfigurieren Sie Verarbeitungsparameter wie Skalierungsfaktor und Ausgabeformat."
      },
      "process": {
        "title": "Ein-Klick-Verarbeitung",
        "desc": "KI verarbeitet automatisch,通常 innerhalb von Sekunden bis Minuten abgeschlossen."
      },
      "download": {
        "title": "Ergebnis herunterladen",
        "desc": "Vorschau des Ergebnisses und Download der hochwertigen Ausgabe."
      }
    },
    "fileTypes": {
      "image": "Bild",
      "video": "Video"
    },
    "imageEnhancer": {
      "name": "Bildverbesserer",
      "desc": "Upscale-Bilder auf 4K-Auflösung mit verbesserten Details.",
      "fullDesc": "Upscale-Bilder auf 4K-Auflösung mit verbesserten Details. Nutzt fortschrittliche KI-Algorithmen zur Detailverbesserung, macht verschwommene Bilder scharf und klar."
    },
    "doc-crop-enhance": {
      "name": "Bild zuschneiden & entzerren",
      "desc": "Dokumentraender zuschneiden und Verzerrung mit KI korrigieren.",
      "fullDesc": "Bildzuschnitt, Entzerrung und Verbesserung. Randhintergrund entfernen, Verzerrung korrigieren und mit mehreren Modi verbessern einschließlich aufhellen, schärfen, schwarz-weiß, Graustufen und Schattenentfernung.",
      "enhanceMode": "Verbesserungsmodus",
      "enhanceModes": {
        "disabled": "Deaktiviert",
        "brighten": "Aufhellen",
        "sharpen": "Verbessern & Schärfen",
        "blackWhite": "Schwarz-Weiß",
        "grayscale": "Graustufen",
        "deshadow": "Schattenentfernung",
        "bitmap": "Bitmap"
      },
      "cropImage": "Ränder zuschneiden",
      "dewarpImage": "Entzerren",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB",
      "noImageInResponse": "Verarbeitung fehlgeschlagen, bitte versuchen Sie es erneut",
      "downloadName": "doc-crop-enhanced.png",
      "featuresKicker": "VERBESSERUNG DES DOKUMENTEN-SCANNENS",
      "featuresTitle": "Verwandeln Sie Dokumentenfotos in saubere, richtig ausgerichtete Scans",
      "featuresIntro": "Behandeln Sie Dokumentkanten, Schräglage, Perspektive, gekrümmte Seiten, Schatten und Textklarheit für allgemeine mobile Erfassungs- und Scanverbesserungsanforderungen.",
      "features": [
        {
          "title": "Dokumentkanten automatisch erkennen und zuschneiden",
          "desc": "Finden Sie die Grenze zwischen dem Papier und seinem Hintergrund und entfernen Sie dann Schreibtische, Kantenschatten und nicht zusammenhängende Bereiche, um eine sauberere Seite zu erhalten.",
          "cta": "Schneiden Sie ein Dokument kostenlos zu"
        },
        {
          "title": "Richten Sie verzerrte Dokumente gerade aus und korrigieren Sie die Perspektive",
          "desc": "Korrigieren Sie Trapezverzerrungen, schiefe Seiten und Proportionen, die durch verwinkelte Telefonfotos von Verträgen, Formularen und Testpapieren verursacht werden.",
          "cta": "Korrigieren Sie ein Dokumentenfoto"
        },
        {
          "title": "Entzerren Sie gebogene Seiten und gescannte Dokumente",
          "desc": "Korrigieren Sie Verzerrungen in der Nähe von Bucheinbänden, gewelltem Papier und gefalteten Seiten, um die Lesbarkeit von Lehrbüchern und Buchfotos zu verbessern.",
          "cta": "Entzerren Sie ein gebogenes Dokument"
        },
        {
          "title": "Entfernen Sie Schatten aus Dokumentenscans",
          "desc": "Reduzieren Sie Schatten durch Telefone, Finger, Buchrücken und ungleichmäßige Beleuchtung und sorgen Sie so für sauberere Belege, Arbeitsblätter und gescannte Seiten.",
          "cta": "Dokumentschatten entfernen"
        },
        {
          "title": "Erhellen Sie Dokumente und schärfen Sie Text",
          "desc": "Verbessern Sie die Helligkeit und die gedruckten Textkanten in kontrastarmen Dokumenten, um das Lesen, Drucken und Organisieren zu erleichtern.",
          "cta": "Gescannten Text schärfen"
        },
        {
          "title": "Erstellen Sie Schwarzweiß-, Graustufen- oder Bitmap-Scans",
          "desc": "Konvertieren Sie Farbdokumentfotos in Schwarzweiß-, Graustufen- oder Bitmap-Bilder zum Drucken und Archivieren.",
          "cta": "Verbessern Sie ein Dokumentbild"
        }
      ],
      "useCasesKicker": "HÄUFIGE ANWENDUNGSFÄLLE",
      "useCasesTitle": "Welche Dokumentbilder können zugeschnitten und verbessert werden?",
      "useCasesIntro": "Konzipiert für einzelne per Telefon oder Scanner erfasste Dokumentbilder mit ungleichmäßigen Rahmen, Schatten, Verzerrungen oder unklarem Text.",
      "useCases": [
        {
          "title": "Telefonfoto zum Scannen",
          "desc": "Entfernen Sie Schreibtischhintergründe und korrigieren Sie die Kamerawinkel, damit Telefonfotos eher wie Scans aussehen."
        },
        {
          "title": "Verträge und Formulare",
          "desc": "Beschneiden Sie Verträge, Anwendungen und Formulare, um saubere Kanten und Seitenproportionen wiederherzustellen."
        },
        {
          "title": "Quittungen und Rechnungen",
          "desc": "Reduzieren Sie Schatten und schärfen Sie schwach gedruckten Text für eine klarere Anzeige und Archivierung."
        },
        {
          "title": "Gebogene Buchseiten",
          "desc": "Korrekte Krümmung in der Nähe der Einbände von Lehrbüchern, Büchern und Arbeitsbüchern."
        },
        {
          "title": "Testpapiere und Arbeitsblätter",
          "desc": "Richten Sie Testpapiere gerade, entfernen Sie Schatten und schärfen Sie gedruckten Text zur Wiederverwendung oder zum Drucken."
        },
        {
          "title": "Schwarz-Weiß-Archive",
          "desc": "Konvertieren Sie Dokumentfotos in konsistente Schwarzweiß- oder Graustufen-Scanstile."
        }
      ],
      "faqTitle": "Häufig gestellte Fragen zum Zuschneiden und Korrigieren von AI-Dokumenten",
      "faqs": [
        {
          "q": "Was ist das Zuschneiden und Korrigieren von KI-Dokumenten?",
          "a": "Es erkennt den Dokumentbereich, entfernt den umgebenden Hintergrund und kann Schräglage, perspektivische oder gekrümmte Seitenverzerrungen basierend auf Ihren Einstellungen korrigieren."
        },
        {
          "q": "Wie schneide ich gescannte Dokumentbilder online automatisch zu?",
          "a": "Aktivieren Sie den Kantenzuschnitt und laden Sie dann das gescannte Dokumentbild hoch. Das Tool versucht, die Papiergrenze zu erkennen und den Bereich außerhalb des Dokuments zu entfernen."
        },
        {
          "q": "Kann ich ein gescanntes Dokument online korrigieren?",
          "a": "Ja. Verwenden Sie die Ausrichtung für einen geneigten Scan und die Perspektivkorrektur für ein schräges Telefonfoto. Verwenden Sie die Entzerrung nur, wenn die Seite selbst gekrümmt ist."
        },
        {
          "q": "Was ist der Unterschied zwischen den Modi „Schattieren entfernen“ und „Schärfen“?",
          "a": "Deshadow verbessert die ungleichmäßige Seitenbeleuchtung, während Sharpen Text- und Linienkanten verstärkt. Wählen Sie den Modus, der dem Quellproblem entspricht."
        },
        {
          "q": "Mit welchem ​​Tool kann ich gescannte Prüfungsunterlagen, Verträge und Quittungen aufwerten?",
          "a": "Verwenden Sie dieses Tool zum Zuschneiden und Verbessern von Dokumenten mit Schattenentfernung für ungleichmäßige Beleuchtung, Schärfen für blassen Text und Schwarzweiß oder Graustufen, wenn Sie Dokumente für den Druck vorbereiten."
        },
        {
          "q": "Kann es ein Telefonfoto in ein gescanntes Dokument umwandeln?",
          "a": "Durch Zuschneiden, Korrigieren und Verbessern kann ein scanähnliches Bild entstehen, das Tool generiert jedoch keine PDFs und extrahiert auch keinen OCR-Text."
        },
        {
          "q": "Welche Bildformate und Dateigrößen werden unterstützt?",
          "a": "Es werden JPG-, PNG- und WebP-Bilder mit einer maximalen Dateigröße von 15 MB unterstützt."
        },
        {
          "q": "Ändert die Verarbeitung den ursprünglichen Dokumentinhalt?",
          "a": "Das Tool passt Bildausschnitt, Geometrie, Helligkeit und Klarheit an. Es wird weder Text bearbeitet noch Dokumentinhalt extrahiert."
        }
      ],
      "education": {
        "kicker": "BILDUNGSDOKUMENTE",
        "title": "Verwandeln Sie Prüfungsunterlagen, Hausaufgaben und Lehrbuchfotos in klare Scans",
        "intro": "Erkennen Sie automatisch die Kanten von Bildungsdokumenten und korrigieren Sie Schräglage, Perspektive, gekrümmte Seiten und Schatten für saubereres Drucken, Archivieren und den Einsatz im Klassenzimmer.",
        "items": [
          {
            "title": "Fotos von Erntetestpapieren",
            "desc": "Erkennen Sie die Kanten des Testpapiers und entfernen Sie den Schreibtischhintergrund, um eine saubere, richtig gerahmte Seite zu erstellen."
          },
          {
            "title": "Korrekte Hausaufgabenbilder",
            "desc": "Korrigieren Sie Schräglage und Perspektive in Hausaufgabenfotos, damit diese einfacher überprüft, übermittelt und gedruckt werden können."
          },
          {
            "title": "Lehrbuchseiten entzerren",
            "desc": "Korrigieren Sie gebogene Seiten in der Nähe von Bucheinbänden und reduzieren Sie Schatten, die die Lesbarkeit gedruckter Inhalte erschweren."
          },
          {
            "title": "Arbeitsblätter im Klassenzimmer schärfen",
            "desc": "Erhellen und schärfen Sie Arbeitsblätter oder Lernmaterialien mit sauberen Schwarzweiß- oder Graustufen-Scaneffekten."
          }
        ],
        "relatedTitle": "Müssen Sie handschriftliche Antworten aus einer Prüfungsarbeit entfernen?",
        "relatedDesc": "Dieses Tool übernimmt das Zuschneiden, die geometrische Korrektur und die Bildverbesserung. Verwenden Sie den Handschriftradierer, um Schülerantworten, Berechnungen oder Lehreranmerkungen zu entfernen.",
        "relatedCta": "Öffnen Sie den Handschrift-Radiergummi"
      }
    },
    "watermark-remover": {
      "name": "Wasserzeichenentferner",
      "desc": "Wasserzeichen aus Bildern mit KI per Klick entfernen.",
      "fullDesc": "KI-gestützte Wasserzeichenentfernung unter Beibehaltung der Bildqualität. Unterstützt Batchverarbeitung, automatische Wasserzeichenerkennung und präzise Entfernung ohne Beschädigung des Originalbildes.",
      "audienceLabels": ["E-Commerce-Händler", "Marketingteams", "Designer und Kreative", "Mode- und Bekleidungsgeschäfte"],
      "audienceCases": [
        { "title": "Produktvisuals 3-mal schneller vorbereiten", "desc": "Bereinigen Sie vor der Erstellung hochwertiger Produktbilder autorisierte Produktfotos, Lieferantenbilder oder Entwürfe. Entfernen Sie störende Markierungen, damit Käufer sich auf das Produkt konzentrieren können." },
        { "title": "60 % weniger manuelle Bereinigung und schnellere Kampagnen", "desc": "Entfernen Sie unerwünschte Wasserzeichen, bevor Sie eigene oder lizenzierte Visuals in Anzeigen, Banner und Markengrafiken verwandeln. Saubere Assets lassen sich schneller für Kampagnen, Produkteinführungen und Produktposter einsetzen." },
        { "title": "Saubere Bilder schneller in neue Kreativkonzepte verwandeln", "desc": "Erkunden Sie neue Designrichtungen mit bereinigten Ausgangsbildern, ohne alles neu aufzubauen. Nutzen Sie wasserzeichenfreie Entwürfe als Referenz für KI-Skizzen, Concept Art oder posterartige Visuals." },
        { "title": "Katalogbilder ohne neues Fotoshooting auffrischen", "desc": "Bereinigen Sie vor Katalogaktualisierungen, saisonalen Einführungen oder KI-Anprobe-Visuals autorisierte Modefotos, damit Passform, Stoff und Produktdetails im Mittelpunkt stehen." }
      ],
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "watermark-removed.png",
      "aiRepair": "Wasserzeichenentfernung",
      "uploadLabel": "Bild hochladen",
      "uploadHint": "Unterstützt JPG-, PNG- oder WebP-Bilder bis zu 15 MB.",
      "featuresKicker": "Schnell und genau",
      "featuresTitle": "Entfernen Sie verschiedene Wasserzeichen aus Fotos online",
      "featuresIntro": "Laden Sie ein JPG-, PNG- oder WebP-Bild hoch und lassen Sie die KI Wasserzeichenbereiche erkennen und den Hintergrund ohne manuelles Bürsten rekonstruieren.",
      "features": [
        {
          "title": "Vollbild-Wasserzeichen löschen",
          "desc": "Entfernen Sie wiederholt durchscheinende Text- oder Musterwasserzeichen, die das gesamte Bild bedecken, um ein saubereres Ergebnis zu erzielen.",
          "cta": "Probieren Sie AI Watermark Remover kostenlos aus"
        },
        {
          "title": "Entfernen Sie Zeitstempel und Datumsmarkierungen",
          "desc": "Entfernen Sie Datumsangaben, Zeitstempel und Kameramarkierungen aus Fotoecken und rekonstruieren Sie gleichzeitig den Hintergrund dahinter.",
          "cta": "Bildwasserzeichen online löschen"
        },
        {
          "title": "Markenlogos löschen",
          "desc": "Entfernen Sie Markenlogos, Eckabzeichen und Werbezeichen von Bildern, für deren Bearbeitung Sie berechtigt sind.",
          "cta": "Entfernen Sie jetzt Fotowasserzeichen"
        },
        {
          "title": "Bereinigen Sie Text- und Entwurfsmarken",
          "desc": "Entfernen Sie Textüberlagerungen aus Vorschauen, Designentwürfen und Fotos, um klarere visuelle Inhalte zu erstellen.",
          "cta": "Probieren Sie jetzt den Wasserzeichen-Entferner aus"
        }
      ],
      "useCasesKicker": "Anwendungsfälle",
      "useCasesTitle": "Was kann der AI Image Watermark Remover reinigen?",
      "useCases": [
        {
          "title": "Wasserzeichenentfernung für Produktfotos",
          "desc": "Entfernen Sie Text, Logos und Werbezeichen von Produktfotos, bevor Sie sie an Ihre eigenen Assets weitergeben."
        },
        {
          "title": "Wasserzeichenentfernung für soziale Fotos",
          "desc": "Entfernen Sie Plattformmarkierungen oder Zeitstempel von Ihren eigenen Fotos, um eine sauberere Veröffentlichungsversion zu erhalten."
        },
        {
          "title": "Bereinigen Sie mehrere Wasserzeichen",
          "desc": "Wenn ein Bild mehrere Wasserzeichen enthält, kann die KI mehrere abgedeckte Bereiche erkennen und bereinigen."
        }
      ],
      "howToKicker": "Drei einfache Schritte",
      "howToTitle": "So entfernen Sie kostenlos Wasserzeichen aus Bildern online",
      "howToIntro": "Es ist keine Softwareinstallation erforderlich. Laden Sie ein Bild hoch, führen Sie den AI-Wasserzeichen-Entferner aus und laden Sie das bereinigte Ergebnis herunter.",
      "howToCta": "Wasserzeichen jetzt online entfernen",
      "steps": {
        "upload": {
          "title": "Laden Sie ein mit Wasserzeichen versehenes Bild hoch",
          "desc": "Wählen Sie ein JPG-, PNG- oder WebP-Bild mit weniger als 15 MB. Stellen Sie sicher, dass Sie das Recht haben, es zu bearbeiten und zu verwenden."
        },
        "remove": {
          "title": "Entfernen Sie das Wasserzeichen mit KI",
          "desc": "Beginnen Sie mit der Verarbeitung und die KI erkennt Logos, Text, Zeitstempel oder Vollbild-Wasserzeichen und rekonstruiert den Hintergrund."
        },
        "download": {
          "title": "Vorschau und Download",
          "desc": "Vergleichen Sie die Vorher- und Nachher-Ergebnisse und laden Sie dann das bereinigte Bild herunter oder laden Sie ein anderes hoch."
        }
      },
      "faqTitle": "Häufig gestellte Fragen zum AI-Wasserzeichen-Entferner",
      "faqs": [
        {
          "q": "Was ist ein KI-Wasserzeichenentferner?",
          "a": "Ein KI-Wasserzeichenentferner erkennt Wasserzeichenbereiche und rekonstruiert abgedeckte Hintergründe anhand benachbarter Farben, Texturen und Bildinhalte."
        },
        {
          "q": "Wie entferne ich kostenlos Wasserzeichen von Fotos online?",
          "a": "Melden Sie sich an, laden Sie ein Bild zum Miral AI-Wasserzeichenentferner hoch und beginnen Sie mit der Verarbeitung, um eine Vorschau des bereinigten Ergebnisses anzuzeigen."
        },
        {
          "q": "Welche Bildformate werden unterstützt?",
          "a": "Das Tool unterstützt derzeit JPG-, PNG- und WebP-Bilder unter 15 MB. Diese Seite entfernt keine Wasserzeichen aus Videos."
        },
        {
          "q": "Kann es Vollbild-Wasserzeichen, Logos und Zeitstempel entfernen?",
          "a": "Ja. KI kann wiederholte Vollbild-Wasserzeichen, Markenlogos, Datumsstempel, Text und Entwurfsmarken verarbeiten. Die Ergebnisse hängen von der Deckkraft, der abgedeckten Fläche und der Hintergrundkomplexität ab."
        },
        {
          "q": "Mit welchem Tool kann ich mehrere Logos oder Zeitstempel von einem Foto entfernen?",
          "a": "Der Miral AI-Wasserzeichenentferner kann mehrere Wasserzeichenbereiche verarbeiten, einschließlich Logos und Zeitstempel. Überprüfen Sie die Vorschau, wenn große Markierungen Personen oder komplexe Texturen verdecken."
        },
        {
          "q": "Ist das Entfernen eines Wasserzeichens aus einem Bild legal?",
          "a": "Verarbeiten Sie nur Bilder, deren Eigentümer Sie sind, zu deren Bearbeitung Sie berechtigt sind oder die Sie rechtmäßig verwenden dürfen. Das Entfernen von Urheberrechtswasserzeichen ohne Genehmigung kann die Rechte des Eigentümers verletzen."
        },
        {
          "q": "Wie kann man verschwommene Bereiche nach dem Entfernen eines Wasserzeichens beheben?",
          "a": "Beginnen Sie mit dem qualitativ hochwertigsten verfügbaren Quellbild und prüfen Sie vor dem Herunterladen die Vorschau. Die KI versucht, die ursprüngliche Komposition, Auflösung und Details beizubehalten, aber durch große Wasserzeichen verdeckte Inhalte müssen rekonstruiert werden, sodass lokale Ergebnisse vom Original abweichen können."
        }
      ]
    },
    "full-watermark-remover": {
      "name": "KI-Wasserzeichenentferner",
      "desc": "Entfernen Sie Wasserzeichen aus Bildern mit KI.",
      "fullDesc": "Erkennen und entfernen Sie Wasserzeichen aus Bildern mit KI und bewahren Sie dabei Bildinhalt, Details und Qualität.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "vollbild-wasserzeichen-entfernt.png"
    },
    "ai-text-remover": {
      "name": "KI-Textentferner",
      "desc": "Entfernen Sie unerwünschten Text aus Bildern mit KI.",
      "fullDesc": "Entfernen Sie unerwünschten Text aus Bildern mit KI und bewahren Sie Hintergrund, Textur und natürliche Details.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "text-entfernt.png"
    },
    "ai-logo-remover": {
      "name": "KI-Logoentferner",
      "desc": "Entfernen Sie unerwünschte Logos aus Bildern mit KI.",
      "fullDesc": "Entfernen Sie unerwünschte Logos aus Bildern mit KI und bewahren Sie Hintergrund, Textur und natürliche Details.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "logo-entfernt.png"
    },
    "ai-passersby-remover": {
      "name": "KI-Passantenentferner",
      "desc": "Entfernen Sie Passanten aus Bildern mit KI.",
      "fullDesc": "Erkennen und entfernen Sie Passanten aus Bildern mit KI und bewahren Sie Motiv, Hintergrundstruktur und natürliche Bilddetails.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "passanten-entfernt.png"
    },
    "background-remover": {
      "name": "Hintergrundentferner",
      "desc": "Bildhintergrund mit KI per Klick entfernen.",
      "heroTitle": "Kostenloser KI-Hintergrundentferner für transparente PNGs",
      "fullDesc": "Laden Sie ein JPG-, PNG- oder WebP-Bild hoch. Die KI erkennt Porträts, Produkte und Kanten, bewahrt feine Details wie Haare und erstellt ohne Photoshop ein transparentes PNG.",
      "uploadLabel": "Bild zum Freistellen hochladen",
      "uploadHint": "Bild anklicken oder hierher ziehen",
      "uploadSpec": "JPG, PNG oder WebP bis 15MB. Das Ergebnis wird als transparentes PNG heruntergeladen.",
      "processButton": "Bildhintergrund entfernen",
      "previewAlt": "Bildvorschau vor der KI-Hintergrundentfernung",
      "demoBeforeAlt": "Porträt vor der Hintergrundentfernung",
      "demoAfterAlt": "Porträt nach der KI-Hintergrundentfernung",
      "processingAlt": "KI entfernt den Bildhintergrund",
      "processingLabel": "Freistellung läuft",
      "resultLabel": "Transparenter Hintergrund fertig",
      "resultBeforeAlt": "Originalbild vor der Hintergrundentfernung",
      "resultAfterAlt": "Transparentes PNG nach KI-Hintergrundentfernung",
      "productBeforeAlt": "Produktfotografie vor der Hintergrundentfernung",
      "productAfterAlt": "Freigestelltes Produkt auf transparentem Hintergrund",
      "featuresKicker": "Präzise Motiverkennung",
      "featuresTitle": "KI-Hintergrundentferner für Porträts und Produktfotos",
      "featuresIntro": "Von komplexen Porträtkanten bis zu E-Commerce-Produkten trennt die KI Motiv und Hintergrund ohne Pinsel, Pfade oder manuelle Masken.",
      "features": [
        { "title": "Porträthintergrund entfernen und Haare bewahren", "desc": "Erkennt Personen, Kleidung und feine Haarsträhnen für Profilbilder, Bewerbungsfotos, Poster und Social-Media-Grafiken.", "cta": "Porträthintergrund kostenlos entfernen" },
        { "title": "Produktfotos mit einem Klick freistellen", "desc": "Entfernt Tisch, Wand und Studioszene für transparente Produktmotive in weißen Hintergründen, Shops und Anzeigen.", "cta": "Produktfotohintergrund entfernen" },
        { "title": "Transparentes PNG herunterladen", "desc": "Bewahrt Transparenz für neue Hintergründe, Banner, Präsentationen, Thumbnails und Grafikdesigns.", "cta": "Bildhintergrund transparent machen" }
      ],
      "featureAlts": { "portraitBefore": "Porträt vor dem Freistellen", "portraitAfter": "Freigestelltes Porträt mit erhaltenen Haaren", "productBefore": "Produkt vor der Hintergrundentfernung", "productAfter": "Produkt auf transparentem Hintergrund", "ecommerceBefore": "E-Commerce-Bild vor dem Freistellen", "ecommerceAfter": "Transparentes PNG für E-Commerce" },
      "useCasesKicker": "Beliebte Anwendungen",
      "useCasesTitle": "Welche Bilder eignen sich für KI-Freistellung?",
      "useCasesIntro": "Ideal, wenn Sie ein Motiv schnell isolieren oder ein transparentes Asset für kreative und kommerzielle Projekte benötigen.",
      "useCases": [
        { "title": "E-Commerce-Produktfotos", "desc": "Erstellen Sie transparente Produktmotive für Kataloge, Shops und Kampagnen." },
        { "title": "Porträts und Profilbilder", "desc": "Entfernen Sie die Umgebung und bewahren Sie Haare, Kleidung und Konturen." },
        { "title": "Social-Media-Grafiken", "desc": "Platzieren Sie Personen oder Produkte in Posts, Covern und Thumbnails." },
        { "title": "Bewerbungs- und Passfoto-Vorbereitung", "desc": "Stellen Sie die Person frei und fügen Sie die benötigte Hintergrundfarbe hinzu." },
        { "title": "Logos und Grafikelemente", "desc": "Entfernen Sie unerwünschte Flächen vor der Wiederverwendung." },
        { "title": "Werbung und Grafikdesign", "desc": "Erstellen Sie flexible transparente PNGs ohne wiederholte Handarbeit." }
      ],
      "howToKicker": "Drei einfache Schritte",
      "howToTitle": "Bildhintergrund kostenlos online entfernen",
      "howToIntro": "Bild hochladen, automatische KI-Freistellung starten und transparentes PNG herunterladen.",
      "steps": [
        { "title": "JPG, PNG oder WebP hochladen", "desc": "Wählen Sie ein klares Porträt, Produkt oder Design unter 15MB." },
        { "title": "Hintergrund mit KI entfernen", "desc": "Die KI trennt das Motiv und bewahrt wichtige Kanten." },
        { "title": "PNG prüfen und herunterladen", "desc": "Vergleichen Sie das Ergebnis und speichern Sie das transparente Bild." }
      ],
      "faqTitle": "FAQ zum KI-Hintergrundentferner",
      "faqs": [
        { "q": "Wie entferne ich einen Bildhintergrund kostenlos online?", "a": "Laden Sie JPG, PNG oder WebP hoch und starten Sie die Entfernung. Die KI erkennt das Motiv und erzeugt ein transparentes PNG." },
        { "q": "Kann die KI Haare und feine Kanten bewahren?", "a": "Das Werkzeug versucht Haare, Kleidung und kleine Details zu erhalten. Ein deutlicher Kontrast verbessert meist das Ergebnis." },
        { "q": "Kann ich den Hintergrund eines Produktfotos entfernen?", "a": "Ja. Klar sichtbare Produkte eignen sich für transparente E-Commerce- und Werbemotive." },
        { "q": "Welches Dateiformat erhalte ich?", "a": "Das Ergebnis wird als PNG mit Transparenz heruntergeladen." },
        { "q": "Welche Formate und Größen werden unterstützt?", "a": "JPG, PNG und WebP bis 15MB werden unterstützt." },
        { "q": "Muss ich Photoshop installieren?", "a": "Nein. Die KI entfernt den Hintergrund direkt im Browser." }
      ],
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "background-removed.png"
    },
    "image-eraser": {
      "name": "Bildradierer",
      "desc": "Jedes Objekt, jede Person oder Wasserzeichen mit KI aus Bildern entfernen.",
      "fullDesc": "KI-gestützter Bildradierer. Malen Sie über ein unerwünschtes Objekt, eine Person, ein Wasserzeichen oder Text in Ihrem Foto, und die KI entfernt es nahtlos und füllt den Bereich mit natürlichem Inhalt. Perfekt zum Bereinigen von Fotos und Entfernen von störenden Elementen.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "image-erased.png"
    },
    "object-remover": {
      "name": "Objekt-Entferner",
      "desc": "Entfernen Sie unerwünschte Objekte mit KI aus Ihren Fotos.",
      "fullDesc": "KI-gestützter Objekt-Entferner. Malen Sie über ein unerwünschtes Objekt in Ihrem Foto, und die KI entfernt es nahtlos und füllt den Bereich mit natürlichem Inhalt. Perfekt zum Bereinigen von Fotos und Entfernen von störenden Elementen.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "object-removed.png",
      "uploadLabel": "Bild hochladen",
      "uploadHint": "Klicken oder ziehen Sie, um ein Bild hochzuladen",
      "uploadSpec": "Unterstützt JPG-, PNG- oder WebP-Bilder.",
      "maskHint": "Streichen Sie über jeden Teil des Objekts, den die KI entfernen soll.",
      "processButton": "Objekt entfernen",
      "demoBeforeAlt": "Foto vor der Entfernung unerwünschter Objekte",
      "demoAfterAlt": "Foto nach Entfernung unerwünschter Objekte",
      "processingAlt": "KI verarbeitet das markierte Foto",
      "resultBeforeAlt": "Originalfoto vor Objektentfernung",
      "resultAfterAlt": "Reinigen Sie das Foto nach der Entfernung des Objekts",
      "featureImageLabels": {
        "object": "Beispiel für die Entfernung unerwünschter Objekte",
        "person": "Beispiel für die Entfernung von Personen",
        "distraction": "Beispiel für die Entfernung von Hintergrundablenkungen"
      },
      "featuresKicker": "Präzise Fotobereinigung",
      "featuresTitle": "Entfernen Sie unerwünschte Objekte aus Fotos online",
      "featuresIntro": "Markieren Sie genau den Bereich, den Sie reinigen möchten, und nutzen Sie die KI-Objektentfernung für alltägliche Fotoablenkungen, ohne den Hintergrund manuell neu erstellen zu müssen.",
      "features": [
        {
          "title": "Entfernen Sie unerwünschte Gegenstände",
          "desc": "Verwenden Sie einen verstellbaren Pinsel, um Unordnung, Schilder, Requisiten oder andere Objekte zu markieren. AI entfernt den ausgewählten Bereich und füllt ihn mit umgebenden Bilddetails.",
          "cta": "Objekte kostenlos entfernen"
        },
        {
          "title": "Entfernen Sie Personen aus Fotohintergründen",
          "desc": "Entfernen Sie Fotobomber, Touristen oder Passanten aus Reiseaufnahmen und Porträts, wenn diese vom Hauptmotiv ablenken.",
          "cta": "Saubere Fotohintergründe kostenlos"
        },
        {
          "title": "Löschen Sie kleine Hintergrundablenkungen",
          "desc": "Entfernen Sie Kabel, Mülleimer, Straßenmüll, Markierungen oder einzelne visuelle Ablenkungen, um eine klarere Komposition zu schaffen.",
          "cta": "Löschen Sie Fotoablenkungen kostenlos"
        }
      ],
      "useCasesKicker": "Beliebte Anwendungsfälle",
      "useCasesTitle": "Was können Sie mit dem AI Object Remover entfernen?",
      "useCasesIntro": "Entwickelt für gezielte Bearbeitungen, bei denen Sie den unerwünschten Bereich klar überstreichen und den Rest des Fotos unverändert lassen können.",
      "useCases": [
        {
          "title": "Bereinigung von Reisefotos",
          "desc": "Entfernen Sie Passanten, Schilder, Mülleimer oder Straßenmüll aus Urlaubsfotos."
        },
        {
          "title": "Bereinigung von Produktfotos",
          "desc": "Entfernen Sie Requisiten, Etiketten, Kabel und störende Gegenstände rund um ein Produkt."
        },
        {
          "title": "Porträt-Hintergrundbereinigung",
          "desc": "Entfernen Sie Personen im Hintergrund und kleine Objekte, die die Aufmerksamkeit vom Motiv ablenken."
        },
        {
          "title": "Immobilienfotos",
          "desc": "Entfernen Sie temporäre Unordnung und isolierte Objekte aus Raum- oder Grundstücksbildern."
        },
        {
          "title": "Social-Media-Bilder",
          "desc": "Polieren Sie Fotos vor dem Posten, indem Sie sichtbare Störfaktoren aus dem Rahmen entfernen."
        },
        {
          "title": "Kreative Fotobearbeitung",
          "desc": "Löschen Sie ausgewählte Bereiche, bevor Sie ein Bild in einem Layout oder visuellen Projekt wiederverwenden."
        }
      ],
      "howToKicker": "Drei einfache Schritte",
      "howToTitle": "So entfernen Sie online ein Objekt aus einem Foto",
      "howToIntro": "Laden Sie ein Foto hoch, streichen Sie über das unerwünschte Objekt und laden Sie das KI-bereinigte Ergebnis herunter.",
      "steps": [
        {
          "title": "Laden Sie Ihr Foto hoch",
          "desc": "Wählen Sie das Bild aus, das die Person, den Gegenstand oder die Ablenkung enthält, die Sie löschen möchten."
        },
        {
          "title": "Streichen Sie über das Objekt",
          "desc": "Passen Sie den Pinsel an und decken Sie den gesamten unerwünschten Bereich ab. Verwenden Sie „Rückgängig“ oder den Radiergummi, um die Maske zu verfeinern."
        },
        {
          "title": "Entfernen und herunterladen",
          "desc": "Starten Sie die KI-Verarbeitung, vergleichen Sie die Vorher- und Nachher-Bilder und laden Sie dann das bereinigte Foto herunter."
        }
      ],
      "faqTitle": "Häufig gestellte Fragen zum AI Object Remover",
      "faqs": [
        {
          "q": "Wie entferne ich unerwünschte Objekte online aus Fotos?",
          "a": "Laden Sie ein Foto hoch, streichen Sie über das gesamte unerwünschte Objekt und beginnen Sie mit der Verarbeitung. KI rekonstruiert den ausgewählten Bereich anhand von Farben, Texturen und Szenendetails in der Nähe."
        },
        {
          "q": "Mit welchem Tool kann ich eine Person aus einem Fotohintergrund entfernen?",
          "a": "Verwenden Sie den Pinsel, um die Person abzudecken und Details wie Schatten oder getragene Gegenstände hinzuzufügen. Die Ergebnisse sind normalerweise besser, wenn der umgebende Hintergrund sichtbar ist."
        },
        {
          "q": "Kann KI Schilder, Drähte, Mülleimer und Straßenmüll beseitigen?",
          "a": "Ja. Markieren Sie den unerwünschten Bereich deutlich und vermeiden Sie es, Objekte in der Nähe abzudecken, die Sie behalten möchten. Kleine, isolierte Ablenkungen lassen sich im Allgemeinen leichter rekonstruieren."
        },
        {
          "q": "Wie kann ich ein natürlicheres Ergebnis beim Entfernen von Objekten erzielen?",
          "a": "Verwenden Sie ein klares, qualitativ hochwertiges Quellbild und streichen Sie leicht über die Objektkanten hinaus. Bearbeiten Sie schwierige Bereiche separat, wenn sich mehrere Objekte überlappen."
        },
        {
          "q": "Verändert der Objektentferner das gesamte Foto?",
          "a": "Der Entfernungsantrag basiert auf der gebürsteten Maske. Das Tool konzentriert sich auf den ausgewählten Bereich, obwohl die KI die Pixel an seinen Rändern rekonstruieren muss."
        },
        {
          "q": "Welche Bildformate kann ich hochladen?",
          "a": "Die Upload-Steuerung akzeptiert gängige Bildformate, einschließlich JPG, PNG und WebP."
        }
      ]
    },
    "ai-person-remover": {
      "name": "KI-Personen-Entferner",
      "desc": "Entfernen Sie Personen mit KI aus Ihren Fotos.",
      "fullDesc": "KI-gestützter Personen-Entferner. Malen Sie über eine beliebige Person in Ihrem Foto, und die KI entfernt sie nahtlos und füllt den Bereich mit natürlichem Inhalt. Perfekt zum Entfernen von Passanten, Touristen oder Fremden aus Ihren Aufnahmen.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "person-removed.png"
    },
    "background-blur": {
      "name": "Hintergrundunschärfe",
      "desc": "Mit KI per Klick den Hintergrund weichzeichnen und das Motiv hervorheben",
      "fullDesc": "Die KI erkennt automatisch das Vordergrundmotiv (Person/Objekt), hält das Motiv scharf und wendet eine Gaußsche Unschärfe auf den Hintergrund an – für einen Effekt wie im Porträtmodus. Ideal für Porträts und Produktdetails.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "hintergrundunschaerfe.png"
    },
    "white-background": {
      "name": "Weißer Hintergrund",
      "desc": "Hintergrund durch Weiß ersetzen mit KI.",
      "fullDesc": "KI-gestütztes Ersetzen des Hintergrunds durch Weiß mit einem Klick. Erkennt präzise die Motivkontur, bewahrt feine Details wie Haare, gibt Bild mit reinweißem Hintergrund aus. Ideal für Produktfotos und Ausweisfotos.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "weisser-hintergrund.png"
    },
    "blue-background": {
      "name": "Blauer Hintergrund",
      "desc": "Hintergrund durch Blau ersetzen mit KI.",
      "fullDesc": "KI-gestütztes Ersetzen des Hintergrunds durch Blau mit einem Klick. Erkennt präzise die Motivkontur, bewahrt feine Details wie Haare, gibt Bild mit reinblauem Hintergrund aus. Ideal für Ausweisfotos und Passfotos.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "noImageInResponse": "Kein Ergebnisbild zurückgegeben. Bitte versuchen Sie es später erneut.",
      "downloadName": "blauer-hintergrund.png"
    },
    "face-swap": {
      "name": "Foto-Gesichtstausch",
      "desc": "Tauschen Sie Gesichter auf Fotos mit KI per Klick.",
      "fullDesc": "KI-gestützter Gesichtstausch. Laden Sie ein Zielfoto und ein Quellgesichtsfoto hoch, um das Gesicht nahtlos in das Zielbild einzufügen. Unterstützt Mehrpersonenszenen mit realistischen Ergebnissen.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "targetImage": "Zielfoto",
      "sourceImage": "Quellgesicht",
      "effectImageLabel": "Ergebnis",
      "downloadName": "gesichtstausch-ergebnis.png",
      "step1Title": "Fotos hochladen",
      "step1Desc": "Laden Sie Zielfoto und Quellgesichtsfoto hoch",
      "step2Title": "KI-Gesichtstausch",
      "step2Desc": "Klicken Sie auf verarbeiten, die KI tauscht das Gesicht automatisch",
      "step3Title": "Herunterladen",
      "step3Desc": "Vorschau und Download des Ergebnisses",
      "processButton": "Gesicht tauschen",
      "targetPreviewAlt": "Zielfotovorschau für KI-Gesichtstausch",
      "sourcePreviewAlt": "Vorschau des Quellgesichts für den AI-Gesichtsaustausch",
      "processingAlt": "Vorschau der AI-Face-Swap-Verarbeitung",
      "resultBeforeAlt": "Zielfoto vor dem Gesichtsaustausch",
      "resultAfterAlt": "Foto nach KI-Gesichtstausch",
      "featuresKicker": "Natürlicher Gesichtsersatz",
      "featuresTitle": "Tauschen Sie Gesichter zwischen Fotos mit KI aus",
      "featuresIntro": "Verwenden Sie ein Zielfoto für die Pose und Komposition und geben Sie dann ein klares Quellgesicht für einen fokussierten Foto-Gesichtsaustausch an.",
      "features": [
        {
          "title": "Erstellen Sie einen natürlich aussehenden Face Swap",
          "desc": "Die KI verschmilzt die Identität der Quelle mit dem Zielfoto und folgt dabei dessen Pose, Rahmen, Beleuchtung und dem gesamten visuellen Stil.",
          "cta": "Erstellen Sie kostenlos ein Foto-Gesichtstausch"
        },
        {
          "title": "Behalten Sie die gewünschte Fotokomposition bei",
          "desc": "Verwenden Sie ein Porträt, ein Selfie, ein Charakterbild oder eine kreative Szene als Ziel und behalten Sie dabei den Hintergrund und die Komposition bei.",
          "cta": "Probieren Sie Photo Face Swap kostenlos aus"
        },
        {
          "title": "Verwenden Sie ein klares Quellgesicht",
          "desc": "Laden Sie ein nach vorne gerichtetes, gut beleuchtetes Quellbild mit sichtbaren Gesichtsdetails hoch, um dem Modell bei der Erstellung eines konsistenteren Ersatzes zu helfen.",
          "cta": "Kostenlos hochladen und austauschen"
        }
      ],
      "useCasesKicker": "Kreative Fotoideen",
      "useCasesTitle": "Beliebte Anwendungen für den Online-Foto-Gesichtstausch",
      "useCasesIntro": "Erstellen Sie spielerische und kreative Fotobearbeitungen mit einem Zielbild und einem Quellgesichtsbild.",
      "useCases": [
        {
          "title": "Selfie- und Profilfoto-Gesichtstausch",
          "desc": "Ersetzen Sie ein Gesicht in einem Selfie oder Porträt und behalten Sie dabei die Zielpose, den Hintergrund und den Bildausschnitt bei. Entdecken Sie Profilbildkonzepte und persönliche Porträtideen mit einem klaren Gesichtsausdruck.",
          "cta": "Erstellen Sie kostenlos ein Portrait-Gesichtstausch",
          "imageAlt": "Beispiel für einen KI-Gesichtsaustausch für Selfies und Profilfotos"
        },
        {
          "title": "Memes und soziale Reaktionsbilder",
          "desc": "Verwandeln Sie bekannte Fotos in personalisierte Memes, verspielte Reaktionsbilder und teilbare soziale Inhalte. Ein klarer Zielausdruck trägt dazu bei, dass das endgültige Bild leicht erkennbar bleibt.",
          "cta": "Machen Sie einen Meme Face Swap kostenlos",
          "imageAlt": "Anwendungsfall für kreative Memes und soziale Reaktionsbilder"
        },
        {
          "title": "Cosplay, Charaktere und kreative Geschichten",
          "desc": "Probieren Sie ein Gesicht in einem Kostüm, einem Fantasy-Porträt, einer illustrierten Figur oder einer thematischen Szene aus. Verwenden Sie den Gesichtsaustausch, um Charakterkonzepte zu erkunden und visuelle Geschichten aus Bildern zu erstellen, die Sie möglicherweise bearbeiten.",
          "cta": "Probieren Sie einen kostenlosen Charakter-Gesichtstausch aus",
          "imageAlt": "Anwendungsfall für Cosplay und Charakter-Gesichtstausch"
        }
      ],
      "howToKicker": "Drei einfache Schritte",
      "howToTitle": "So tauschen Sie Gesichter in Fotos online mit KI aus",
      "howToIntro": "Wählen Sie ein Zielfoto, fügen Sie ein klares Quellgesicht hinzu und lassen Sie die KI das Ergebnis mit dem Gesichtsaustausch generieren.",
      "faqTitle": "Häufig gestellte Fragen zum Foto-Gesichtstausch",
      "faqs": [
        {
          "q": "Wie tausche ich online ein Gesicht zwischen zwei Fotos aus?",
          "a": "Laden Sie das Foto, dessen Pose und Komposition Sie beibehalten möchten, als Ziel hoch, laden Sie dann die Identität hoch, die Sie als Quellgesicht verwenden möchten, und beginnen Sie mit der Verarbeitung."
        },
        {
          "q": "Was ist der Unterschied zwischen dem Zielfoto und dem Quellgesicht?",
          "a": "Das Zielfoto liefert Pose, Hintergrund und Komposition. Das Quellgesicht liefert die Gesichtsidentität, die für den Ersatz verwendet wird."
        },
        {
          "q": "Wie wähle ich ein gutes Quellbild für den Gesichtsaustausch aus?",
          "a": "Verwenden Sie ein klares, gut beleuchtetes Bild mit einem freien Gesicht. Ein Quellwinkel und ein Ausdruck ähnlich dem Ziel können zu einem konsistenteren Ergebnis führen."
        },
        {
          "q": "Kann ich AI Face Swap für Selfies, Memes oder Cosplay-Fotos verwenden?",
          "a": "Ja. Hierbei handelt es sich um häufige kreative Verwendungszwecke, wenn Sie Eigentümer der hochgeladenen Bilder sind oder über die Berechtigung zum Bearbeiten verfügen."
        },
        {
          "q": "Warum sieht ein Gesichtstausch manchmal weniger realistisch aus?",
          "a": "Große Unterschiede im Gesichtswinkel, in der Beleuchtung, im Ausdruck, in der Auflösung oder bei starker Verdeckung können die Überblendung erschweren. Probieren Sie klarere und kompatiblere Quellfotos aus."
        },
        {
          "q": "Welche Bildformate und Dateigrößen werden unterstützt?",
          "a": "Es werden JPG-, PNG- und WebP-Bilder mit einer maximalen Dateigröße von 15 MB pro Bild unterstützt."
        },
        {
          "q": "Kann ich auf dieser Seite ein Gesicht in einem Video austauschen?",
          "a": "Nein. Diese Seite verarbeitet Standbilder und gibt ein Bildergebnis zurück."
        }
      ]
    },
    "image-enhancer": {
      "name": "Bildverbesserer",
      "desc": "Bildschaerfe mit KI per Klick verbessern.",
      "fullDesc": "Upscale-Bilder auf 4K-Auflösung mit verbesserten Details. Nutzt fortschrittliche KI-Algorithmen zur Detailverbesserung, macht verschwommene Bilder scharf und klar.",
      "fileTooLarge": "Bild ist zu groß. Bitte verwenden Sie eine Datei unter 15MB (JPG, PNG oder WebP).",
      "notImageFile": "Bitte laden Sie eine Bilddatei hoch.",
      "downloadName": "image-enhanced.png",
      "targetResolution": "Zielauflösung",
      "outputFormat": "Ausgabeformat",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "Verarbeitung fehlgeschlagen. Versuchen Sie ein anderes Bild oder Ausgabeformat."
    },
    "video-enhancer": {
      "name": "Video-Verbesserer",
      "desc": "Verbessert die Videoqualität mit KI-Upscaling.",
      "fullDesc": "Verbessert Videos auf HD/4K mit KI-Frame-Interpolation und Schärfung.",
      "notVideoFile": "Bitte laden Sie eine Videodatei hoch (z. B. MP4, MOV, AVI).",
      "fileTooLarge": "Video ist zu groß. Bitte verwenden Sie eine Datei unter 100MB."
    },
    "cartoon-video-style-converter": {
      "name": "Cartoon-Stil-Konverter",
      "desc": "Videos in Cartoon-Stil umwandeln",
      "fullDesc": "Laden Sie ein Video hoch und die KI wandelt es in einen Cartoon-Stil um, während Hauptbewegung, Bildkomposition und Rhythmus erhalten bleiben.",
      "notVideoFile": "Bitte laden Sie eine gültige Videodatei hoch.",
      "fileTooLarge": "Video ist zu groß. Bitte wählen Sie ein Video unter 100MB.",
      "downloadName": "cartoon-style-video.mp4"
    },
    "anime-video-style-converter": {
      "name": "Anime-Stil-Konverter",
      "desc": "Videos in Anime-Stil umwandeln",
      "fullDesc": "Laden Sie ein Video hoch und die KI wandelt es in einen Anime-Stil um, während Motivbewegung und Szenenrhythmus erhalten bleiben.",
      "notVideoFile": "Bitte laden Sie eine gültige Videodatei hoch.",
      "fileTooLarge": "Video ist zu groß. Bitte wählen Sie ein Video unter 100MB.",
      "downloadName": "anime-style-video.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "Ölgemälde-Stil-Konverter",
      "desc": "Videos in Ölgemälde-Stil umwandeln",
      "fullDesc": "Laden Sie ein Video hoch und die KI wandelt es in einen Ölgemälde-Stil mit kräftigen Farben und malerischer Textur um.",
      "notVideoFile": "Bitte laden Sie eine gültige Videodatei hoch.",
      "fileTooLarge": "Video ist zu groß. Bitte wählen Sie ein Video unter 100MB.",
      "downloadName": "oil-painting-style-video.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "Cyberpunk-Stil-Konverter",
      "desc": "Videos in Cyberpunk-Stil umwandeln",
      "fullDesc": "Laden Sie ein Video hoch und die KI wandelt es in einen kontrastreichen, neonartigen futuristischen Cyberpunk-Stil um.",
      "notVideoFile": "Bitte laden Sie eine gültige Videodatei hoch.",
      "fileTooLarge": "Video ist zu groß. Bitte wählen Sie ein Video unter 100MB.",
      "downloadName": "cyberpunk-style-video.mp4"
    },
    "photo-restore": {
      "name": "Fotowiederherstellung",
      "desc": "Wiederherstellen von alten, verschwommenen oder beschädigten Fotos mit KI-Technologie.",
      "fullDesc": "Wiederherstellen von alten, verschwommenen oder beschädigten Fotos mit KI-Technologie. Unterstützt Rauschentfernung, Schärfung und Auffüllen fehlender Teile, um wertvolle Erinnerungen wieder zum Leben zu erwecken.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "foto-wiederhergestellt.png"
    },
    "blurry-photo-repair": {
      "name": "Unscharfe Bilder reparieren",
      "desc": "Reparieren Sie unscharfe Bilder und stellen Sie klarere Details mit KI wieder her.",
      "fullDesc": "Reparieren Sie unscharfe Bilder mit KI. Verbessern Sie die Schärfe, stellen Sie Gesichts- und Texturdetails wieder her und machen Sie weiche Fotos klarer.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "unscharfes-bild-repariert.png"
    },
    "cartoon-digital-human": {
      "name": "KI-Cartoonfiguren-Generator",
      "desc": "Porträt in Cartoon-Stil umwandeln",
      "fullDesc": "Erzeugen Sie aus einem Porträt einen Cartoon-Digitalmenschen im Anime-Stil. Bewahrt erkennbare Merkmale und erstellt einen polierten Avatar mit klaren Linien und lebendigen Farben.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "cartoon-digitalmensch.png"
    },
    "manga-digital-human": {
      "name": "KI-Mangafiguren-Generator",
      "desc": "Porträt in Manga-Stil umwandeln",
      "fullDesc": "Erzeugen Sie aus einem Porträt einen Manga-Digitalmenschen. Bewahrt erkennbare Merkmale und erstellt einen klaren Comic-Look mit ausdrucksstarken Linien und polierter Schattierung.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "manga-digitalmensch.png"
    },
    "oil-painting-digital-human": {
      "name": "KI-Ölporträt-Generator",
      "desc": "Porträt in Ölgemälde-Stil umwandeln",
      "fullDesc": "Erzeugen Sie aus einem Porträt einen Digitalmenschen im Ölgemälde-Stil. Bewahrt erkennbare Merkmale und erstellt ein malerisches Porträt mit kräftigen Farben und Pinselstruktur.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "oelgemaelde-digitalmensch.png"
    },
    "id-photo-generator": {
      "name": "Passfoto-Generator",
      "desc": "Standard-Passfoto aus Porträt erstellen",
      "fullDesc": "Erstellen Sie aus einem Porträt ein sauberes, professionelles Ausweisfoto. Die KI bereitet das Motiv für einen ordentlichen Dokumentfoto-Look auf.",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "downloadName": "passfoto.png"
    },
    "ai-change-clothes": {
      "name": "KI-Kleidungswechsler",
      "desc": "Outfit- und Personenbild hochladen, Kleidung per Klick wechseln",
      "fullDesc": "Laden Sie zuerst das Outfitbild und dann das Personenbild hoch. KI überträgt das ausgewählte Outfit auf das Porträt und bewahrt Person, Pose und natürliche Bilddetails.",
      "demoTitle": "Demo",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch.",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB.",
      "firstImageLabel": "Outfitbild",
      "uploadFirstImage": "Outfitbild hochladen",
      "changeFirstImage": "Outfitbild ändern",
      "secondImageLabel": "Personenbild",
      "uploadSecondImage": "Personenbild hochladen",
      "changeSecondImage": "Personenbild ändern",
      "uploadingSecondImage": "Personenbild wird hochgeladen...",
      "downloadName": "ki-outfit-gewechselt.png"
    },
    "handwritten-erase": {
      "name": "Handschrift-Löscher",
      "desc": "Handschriftlichen Text in Dokumenten mit KI entfernen.",
      "fullDesc": "Automatisches Erkennen und Löschen von handschriftlichem Text aus Dokumenten unter Beibehaltung des gedruckten Inhalts. Perfekt für Prüfungen, Notizen, Verträge und mehr. Unterstützt Zuschneiden, Entzerren und Drehung.",
      "docDirection": "Drehung",
      "docDirections": {
        "none": "Keine Drehung",
        "rotate90": "90° im Uhrzeigersinn",
        "rotate180": "180° im Uhrzeigersinn",
        "rotate270": "270° im Uhrzeigersinn",
        "auto": "Auto-Erkennung"
      },
      "crop": "Ränder zuschneiden",
      "dewarp": "Entzerren",
      "notImageFile": "Bitte laden Sie eine gültige Bilddatei hoch",
      "fileTooLarge": "Bild zu groß, bitte wählen Sie ein Bild unter 15MB",
      "noImageInResponse": "Verarbeitung fehlgeschlagen, bitte versuchen Sie es erneut",
      "downloadName": "handwriting-erased.png",
      "featuresKicker": "Entfernen der Handschrift von Dokumenten",
      "featuresTitle": "Entfernen Sie Handschriften und stellen Sie saubere Dokumente wieder her",
      "featuresIntro": "Bereinigen Sie handschriftliche Antworten, Vertragsüberarbeitungen, Überprüfungsnotizen und Markierungen gescannter Dokumente, während gedruckter Text und das Originallayout erhalten bleiben.",
      "features": [
        {
          "title": "Entfernen Sie die Antworten der Schüler aus den Prüfungsunterlagen",
          "desc": "Erkennen Sie handschriftliche Antworten, Berechnungen und Anmerkungen auf abgeschlossenen Prüfungsarbeiten automatisch.",
          "cta": "Saubere Testpapier-Antworten kostenlos"
        },
        {
          "title": "Handschrift aus Verträgen löschen",
          "desc": "Bereinigen Sie handschriftliche Ergänzungen, Kreise, geänderte Beträge, Pfeile und Überprüfungsnotizen, während gedruckte Klauseln, Tabellen und das Layout erhalten bleiben.",
          "cta": "Saubere Vertragshandschrift online"
        },
        {
          "title": "Bereiten Sie Tests für den Unterricht vor und drucken Sie sie erneut aus",
          "desc": "Bereinigen Sie Schülerantworten und Lehreranmerkungen für Unterricht, Prüfungsvorbereitung und Dokumentenarchivierung.",
          "cta": "Probieren Sie den Teacher Test Paper Cleaner aus"
        },
        {
          "title": "Entfernen Sie handschriftliche Markierungen aus gescannten Dokumenten",
          "desc": "Entfernen Sie Häkchen, Pfeile, Kreise, Randnotizen und Überprüfungsmarkierungen aus gescannten Formularen, Inspektionsberichten und Bürodokumenten.",
          "cta": "Reinigen Sie die Markierungen gescannter Dokumente"
        }
      ],
      "useCasesKicker": "Für Schüler und Lehrer",
      "useCasesTitle": "Anwendungsfälle für die Entfernung von KI-Handschriften im Bildungsbereich",
      "useCases": [
        {
          "title": "Entfernen der Testantwort",
          "desc": "Löschen Sie die Antworten und Berechnungen der Schüler aus den Prüfungsunterlagen."
        },
        {
          "title": "Fehlerbewertung",
          "desc": "Stellen Sie die fertigen Unterlagen für eine weitere Übungsrunde wieder her."
        },
        {
          "title": "Reinigung der Arbeitsmappe",
          "desc": "Entfernen Sie handschriftliche Inhalte aus Hausaufgaben und Arbeitsblättern."
        },
        {
          "title": "Unterricht und Prüfungsvorbereitung",
          "desc": "Erstellen Sie saubere Unterlagen für den Unterricht, zum Nachdrucken und zur Archivierung."
        },
        {
          "title": "Korrektur gescannter Papiere",
          "desc": "Drehen, beschneiden und entzerren Sie verzerrte oder gekrümmte Dokumentbilder."
        },
        {
          "title": "Vertrags- und Notizreinigung",
          "desc": "Entfernen Sie Handschriften und Anmerkungen aus allgemeinen Dokumenten."
        }
      ],
      "howToKicker": "Drei einfache Schritte",
      "howToTitle": "So entfernen Sie handschriftliche Antworten aus Online-Testarbeiten",
      "howToIntro": "Laden Sie ein Testpapier oder -dokument hoch, legen Sie Rotations-, Zuschneide- und Entzerrungsoptionen fest und laden Sie dann das bereinigte Ergebnis herunter.",
      "steps": {
        "upload": {
          "title": "Laden Sie eine Testarbeit oder ein Dokument hoch",
          "desc": "Laden Sie eine JPG-, PNG- oder WebP-Testarbeit, ein Hausaufgabenblatt oder ein gescanntes Dokument mit weniger als 15 MB hoch."
        },
        "process": {
          "title": "Handschrift konfigurieren und entfernen",
          "desc": "Wählen Sie die Richtung des Dokuments und aktivieren Sie je nach Bedarf das Zuschneiden oder Entzerren. Beginnen Sie dann mit der Verarbeitung."
        },
        "download": {
          "title": "Überprüfen und herunterladen",
          "desc": "Vergleichen Sie die Vorher- und Nachher-Bilder, laden Sie das saubere Dokument herunter oder verarbeiten Sie ein anderes Bild."
        }
      },
      "faqTitle": "Häufig gestellte Fragen zum AI Test Paper Answer Remover",
      "faqs": [
        {
          "q": "Mit welchem Tool kann ich handschriftliche Antworten aus Prüfungsarbeiten entfernen?",
          "a": "Der Miral AI-Handschriftentferner erkennt handgeschriebene Antworten, Berechnungen und Anmerkungen und behält dabei nach Möglichkeit gedruckte Fragen und das Originallayout bei."
        },
        {
          "q": "Kann KI Handschrift entfernen und gleichzeitig gedruckten Text beibehalten?",
          "a": "Es kann ein sauberes Papier wiederherstellen und gleichzeitig den gedruckten Text bewahren, wenn die Handschrift den gedruckten Inhalt nicht stark überlappt."
        },
        {
          "q": "Können Lehrer Prüfungsunterlagen bereinigen und erneut ausdrucken?",
          "a": "Ja. Es eignet sich für die Unterrichtsvorbereitung, Unterrichtserklärungen, Testerstellung und Dokumentenarchivierung."
        },
        {
          "q": "Können Studierende beantwortete Arbeiten zur Überarbeitung zurücksetzen?",
          "a": "Ja. Gereinigte Prüfungsunterlagen und Arbeitsblätter können zur Fehlerüberprüfung und zum weiteren Üben wiederverwendet werden."
        },
        {
          "q": "Wie lösche ich handschriftliche Notizen, Kugelschreibermarkierungen und Anmerkungen mit roter Tinte?",
          "a": "Laden Sie das Dokumentbild hoch und führen Sie den Handschriftentferner aus. Es kann verschiedene Handschriftfarben und Schreibwerkzeuge verarbeiten, die Ergebnisse hängen jedoch von der Klarheit und Überlappung mit gedrucktem Text ab."
        },
        {
          "q": "Wie behebe ich einen verzerrten oder gebogenen Scan, bevor ich die Handschrift entferne?",
          "a": "Richten Sie einen geneigten Scan zuerst aus oder drehen Sie ihn. Verwenden Sie das Zuschneiden für überschüssigen Hintergrund und die Entzerrung nur für wirklich gekrümmte Seiten, bevor Sie die Handschrift bearbeiten."
        },
        {
          "q": "Welche Bildformate werden unterstützt?",
          "a": "JPG-, PNG- und WebP-Bilder unter 15 MB werden unterstützt. PDF-Dateien werden auf dieser Seite nicht unterstützt."
        }
      ]
    },
    "category": {
      "image": "Bildbearbeitung",
      "video": "Videobearbeitung",
      "document": "Dokumentenverarbeitung"
    },
    "categoryModal": {
      "title": "Werkzeugkategorie auswählen"
    },
    "convert": {
      "success": "Konvertierung abgeschlossen!",
      "zipHint": "Das Ergebnis ist als ZIP-Datei mit mehreren Bildern verpackt",
      "fileTooLarge": "Datei zu groß, bitte wählen Sie eine Datei unter 50MB",
      "demoTitle": "Konvertierungsvorschau",
      "sourceLabel": "Quellformat",
      "targetLabel": "Zielformat"
    },
    "pdf-to-word": {
      "name": "PDF zu Word",
      "desc": "PDF-Dateien in bearbeitbare Word-Dokumente umwandeln",
      "fullDesc": "Wandeln Sie PDF-Dateien intelligent in bearbeitbare Word-Dokumente um, wobei Layout, Tabellen, Bilder und mehr genau erhalten bleiben."
    },
    "image-to-word": {
      "name": "Bild zu Word",
      "desc": "Text in Bildern in Word-Dokumente umwandeln",
      "fullDesc": "Erkennen Sie intelligent Text, Tabellen und andere Inhalte in Bildern und wandeln Sie diese in Word-Dokumente um, wobei das Originallayout erhalten bleibt."
    },
    "pdf-to-excel": {
      "name": "PDF zu Excel",
      "desc": "PDF-Tabellen in bearbeitbare Excel-Dateien umwandeln",
      "fullDesc": "Erkennen Sie intelligent Tabelleninhalte in PDF-Dateien und wandeln Sie diese in bearbeitbare Excel-Dateien um."
    },
    "pdf-to-ppt": {
      "name": "PDF zu PPT",
      "desc": "PDF-Dateien in bearbeitbare PPT-Präsentationen umwandeln",
      "fullDesc": "Wandeln Sie PDF-Dateien intelligent in bearbeitbare PPT-Präsentationen um, wobei Originalformatierung, Bilder und Text erhalten bleiben."
    },
    "pdf-to-image": {
      "name": "PDF zu Bild",
      "desc": "Jede PDF-Seite in hochwertige Bilder umwandeln",
      "fullDesc": "Wandeln Sie jede Seite einer PDF-Datei in hochwertige Bilder um. Unterstützt Stapelkonvertierung mehrseitiger PDFs."
    },
    "word-to-pdf": {
      "name": "Word zu PDF",
      "desc": "Word-Dokumente in PDF-Dateien umwandeln",
      "fullDesc": "Wandeln Sie Word-Dokumente schnell in PDF-Dateien um, wobei Originalformatierung, Schriftarten und Bilder erhalten bleiben."
    },
    "excel-to-pdf": {
      "name": "Excel zu PDF",
      "desc": "Excel-Tabellenkalkulationen in PDF-Dateien umwandeln",
      "fullDesc": "Wandeln Sie Excel-Tabellenkalkulationen in PDF-Dateien um, wobei Tabellenstruktur und Datenlayout erhalten bleiben."
    },
    "image-to-pdf": {
      "name": "Bild zu PDF",
      "desc": "Mehrere Bilder in einer einzigen PDF-Datei zusammenführen",
      "fullDesc": "Führen Sie mehrere Bilder in einer einzigen PDF-Datei zusammen. Unterstützt gängige Bildformate wie JPG, PNG und BMP."
    },
    "word-to-image": {
      "name": "Word zu Bild",
      "desc": "Jede Word-Dokumentseite in ein Bild umwandeln",
      "fullDesc": "Wandeln Sie jede Seite eines Word-Dokuments in hochwertige Bilder um. Unterstützt Stapelkonvertierung mehrseitiger Dokumente."
    }
  },
  "musicTags": {
    "pop": "Pop",
    "electronic": "Elektronisch",
    "classical": "Klassisch",
    "jazz": "Jazz"
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "Digital-Marketing-Leiter",
        "tag": "90% Zeit gespart",
        "content": "Miral ist zu unserem Hub für visuelle Inhalte geworden. Produktbilder mit Midjourney erstellen, Werbevideos mit Veo erstellen, dann alles in Miral bearbeiten — alles ohne Plattformwechsel."
      },
      {
        "name": "Sarah Rodriguez",
        "role": "E-Commerce-Besitzerin",
        "tag": "40% höhere Konversion",
        "content": "Zugang zu 29+ Modellen an einem Ort ist erstaunlich. Ich nutze Seedream für Produktfotos, Seedance für Videoanzeigen und die Upscaling-Tools für Kataloge. Die Konversion hat sich um 40% erhöht!"
      },
      {
        "name": "David Kim",
        "role": "Content-Ersteller",
        "tag": "500K+ Follower",
        "content": "Ich erstelle Bilder mit FLUX und Nano Banana, verwandle sie dann in virale Videos mit Kling und Sora. Das Credit-System ist fair — Pay as you go. Meine Follower lieben die vielfältigen Inhalte!"
      },
      {
        "name": "Emma Thompson",
        "role": "Grafikdesignerin",
        "tag": "Professionelle Qualität",
        "content": "Als Designerin war ich skeptisch gegenüber KI-Plattformen. Aber Mirals reiche Modellbibliothek und präzise Bearbeitungstools sind wirklich beeindruckend — von Konzeptskizzen bis Endprodukten, alles ist einfach."
      },
      {
        "name": "James Wilson",
        "role": "Video-Produzent",
        "tag": "10x schnellerer Workflow",
        "content": "Die Videomodelle hier sind unglaublich — Veo ist filmisch, Seedance ist schnell, und Wans Charakteranimation ist natürlich. Alle Modelle teilen sich ein Credit-System — spart Zeit und Geld."
      },
      {
        "name": "Lisa Park",
        "role": "Inhaberin einer Kreativagentur",
        "tag": "Top-Wahl des Teams",
        "content": "Unser gesamtes Team ist zu Miral gewechselt. Die API-Integration ist reibungslos und die Vielfalt der Modelle bedeutet, dass wir immer das richtige Tool finden. Dies ist die beste KI-Plattform, die es gibt."
      }
    ]
  },
  "faq": {
    "categories": {
      "all": "Alle",
      "general": "Allgemein",
      "pricing": "Preise",
      "models": "Modelle",
      "features": "Funktionen"
    },
    "items": [
      {
        "q": "What is Miral?",
        "a": "Miral is an all-in-one AI creation platform integrating 29+ top-tier AI models, supporting image generation, video creation, music production, and professional editing tools. No need to switch between platforms - one account gives you access to all major models including FLUX, Midjourney, Sora, Veo, Kling, and more."
      },
      {
        "q": "Which AI models are supported?",
        "a": "We support 29+ top-tier AI models, including image models (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana, etc.), video models (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5, etc.), and AI music generation models. All models are continuously updated."
      },
      {
        "q": "How does the credit system work?",
        "a": "We use a unified credit system. Image generation starts at 2 credits, video generation at 10 credits, and music at 10 credits per track. Premium models may consume more credits. Subscribers enjoy lower credit rates and can also purchase credit packs separately."
      },
      {
        "q": "Can I generate images, videos, and music?",
        "a": "Yes! Miral supports text-to-image, image editing, style transfer, text-to-video, image-to-video, AI music creation, and more - meeting all creative needs from personal projects to commercial work."
      },
      {
        "q": "How fast is the generation?",
        "a": "Most image generation completes within 30 seconds, video generation takes about 1-6 minutes. We continuously optimize our infrastructure to ensure fast and stable generation."
      },
      {
        "q": "Can I use Miral for commercial purposes?",
        "a": "Yes. All paid plans include commercial licenses, allowing you to use generated content for commercial projects, marketing materials, social media, and more."
      },
      {
        "q": "Is API access available?",
        "a": "Yes, the Ultimate plan includes API access. Through our comprehensive API, you can integrate AI image, video, and music generation directly into your applications."
      },
      {
        "q": "Can I generate music with AI?",
        "a": "Absolutely! Our AI music generator supports various music styles. Simply describe what you want to generate original music, perfect for video soundtracks, podcast background music, and more."
      },
      {
        "q": "How do you handle data privacy and security?",
        "a": "We strictly adhere to GDPR compliance standards. All data is encrypted and not used for AI training. Users can delete their accounts and all data at any time."
      },
      {
        "q": "Can others see my work?",
        "a": "By default, your work is only visible to you. Pro and Ultimate users can enable privacy mode to ensure complete privacy."
      },
      {
        "q": "How can I delete my account and data?",
        "a": "You can request account deletion in your account settings at any time. We will delete all your data and generated content within 30 days."
      },
      {
        "q": "Can I get support if I encounter issues?",
        "a": "Of course! You can contact our support team at miral_support@miralvis.com. Pro users get priority support, and Ultimate users get dedicated support."
      }
    ]
  },
  "pricing": {
    "title": "Unbegrenzte Inspiration, wählen Sie den Plan, der am besten passt",
    "subtitle": "Freischalten aller KI-Modelle, Batch-Erstellung von Bildern, Videos und Musik.",
    "promo": "Angebot für begrenzte Zeit — 30% sparen auf Jahrespläne",
    "monthly": "Monatlich",
    "yearly": "Jährlich",
    "yearlyNote": "Jahresplan — Credits auf einmal geliefert, Einmalzahlung wirtschaftlicher",
    "popular": "Am beliebtesten",
    "currentPlan": "Aktueller Plan",
    "currentPlanBtn": "Aktueller Plan",
    "upgrade": "Upgrade",
    "unavailable": "Nicht verfügbar",
    "upgradeSuccess": "Upgrade erfolgreich!",
    "upgradeFailed": "Upgrade fehlgeschlagen",
    "upgradeModal": {
      "title": "Upgrade bestätigen",
      "item1": "Wir berechnen den Preisunterschied Ihrer Karte.",
      "item2": "Nach erfolgreicher Zahlung wird zusätzliches Guthaben automatisch hinzugefügt.",
      "item3": "Der neue Plan tritt nach erfolgreicher Zahlung in Kraft.",
      "tip": "Tipp: Stellen Sie sicher, dass Ihre Zahlungsmethode gültig ist. Guthaben-Aktualisierung innerhalb von Sekunden nach Zahlung.",
      "cancel": "Abbrechen",
      "confirm": "Upgrade bestätigen"
    },
    "subscribe": "Jetzt abonnieren",
    "processing": "Verarbeitung...",
    "creditsPer": "Credits /",
    "extraCredits": "zusätzliche Credits",
    "creditsRate": "100 Credits = $",
    "perMonth": "Monat",
    "perYear": "Jahr",
    "yearlyBilling": "Jährliche Abrechnung",
    "saveVsMonthly": "Sparen vs monatlich:",
    "planDesc": {
      "basic": "Perfekt für den Start",
      "pro": "Am besten für Kreative und Profis",
      "ultimate": "Für Teams und Power-User"
    },
    "creditsPack": {
      "title": "Credit-Pack kaufen",
      "subtitle": "Einmalkauf, kein Abo",
      "buy": "Credits kaufen",
      "oneTime": "Einmalkauf",
      "permanent": "Credits laufen nie ab",
      "tip": "Tipp: Abonnements sind besserer Wert",
      "tipItems": [
        "Niedrigere Credit-Rates (40-60% sparen)",
        "15% Rabatt auf alle Credit-Packs"
      ]
    },
    "security": {
      "noTraining": "Nicht für KI-Training verwendet",
      "encrypted": "Verschlüsselte Speicherung",
      "gdpr": "DSGVO-konform",
      "delete": "Selbstbedienung Konto-Löschung"
    },
    "dataSafety": "Erfahren Sie mehr über unser Engagement für Datensicherheit →",
    "allPlansInclude": "Alle Pläne beinhalten",
    "includes": {
      "models": "Premium-KI-Modelle",
      "fast": "Schnelle Erstellung",
      "privacy": "100% Privatsphäre",
      "commercial": "Kommerzielle Nutzung"
    },
    "creditsInfo": {
      "title": "Credits-Leitfaden",
      "subtitle": "Credit-Verbrauch für alle Modelle anzeigen",
      "model": "Modell",
      "type": "Typ",
      "cost": "Credit-Kosten",
      "speed": "Geschwindigkeit",
      "image": "Bild",
      "video": "Video"
    },
    "questions": "Fragen?",
    "contact": "Hilfe benötigt?",
    "contactUs": "Kontaktieren Sie uns",
    "faq": {
      "items": [
        {
          "q": "Was kann ich mit Credits erstellen?",
          "a": "Credits können用于生成 KI-Bilder, -Videos und -Musik. Bilderstellung beginnt bei 2 Credits, Videoerstellung bei 10 Credits und Musik bei 10 Credits pro Titel. Premium-Modelle können mehr Credits verbrauchen."
        },
        {
          "q": "Kann ich jederzeit kündigen?",
          "a": "Ja, Sie können Ihr Abo jederzeit kündigen. Sie können den Service bis zum Ende Ihrer aktuellen Abrechnungsperiode weiterhin nutzen."
        },
        {
          "q": "Was passiert, wenn mir die Credits ausgehen?",
          "a": "Sie können jederzeit Einmal-Credit-Packs kaufen (kein Abo erforderlich). Abonnenten erhalten 15% Rabatt auf Credit-Packs. Sie können auch Ihren Plan für bessere Raten auf monatliche Kontingente upgraden."
        },
        {
          "q": "Gibt es eine Rückerstattungsrichtlinie?",
          "a": "Ja. Bei Erstkauf von Einmal-Packs oder Erstabonnement können Sie innerhalb von 7 Kalendertagen eine Rückerstattung anfordern, wenn die Credit-Nutzung unter 3% liegt."
        }
      ]
    }
  },
  "music": {
    "breadcrumb": {
      "home": "Startseite",
      "aiMusic": "KI-Musik"
    },
    "model": {
      "label": "Modell",
      "aiMusicName": "KI-Musik",
      "desc": "Erstellen Sie originale Musik aus Beschreibungen, unterstützt verschiedene Stile und Dauer.",
      "tagMusic": "Musikerstellung",
      "tagLyrics": "Texterstellung"
    },
    "mode": {
      "describe": "Beschreiben",
      "lyrics": "Text schreiben"
    },
    "form": {
      "musicDesc": "Musikbeschreibung",
      "musicDescPlaceholder": "Beschreiben Sie den Musikstil, die Emotion und die Szene, die Sie möchten...\n\nBeispiel: Eine fröhliche elektronische Musik mit futuristischen Synth-Melodien, geeignet für Tech-Produkt-Werbevideos",
      "optimize": "Optimieren",
      "songTitle": "Songtitel",
      "songTitlePlaceholder": "Songtitel eingeben...",
      "lyricsDescLabel": "Textbeschreibung",
      "lyricsDescPlaceholder": "Schreiben Sie hier Ihre Textbeschreibung...\n\nBeispiel:\n[Intro]\n...\n[Verse]\n...\n[Chorus]\n...",
      "styleTags": "Stil-Tags",
      "styleTagsPlaceholder": "Klicken Sie auf Tags unten zum Hinzufügen (Mehrfachauswahl)"
    },
    "tags": {
      "sections": [
        {
          "label": "Strophe",
          "value": "[Verse]\n"
        },
        {
          "label": "Refrain",
          "value": "[Chorus]\n"
        },
        {
          "label": "Brücke",
          "value": "[Bridge]\n"
        },
        {
          "label": "Intro",
          "value": "[Intro]\n"
        },
        {
          "label": "Outro",
          "value": "[Outro]\n"
        }
      ],
      "styles": [
        {
          "label": "Pop",
          "value": "Pop"
        },
        {
          "label": "Rock",
          "value": "Rock"
        },
        {
          "label": "Jazz",
          "value": "Jazz"
        },
        {
          "label": "Klassisch",
          "value": "Klassisch"
        },
        {
          "label": "Elektronisch",
          "value": "Elektronisch"
        },
        {
          "label": "R&B",
          "value": "R&B"
        },
        {
          "label": "Hip-Hop",
          "value": "Hip-Hop"
        },
        {
          "label": "Country",
          "value": "Country"
        },
        {
          "label": "Folk",
          "value": "Folk"
        },
        {
          "label": "Ambient",
          "value": "Ambient"
        },
        {
          "label": "Filmisch",
          "value": "Filmisch"
        },
        {
          "label": "Lo-fi",
          "value": "Lo-fi"
        },
        {
          "label": "Metal",
          "value": "Metal"
        },
        {
          "label": "Reggae",
          "value": "Reggae"
        },
        {
          "label": "Blues",
          "value": "Blues"
        },
        {
          "label": "Soul",
          "value": "Soul"
        },
        {
          "label": "Funk",
          "value": "Funk"
        },
        {
          "label": "Indie",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "Dauer",
      "instrumental": "Instrumental",
      "instrumentalDescOn": "Nur Begleitung erstellen, kein Gesang",
      "instrumentalDescOff": "Gesangsaufführung einschließen"
    },
    "errors": {
      "titleRequired": "Songtitel ist erforderlich",
      "lyricsDescRequired": "Textbeschreibung ist erforderlich"
    },
    "footer": {
      "creditsRequired": "Credits erforderlich:",
      "creditsLeft": "Verbleibend:",
      "generate": "Musik erstellen"
    },
    "preview": {
      "generating": "Musik wird erstellt...",
      "generatedTitle": "Erstellte Musik",
      "emptyTitle": "KI-Musik-Generator",
      "emptySubtitle": "Erstellen Sie originale Musik mit KI. Beschreiben Sie den Stil oder geben Sie Text ein und erstellen Sie Ihren eigenen Song in Sekunden.",
      "emptyTags": [
        "Pop",
        "Jazz",
        "Filmisch",
        "Lo-fi",
        "Rock"
      ],
      "track": "Titel",
      "play": "Abspielen",
      "pause": "Pause",
      "mute": "Stumm",
      "unmute": "Stumm aufheben",
      "download": "Herunterladen",
      "showLyrics": "Text anzeigen",
      "hideLyrics": "Text ausblenden",
      "generateFailed": "Erstellung fehlgeschlagen",
      "requestFailed": "Anfrage fehlgeschlagen, bitte versuchen Sie es erneut",
      "downloadMp3": "MP3 herunterladen",
      "downloadWav": "WAV herunterladen",
      "regenerate": "Neu erstellen",
      "noHistory": "Noch keine Historie"
    },
    "intro": {
      "title": "KI-Musik-Generator",
      "desc": "Mit fortschrittlicher KI-Technologie geben Sie einfach eine Beschreibung oder Text ein, um hochwertige originale Musik zu erstellen. Unterstützt mehrere Musikstile, geeignet für Videosoundtracks, Werbung, Podcasts und mehr.",
      "tagMusic": "Musikerstellung",
      "tagLyrics": "Texterstellung",
      "tagStyles": "Mehrere Stile",
      "tagCommercial": "Kommerzielle Lizenz"
    },
    "features": {
      "badge": "Kernfunktionen",
      "title": "Was kann der KI-Musik-Generator für Sie tun?",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "Mehrere Stile",
          "desc": "Unterstützt Pop, Rock, Elektronisch, Jazz, Klassisch, Hip-Hop und Dutzende Musikstile für verschiedene kreative Bedürfnisse."
        },
        "lyrics": {
          "icon": "📝",
          "title": "Texterstellung",
          "desc": "Geben Sie Text ein, um vollständige Songs mit Abschnittsmarkern (Strophe, Refrain usw.) zu erstellen, KI arrangiert und produziert Musik automatisch."
        },
        "vocals": {
          "icon": "🎤",
          "title": "Gesangssynthese",
          "desc": "Unterstützt männliche und weibliche Gesänge mit verschiedenen Timbres, KI singt Ihren Text mit natürlichen und glatten Ergebnissen."
        },
        "instrumental": {
          "icon": "🎹",
          "title": "Instrumental-Modus",
          "desc": "Erstellen Sie hochwertige Instrumentalbegleitung, geeignet für Videosoundtracks, Podcast-Hintergrundmusik und mehr."
        },
        "fast": {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Fortschrittliche KI-Modelle gewährleisten schnelle Musikproduktion, die meisten Musik können innerhalb von 30 Sekunden erstellt werden."
        },
        "commercial": {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Musik können für kommerzielle Zwecke verwendet werden, einschließlich Videos, Werbung, Podcasts und mehr."
        }
      }
    },
    "faq": {
      "title": "Häufig gestellte Fragen",
      "items": {
        "howItWorks": {
          "q": "Wie funktioniert der KI-Musik-Generator?",
          "a": "Unser KI-Musik-Generator verwendet fortschrittliche Deep-Learning-Modelle, um originale Musik basierend auf Ihren Textbeschreibungen oder Text zu erstellen. Geben Sie einfach den Musikstil, die Emotion und die Szenenbeschreibung ein, und die KI wird automatisch ein vollständiges Musikstück komponieren."
        },
        "commercial": {
          "q": "Kann erstellte Musik für kommerzielle Zwecke verwendet werden?",
          "a": "Ja, alle Musik, die mit unserer Plattform erstellt wurde, kann für kommerzielle Zwecke verwendet werden, einschließlich YouTube-Videos, Werbung, Podcasts, Spielen und mehr."
        },
        "styles": {
          "q": "Welche Musikstile werden unterstützt?",
          "a": "Wir unterstützen Pop, Rock, Elektronisch, Jazz, Klassisch, Hip-Hop, R&B, Country, Metal, Folk und Dutzende andere Musikstile. Sie können auch mehrere Stile mischen, um einzigartige Musik zu erstellen."
        },
        "credits": {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Je nach gewähltem Modell kostet jede Erstellung 8-10 Credits. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        "download": {
          "q": "Kann ich die erstellte Musik herunterladen?",
          "a": "Ja, erstellte Musik unterstützt sowohl MP3- als auch WAV-Format zum Download. Sie können das entsprechende Format basierend auf Ihren Bedürfnissen wählen."
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "Summer Breeze",
        "style": "Pop / Fröhlich",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "Space Journey",
        "style": "Elektronisch / Futuristisch",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "Walking in Rain",
        "style": "Jazz / Entspannt",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "Mountain Dawn",
        "style": "Klassisch / Ruhig",
        "duration": "3:00"
      }
    }
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "Startseite",
      "models": "Modelle"
    },
    "model": "Modell",
    "modelVersion": "Modellversion",
    "standard": "Standard",
    "pro": "Pro",
    "standardDesc": "Standardqualität, schnelle Erstellung",
    "proDesc": "Hohe Qualität, unterstützt hohe Auflösung",
    "credits": "Credits",
    "imagePrompt": "Bild-Prompt",
    "imagePromptPlaceholder": "Beschreibe das Bild, das du erzeugen möchtest...",
    "videoPrompt": "Video-Prompt",
    "videoPromptPlaceholder": "Beschreibe das Video, das du erzeugen möchtest...",
    "referenceImage": "Referenzbild",
    "aspectRatio": "Seitenverhältnis",
    "thinkingLevel": "Denkstufe",
    "thinkingMinimal": "Niedrige Latenz",
    "thinkingHigh": "Hohe Wiedergabetreue",
    "characters": "Zeichen",
    "imageSize": "Bildgröße",
    "auto": "Auto",
    "resolution": "Auflösung",
    "duration": "Dauer",
    "seconds": "Sekunden",
    "creditsRequired": "Credits erforderlich:",
    "creditsRemaining": "Verbleibend:",
    "remaining": "Verbleibend:",
    "generate": "Erstellen",
    "getMoreCredits": "Mehr Credits erhalten",
    "generating": "Erstellung...",
    "demoPrompt": "Demo-Prompt",
    "modelLabel": "Modell:",
    "version": "Version:",
    "size": "Größe:",
    "download": "Herunterladen",
    "regenerate": "Neu erstellen",
    "noHistory": "Keine Erstellungshistorie",
    "features": {
      "badge": "Kernfunktionen",
      "title": "Was kann dieses Modell?",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "Realistischer Stil",
          "desc": "Erstellen Sie fotorealistische Bilder mit natürlichem Licht und Details."
        },
        "artistic": {
          "icon": "🎨",
          "title": "Künstlerischer Stil",
          "desc": "Erstellen Sie künstlerische Bilder mit verschiedenen Malstilen."
        },
        "portrait": {
          "icon": "👤",
          "title": "Porträt",
          "desc": "Professionelle Porträtfotografie mit natürlichen Hauttönen."
        },
        "landscape": {
          "icon": "🏔️",
          "title": "Landschaft",
          "desc": "Atemberaubende Landschafts- Naturfotografie."
        },
        "product": {
          "icon": "📦",
          "title": "Produkt",
          "desc": "Hochwertige Produktfotografie für E-Commerce."
        },
        "fast": {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Die meisten Bilder innerhalb von 10-30 Sekunden erstellt."
        },
        "highRes": {
          "icon": "🖼️",
          "title": "Hohe Auflösung",
          "desc": "Unterstützt Auflösung bis zu 4K."
        },
        "cinematic": {
          "icon": "🎬",
          "title": "Filmisch",
          "desc": "Erstellen Sie filmische Videos mit professioneller Kameraarbeit."
        },
        "audioSync": {
          "icon": "🔊",
          "title": "Audio-Synchronisation",
          "desc": "Native Audio-Video-Synchronisation für Videos."
        },
        "lipSync": {
          "icon": "👄",
          "title": "Lippen-Synchronisation",
          "desc": "Präzise Lippen-Synchronisation für Charaktervideos."
        },
        "animation": {
          "icon": "🎭",
          "title": "Animation",
          "desc": "Sanfte Charakteranimation und Bewegung."
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "Langes Video",
          "desc": "Unterstützung für längere Videodauer."
        },
        "privacy": {
          "icon": "🔒",
          "title": "Privatsphäre & Sicherheit",
          "desc": "Alle Daten werden bei der Übertragung verschlüsselt und nicht für KI-Training verwendet. Ihre Kreationen gehören Ihnen."
        }
      }
    },
    "whyChoose": {
      "items": [
        "Intelligente Kreation powered by {name}",
        "Erledigen Sie komplexe kreative Aufgaben schnell und effizient",
        "Erstellte Inhalte können kommerziell genutzt werden",
        "Kontinuierliche Updates und verbessernde Fähigkeiten",
        "Einheitliches Credit-System, Pay as you go"
      ]
    },
    "faq": {
      "title": "Häufig gestellte Fragen",
      "imageType": "Bilder",
      "videoType": "Videos",
      "imageFormats": "PNG-, JPEG- und WebP-Ausgabeformate werden unterstützt; wählen Sie, was zu Ihrem Workflow passt.",
      "videoFormats": "Videos werden als MP4 mit 480p- und 720p-Optionen und mehreren Seitenverhältnissen geliefert.",
      "items": [
        {
          "q": "Wie funktioniert {name}?",
          "a": "Laden Sie eine Referenz hoch oder geben Sie einen Text-Prompt ein — {name} erstellt hochwertige {type} basierend auf Ihrer Eingabe. Der Prozess ist einfach und benötigt keine Expertenfähigkeiten."
        },
        {
          "q": "Kann ich erstellte {type} kommerziell nutzen?",
          "a": "Ja. Inhalte von {name} können kommerziell genutzt werden, einschließlich Marketing, sozialen Medien und Produktnutzung."
        },
        {
          "q": "Wie viele Credits pro Erstellung?",
          "a": "Jede Erstellung mit {name} verwendet {credits} Credits. Abonnenten erhalten bessere Credit-Rates."
        },
        {
          "q": "Wie schnell ist die Erstellung?",
          "a": "Typische Geschwindigkeit für {name} ist {speed}. Wir optimieren weiterhin für zuverlässige, schnelle Ergebnisse."
        },
        {
          "q": "Welche Ausgabeformate werden unterstützt?",
          "a": ""
        }
      ]
    },
    "imagePromptPlaceholder": "Describe the image you want to generate...",
    "videoPromptPlaceholder": "Describe the video you want to generate...",
    "qwenImage20Pro": {
      "negativePromptLabel": "Negativer Prompt (optional)",
      "negativePromptPlaceholder": "Beschreibe, was nicht erscheinen soll (z.B. geringe Schärfe, deformierte Hände usw.)",
      "customWidth": "Breite",
      "customHeight": "Höhe",
      "sizeHint": "Bereich: 512×512 bis 2048×2048",
      "sizeErrorRequired": "Bitte Breite und Höhe eingeben",
      "sizeErrorInteger": "Breite und Höhe müssen ganze Zahlen sein",
      "sizeErrorRange": "Die Auflösung muss zwischen 512×512 und 2048×2048 liegen",
      "promptEnhanceTitle": "Prompt-Verbesserung",
      "promptEnhanceDesc": "Verbessere die Details des Prompts für reichere Ergebnisse",
      "watermarkTitle": "Wasserzeichen",
      "watermarkDesc": "Füge den generierten Bildern ein Wasserzeichen hinzu",
      "demoPromptText": "Zwischen verschneiten Bergen gleitet ein Junge in Skianzug und Brille fröhlich auf Skiern; Schneekristalle wirbeln in seiner Spur, dahinter erstrecken sich endlose schneebedeckte Grate.",
      "faqSizeSupportQ": "Welche Auflösungen werden unterstützt?",
      "faqSizeSupportA": "Geben Sie Breite und Höhe im Bereich 512~2048 ein (z.B. 2048*2048).",
      "faqMaxCountQ": "Wie viele Bilder können maximal pro Anfrage generiert werden?",
      "faqMaxCountA": "Maximal 4 Bilder (n=1..4).",
      "faqLinkUsageQ": "Wie verwende ich die Bild-Links nach der Generierung?",
      "faqLinkUsageA": "Zuerst wird die temporäre URL von DashScope heruntergeladen, dann auf unseren Server hochgeladen und schließlich eine dauerhaft nutzbare URL zurückgegeben."
    },
    "zImageTurbo": {
      "promptExtendTitle": "Prompt-Verbesserung",
      "promptExtendDesc": "Verbessere die Details des Prompts für reichere Ergebnisse",
      "customWidth": "Breite",
      "customHeight": "Höhe",
      "sizeHint": "Bereich: 512×512 bis 2048×2048",
      "sizeErrorRequired": "Bitte Breite und Höhe eingeben",
      "sizeErrorInteger": "Breite und Höhe müssen ganze Zahlen sein",
      "sizeErrorRange": "Die Auflösung muss zwischen 512×512 und 2048×2048 liegen",
      "seedLabel": "Seed",
      "seedErrorRequired": "Bitte Seed eingeben",
      "seedErrorInteger": "Seed muss eine ganze Zahl sein",
      "seedErrorRange": "Seed muss zwischen 0 und 2147483647 liegen",
      "tagQuality": "Hohe Qualität",
      "tagOfficial": "Offiziell direkt",
      "tagHighRes": "Hohe Auflösung",
      "tagSeed": "Seed-Steuerung",
      "tagPromptExtend": "Prompt-Verbesserung",
      "feature1Title": "Hochwertige Ausgabe",
      "feature1Desc": "Erzeuge hochauflösende Bilder und lade sie für langfristig verfügbare URLs hoch.",
      "feature2Title": "Benutzerdefinierte Auflösung",
      "feature2Desc": "Breite und Höhe im Bereich 512–2048 eingeben.",
      "feature3Title": "Steuerbare Generierung",
      "feature3Desc": "Unterstützt Seed und Prompt-Verbesserung für Reproduzierbarkeit und Tuning.",
      "demoPromptText": "Auf feinem goldenem Sand zieht sich eine klare Spur von Fußspuren tiefer ins Bild; die Ränder wirken feucht und körnig, die Oberfläche glitzert im Sonnenlicht und führt den Blick zu einem fernen Leuchtturm.",
      "faqSizeSupportQ": "Welche Auflösungen werden unterstützt?",
      "faqSizeSupportA": "Geben Sie Breite und Höhe im Bereich 512~2048 ein (z.B. 1024*1536).",
      "faqSeedQ": "Wofür ist der Seed?",
      "faqSeedA": "Mit gleichem Prompt und Parametern hilft ein Seed, ähnliche Ergebnisse zu reproduzieren.",
      "faqPromptExtendQ": "Was ist Prompt-Verbesserung?",
      "faqPromptExtendA": "Wenn aktiviert, verbessert sie Prompt-Details für reichere Ergebnisse."
    }
  },
  "privacy": {
    "title": "Datenschutzrichtlinie",
    "lastUpdated": "Zuletzt aktualisiert: 15. Januar 2025",
    "navTerms": "Nutzungsbedingungen →",
    "navTrust": "Vertrauen & Sicherheit →",
    "sections": [
      {
        "title": "1. Informationserfassung",
        "paragraphs": [
          "Wir sammeln Informationen, die Sie bei der Registrierung und Nutzung unserer Dienste bereitstellen, einschließlich E-Mail-Adresse, Benutzername und Zahlungsinformationen.",
          "Wir erfassen auch automatisch Nutzungsdaten wie IP-Adresse, Browsertyp, Zugriffszeit und verwendete Funktionen."
        ]
      },
      {
        "title": "2. Informationennutzung",
        "paragraphs": [
          "Wir verwenden die gesammelten Informationen, um unsere Dienste bereitzustellen, zu warten und zu verbessern, Transaktionen zu verarbeiten, dienstbezogene Benachrichtigungen zu senden und Betrug und Missbrauch zu verhindern.",
          "Wir verkaufen Ihre persönlichen Informationen nicht an Dritte."
        ]
      },
      {
        "title": "3. KI-generierte Inhalte",
        "paragraphs": [
          "Bilder, die Sie hochladen, und Prompts, die Sie eingeben, werden ausschließlich verwendet, um die von Ihnen angeforderten Inhalte zu generieren und nicht zum Trainieren von KI-Modellen verwendet.",
          "Generierte Inhalte werden temporär auf unseren Servern gespeichert, damit Sie sie herunterladen können, und dann entsprechend unserer Datenaufbewahrungsrichtlinie gelöscht."
        ]
      },
      {
        "title": "4. Datensicherheit",
        "paragraphs": [
          "Wir beschäftigen branchenübliche Sicherheitsmaßnahmen zum Schutz Ihrer persönlichen Informationen, einschließlich SSL-Verschlüsselung, Zugriffssteuerungen und regelmäßige Sicherheitsaudits.",
          "Obwohl wir unser Bestes tun, um Ihre Daten zu schützen, ist keine Übertragungsmethode im Internet zu 100% sicher."
        ]
      },
      {
        "title": "5. Cookie-Nutzung",
        "paragraphs": [
          "Wir verwenden Cookies und ähnliche Technologien, um die Benutzererfahrung zu verbessern, die Nutzung zu analysieren und personalisierte Inhalte bereitzustellen.",
          "Sie können Ihre Cookie-Präferenzen über Ihre Browsereinstellungen verwalten. Das Deaktivieren von Cookies kann bestimmte Funktionen beeinträchtigen."
        ]
      },
      {
        "title": "6. Drittanbieter-Dienste",
        "paragraphs": [
          "Wir können Drittanbieter-Dienstleister nutzen, um uns bei der Bereitstellung von Diensten zu unterstützen, wie Zahlungsabwicklung, Datenanalyse und Kundensupport.",
          "Diese Drittanbieter-Dienstleister greifen nur auf Ihre persönlichen Informationen zu dem Umfang zu, der für die Erbringung von Diensten für uns erforderlich ist."
        ]
      },
      {
        "title": "7. Ihre Rechte",
        "paragraphs": [
          "Sie haben das Recht, auf Ihre persönlichen Informationen zuzugreifen, sie zu korrigieren oder zu löschen. Sie haben auch das Recht, die Einschränkung der Verarbeitung Ihrer Daten oder die Übertragung Ihrer Daten an einen anderen Dienst zu verlangen.",
          "Um diese Rechte auszuüben, kontaktieren Sie uns bitte unter miral_support@miralvis.com. Wir werden auf Ihre Anfrage innerhalb von 30 Tagen antworten."
        ]
      },
      {
        "title": "8. DSGVO-Konformität",
        "paragraphs": [
          "Für Benutzer im Europäischen Wirtschaftsraum halten wir die Anforderungen der Datenschutz-Grundverordnung (DSGVO) ein. Unsere Rechtsgrundlage für die Verarbeitung Ihrer Daten umfasst Vertragserfüllung, berechtigte Interessen und Ihre Zustimmung."
        ]
      },
      {
        "title": "9. Kontaktieren Sie uns",
        "paragraphs": [
          "Wenn Sie Fragen oder Bedenken bezüglich unserer Datenschutzrichtlinie haben, kontaktieren Sie bitte unseren Datenschutz unter miral_support@miralvis.com."
        ]
      }
    ]
  },
  "terms": {
    "title": "Nutzungsbedingungen",
    "lastUpdated": "Zuletzt aktualisiert: 15. Januar 2025",
    "navPrivacy": "Datenschutzrichtlinie →",
    "navTrust": "Vertrauen & Sicherheit →",
    "sections": [
      {
        "title": "1. Dienstübersicht",
        "paragraphs": [
          "Miral (im Folgenden \"die Plattform\") ist eine KI-Plattform, die Bild-, Video- und Musikerstellung integriert. Diese Nutzungsbedingungen (im Folgenden \"Bedingungen\") regeln die Bedingungen und Regeln für Ihre Nutzung der Plattform.",
          "Durch die Nutzung der Plattform stimmen Sie zu, an diese Bedingungen gebunden zu sein. Wenn Sie nicht zustimmen, nutzen Sie die Plattform nicht."
        ]
      },
      {
        "title": "2. Konto-Registrierung",
        "paragraphs": [
          "Sie müssen mindestens 18 Jahre alt sein, um ein Konto zu registrieren. Sie müssen genaue und vollständige Registrierungsinformationen bereitstellen und sind für die Aufrechterhaltung der Kontosicherheit verantwortlich.",
          "Sie sind für alle Aktivitäten verantwortlich, die über Ihr Konto durchgeführt werden. Wenn Sie feststellen, dass Ihr Konto unbefugt genutzt wird, benachrichtigen Sie uns bitte sofort."
        ]
      },
      {
        "title": "3. Dienstnutzung",
        "paragraphs": [
          "Die Plattform bietet kreditbasierte KI-Inhaltserstellungsdienste. Credits können durch Abonnement oder Einmalkauf erworben werden. Verschiedene KI-Modelle und Funktionen verbrauchen unterschiedliche Mengen an Credits.",
          "Sie stimmen zu, die Plattform nicht für illegale, schädliche oder rechtsverletzende Zwecke zu nutzen. Die Erstellung von illegalem, pornografischem, gewalttätigem oder rechtsverletzendem Inhalt ist verboten."
        ]
      },
      {
        "title": "4. Geistiges Eigentum",
        "paragraphs": [
          "Die Rechte am geistigen Eigentum für Inhalte, die Sie über die Plattform generieren, gehören Ihnen, vorbehaltlich der Nutzungsbedingungen jedes KI-Modellanbieters.",
          "Die Warenzeichen, Logos, Interface-Designs und Softwarecodes der Plattform sind durch geistige Eigentumsgesetze geschützt und dürfen nicht ohne Genehmigung verwendet werden."
        ]
      },
      {
        "title": "5. Zahlung und Rückerstattung",
        "paragraphs": [
          "Alle Zahlungen erfolgen in US-Dollar. Die Abonnementgebühren werden monatlich oder jährlich berechnet, je nach gewähltem Plan.",
          "Bei Erstkauf von Einmalketten oder erstem Abonnement können Rückerstattungen innerhalb von 7 Kalendertagen beantragt werden, wenn die Credit-Nutzung unter 3% liegt."
        ]
      },
      {
        "title": "6. Haftungsausschluss",
        "paragraphs": [
          "Die Plattform bietet Dienste \"wie besehen\" und übernimmt keine ausdrücklichen oder stillschweigenden Garantien bezüglich der Verfügbarkeit, Genauigkeit oder Eignung der Dienste.",
          "KI-generierte Inhalte können ungenau oder unvollkommen sein. Benutzer sollten die Anwendbarkeit der generierten Inhalte selbst beurteilen."
        ]
      },
      {
        "title": "7. Haftungsbeschränkung",
        "paragraphs": [
          "Im maximal zulässigen Umfang des Gesetzes ist die Plattform nicht haftbar für direkte, indirekte, zufällige oderFolgeschäden, die aus der Nutzung oder Unfähigkeit zur Nutzung der Dienste entstehen.",
          "Die Gesamthaftung der Plattform übersteigt nicht die Gesamtgebühren, die Sie in den letzten 12 Monaten gezahlt haben."
        ]
      },
      {
        "title": "8. Änderung der Bedingungen",
        "paragraphs": [
          "Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Geänderte Bedingungen werden wirksam, wenn sie auf dieser Seite veröffentlicht werden.",
          "Die fortgesetzte Nutzung der Plattform zeigt die Annahme der geänderten Bedingungen an. Wesentliche Änderungen werden per E-Mail oder Plattformbenachrichtigung mitgeteilt."
        ]
      },
      {
        "title": "9. Kontaktieren Sie uns",
        "paragraphs": [
          "Wenn Sie Fragen zu diesen Bedingungen haben, kontaktieren Sie uns unter miral_support@miralvis.com."
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ Vertrauen & Sicherheit",
    "title": "Ihre Datensicherheit ist unsere oberste Priorität",
    "subtitle": "Erfahren Sie, wie wir Ihren Datenschutz und Ihre Datensicherheit schützen.",
    "badges": [
      {
        "icon": "🛡️",
        "title": "Kein KI-Training",
        "desc": "Ihre hochgeladenen Inhalte und generierten Werke werden nie zum Trainieren von KI-Modellen verwendet."
      },
      {
        "icon": "🔒",
        "title": "Ende-zu-Ende-Verschlüsselung",
        "desc": "Alle Datenübertragungen verwenden TLS 1.3-Verschlüsselung, gespeicherte Daten verwenden AES-256-Verschlüsselung."
      },
      {
        "icon": "✓",
        "title": "DSGVO-konform",
        "desc": "Vollständig konform mit den Anforderungen der EU-Datenschutz-Grundverordnung."
      },
      {
        "icon": "🗑️",
        "title": "Selbst Datenkontrolle",
        "desc": "Sie können alle Ihre Daten jederzeit exportieren oder löschen, einschließlich Kontolöschung."
      }
    ],
    "sections": [
      {
        "title": "Transparenz der Datenverarbeitung",
        "paragraphs": [
          "Wir sind völlig transparent darüber, wie wir mit Daten umgehen. Bilder und Videos, die Sie hochladen, werden nur verwendet, um die von Ihnen angeforderten Inhalte zu generieren und werden innerhalb von 24 Stunden nach der Verarbeitung von den Servern gelöscht.",
          "Generierte Inhalte werden in Ihrem Konto gespeichert, und Sie können sie jederzeit herunterladen oder löschen. Wir teilen Ihre Inhalte nicht ohne Ihre Zustimmung."
        ]
      },
      {
        "title": "Sichere Infrastruktur",
        "paragraphs": [
          "Unsere Dienste werden auf weltweit führender Cloud-Infrastruktur mit mehrschichtigem Schutz eingesetzt. Alle Server befinden sich in SOC 2- und ISO 27001-zertifizierten Rechenzentren.",
          "Wir führen regelmäßige Sicherheitsaudits und Penetrationstests durch, um die Systemsicherheit zu gewährleisten. Alle Mitarbeiter erhalten strenges Sicherheitstraining."
        ]
      },
      {
        "title": "Inhaltssicherheit",
        "paragraphs": [
          "Wir setzen fortschrittliche Inhaltssicherheitssysteme ein, die schädliche Inhaltserstellung automatisch erkennen und blockieren. Dies umfasst但不限于 gewalttätige, pornografische und rechtsverletzende Inhalte.",
          "Wenn Sie verletzende Inhalte feststellen, melden Sie diese bitte unter abuse@miral.org."
        ]
      },
      {
        "title": "Konformität & Zertifizierung",
        "paragraphs": [
          "Wir halten wichtige globale Datenschutzvorschriften ein, einschließlich DSGVO (EU), CCPA (Kalifornien) und LGPD (Brasilien).",
          "Unsere Zahlungsabwicklung hält PCI-DSS-Standards ein, um sicherzustellen, dass Ihre Zahlungsinformationen sicher sind."
        ]
      }
    ],
    "ctaTitle": "Sicherheitsbedenken?",
    "ctaDesc": "Unser Sicherheitsteam ist bereit, Ihre Fragen zu beantworten",
    "ctaButton": "Sicherheitsteam kontaktieren",
    "navTerms": "Nutzungsbedingungen →",
    "navPrivacy": "Datenschutzrichtlinie →"
  },
  "gallery": {
    "tag": "Erstellungshistorie",
    "title": "Meine Kreationen",
    "subtitle": "Sehen Sie alle Ihre KI-Erstellungshistorie.",
    "loginRequired": "Bitte melden Sie sich an, um Ihre Erstellungshistorie anzuzeigen",
    "empty": "Noch keine Kreationen",
    "loadMore": "Mehr laden",
    "filters": {
      "all": "Alle",
      "pending": "Verarbeitung",
      "finish": "Abgeschlossen",
      "failed": "Fehlgeschlagen"
    },
    "usePrompt": "Mit diesem Prompt generieren",
    "download": "Herunterladen",
    "status": {
      "pending": "Verarbeitung",
      "finish": "Abgeschlossen",
      "failed": "Fehlgeschlagen"
    }
  },
  "inspiration": {
    "title": "Inspiration",
    "subtitle": "Sehen Sie, was Creators mit Miral bauen — von hyper-realistischen Bildern bis zu filmischen Videos, Inspiration auf Fingertipp.",
    "filters": {
      "all": "Alle",
      "image": "Bild",
      "video": "Video",
      "portrait": "Porträt",
      "landscape": "Landschaft",
      "fantasy": "Fantasie",
      "anime": "Anime"
    }
  },
  "profile": {
    "joinTime": "Beigetreten",
    "tabs": {
      "account": "Konto",
      "billing": "Abrechnung",
      "privacy": "Daten & Datenschutz"
    },
    "balance": {
      "title": "Guthabenübersicht",
      "available": "Verfügbare Credits"
    },
    "subscription": {
      "currentPlan": "Aktueller Plan",
      "status": "Status",
      "activated": "Aktiviert",
      "cancelled": "Kündigt am Ende der aktuellen Abrechnungsperiode",
      "pending": "Verarbeitung",
      "failed": "Zahlung fehlgeschlagen",
      "expiryDate": "Gültig bis",
      "permanent": "Permanent",
      "upgradePlan": "Upgrade oder Plan ändern",
      "cancelPlan": "Abonnement kündigen",
      "cancelNote": "Ihr Abonnement bleibt bis zum Ende der aktuellen Abrechnungsperiode aktiv",
      "cancelWarning": "Ihr Abonnement wird gekündigt. Sie können alle Funktionen weiterhin nutzen bis",
      "restorePlan": "Abonnement fortsetzen"
    },
    "upgrade": {
      "title": "Upgrade",
      "desc": "Erhalten Sie unbegrenzten Zugang und exklusive Vorteile",
      "btn": "Pläne anzeigen"
    },
    "billing": {
      "title": "Zahlungshistorie",
      "subtitle": "Sehen Sie Ihre Zahlungsaufzeichnungen und laden Sie Rechnungen herunter",
      "empty": "Noch keine Abrechnungsaufzeichnungen",
      "creditsPack": "Credits-Paket",
      "oneTime": "Einmalig",
      "monthly": "Monatlich",
      "yearly": "Jährlich",
      "refresh": "Aktualisieren",
      "plan": "Plan",
      "date": "Datum",
      "amount": "Betrag",
      "invoice": "Rechnung",
      "download": "Herunterladen",
      "invoiceModal": {
        "title": "Rechnungsdetails",
        "orderInfo": "Bestellinformationen",
        "invoiceInfo": "Rechnungsinformationen",
        "plan": "Plan",
        "date": "Zahlungsdatum",
        "amount": "Betrag",
        "paymentId": "Bestell-ID",
        "close": "Schließen",
        "download": "Rechnung herunterladen",
        "fullName": "Vollständiger Name",
        "fullNamePlaceholder": "Geben Sie Ihren vollständigen Namen ein",
        "email": "E-Mail",
        "emailPlaceholder": "Geben Sie Ihre E-Mail ein",
        "company": "Unternehmen",
        "companyPlaceholder": "Rechtlicher Name des Unternehmens",
        "taxId": "Steuer-ID",
        "taxIdPlaceholder": "Steuer-ID eingeben",
        "addressLine1": "Adresszeile 1",
        "addressLine1Placeholder": "Straßenadresse",
        "addressLine2": "Adresszeile 2",
        "addressLine2Placeholder": "Wohnung, Suite etc. (optional)",
        "city": "Stadt",
        "cityPlaceholder": "Stadt",
        "province": "Provinz",
        "provincePlaceholder": "Provinz",
        "postalCode": "Postleitzahl",
        "postalCodePlaceholder": "Postleitzahl",
        "country": "Land",
        "countryPlaceholder": "Land",
        "invoiceRemarks": "Bemerkungen",
        "invoiceRemarksPlaceholder": "Rechnungsbemerkungen",
        "optional": "optional",
        "required": "Dieses Feld ist erforderlich"
      }
    },
    "privacy": {
      "title": "Datenschutzeinstellungen",
      "cardTitle": "Ihre Daten sind geschützt",
      "cardSubtitle": "Unser Engagement für Ihren Datenschutz und Ihre Datensicherheit",
      "item1": "Ihre Daten werden nie zum Trainieren von KI-Modellen verwendet",
      "item2": "Datenübertragung und -speicherung sind vollständig verschlüsselt",
      "item3": "Generierte Werke werden nach der Speicherzeit automatisch gelöscht",
      "item4": "Keine Feedback-Schleifen, keine sekundäre Nutzung abgeleiteter Daten",
      "item5": "Strikte Einhaltung der Datenschutzvorschriften"
    },
    "support": {
      "title": "Hilfe benötigt?",
      "desc": "Unser Support-Team ist hier, um zu helfen",
      "btn": "Support kontaktieren",
      "note": "miral_support@miralvis.com · Antwort innerhalb von 24 Stunden"
    }
  },
  "payment": {
    "success": {
      "title": "Zahlung erfolgreich",
      "message": "Vielen Dank für Ihren Kauf! Ihre Bestellung wurde erfolgreich verarbeitet und Credits wurden Ihrem Konto hinzugefügt.",
      "goHome": "Zur Startseite",
      "viewProfile": "Profil anzeigen"
    },
    "cancel": {
      "title": "Zahlung abgebrochen",
      "message": "Ihre Zahlung wurde abgebrochen. Wenn Sie Fragen haben, zögern Sie nicht, unser Support-Team zu kontaktieren.",
      "tryAgain": "Erneut versuchen",
      "goHome": "Zur Startseite"
    }
  },
  "modelIntro": {
    "common": {
      "videoMode": "Videomodus",
      "textToVideo": "Text zu Video",
      "imageToVideo": "Bild zu Video",
      "referenceImage": "Referenzbild",
      "referenceAudio": "Referenz-Audio",
      "negativePrompt": "Negativer Prompt",
      "duration": "Dauer",
      "resolution": "Auflösung",
      "aspectRatio": "Seitenverhältnis",
      "seed": "Seed",
      "generateAudio": "Audio generieren",
      "watermark": "Wasserzeichen hinzufügen",
      "endFrame": "Endframe",
      "promptEnhance": "Prompt verbessern",
      "promptExtend": "Prompt erweitern",
      "imageSize": "Bildgröße",
      "imageCount": "Anzahl der Bilder",
      "style": "Stil",
      "sizeMode": "Größenmodus",
      "width": "Breite",
      "height": "Höhe",
      "optional": "Optional",
      "uploading": "Hochladen...",
      "clickToUpload": "Klicken zum Hochladen",
      "quality": "Qualität",
      "qualityAuto": "Auto",
      "qualityLow": "Niedrig",
      "qualityMedium": "Mittel",
      "qualityHigh": "Hoch",
      "multipleOf64Hint": "Breite und Höhe müssen Vielfache von 64 sein."
    },
    "seegen": {
      "aspectAdaptive": "Auto",
      "genMode": "Generierungsmodus",
      "modeStand": "Standard",
      "modeSpeed": "Schnell"
    },
    "pollodance": {
      "variantLabel": "Modellvariante",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "Fortschrittliche Bewegungssteuerung, filmischer Stiltransfer und industrielle Videogenerierung.",
      "opt20FastDesc": "Schnelle Generierung mit geringer Latenz.",
      "opt20RefDesc": "Video-Referenzen, Stiltransfer und Subjekt-Tracking.",
      "opt20FastRefDesc": "Geschwindigkeit plus präzise Referenzsteuerung.",
      "refImages": "Referenzbilder (mehrere)",
      "refVideo": "Referenzvideo",
      "refAudio": "Referenz-Audio",
      "webSearch": "Websuche"
    },
    "nanoBanana": {
      "version": "Modellversion",
      "title": "Nano Banana Pro KI-Bild-Generator",
      "desc": "Nano Banana ist ein Hochleistungs-KI-Bildgenerierungsmodell, das realistische Bildgenerierung unterstützt und sich auf Porträts und natürliche Szenen spezialisiert. Verfügbar in Standard- und Pro-Versionen für unterschiedliche Bedürfnisse.",
      "v25Type": "Niedrige Latenz",
      "v25TypeBadge": "Schnell",
      "v25TypeDesc": "Feste 1024px Auflösung, schnelle Generierung",
      "v31Type": "Hohe Wiedergabetreue",
      "v31TypeBadge": "Hohe Qualität",
      "v31TypeDesc": "Unterstützt 1K/2K/4K Mehrfachauflösungen",
      "demoPrompt": "Kinematografisches Porträt, Golden Hour Licht, natürliche Hauttextur, weicher Bokeh-Hintergrund",
      "enterPrompt": "Bitte geben Sie einen Prompt ein",
      "generateFailed": "Erstellung fehlgeschlagen",
      "requestFailed": "Anfrage fehlgeschlagen, bitte versuchen Sie es erneut",
      "multiSize": "Multiple Sizes",
      "multiSizeDesc": "Supports auto, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 and other image sizes.",
      "featuresDesc": "Nano Banana provides high-quality image generation capabilities with multiple size and resolution options.",
      "flexiblePricing": "Flexible Pricing",
      "flexiblePricingDesc": "Standard 5 credits, Pro 20 credits, choose as needed.",
      "commercial": "Commercial License",
      "commercialDesc": "All generated images can be used for commercial purposes.",
      "faq": [
        {
          "q": "What's the difference between Standard and Pro versions?",
          "a": "Standard version is suitable for quick generation of standard quality images, consuming 5 credits. Pro version supports higher resolutions (1K/2K/4K) with better image quality, consuming 20 credits."
        },
        {
          "q": "How does Nano Banana work?",
          "a": "Simply enter a text description, and the Nano Banana model will generate high-quality realistic style images based on your prompt."
        },
        {
          "q": "What image sizes are supported?",
          "a": "Supports auto, 1:1 (square), 4:3, 3:4, 16:9 (landscape), 9:16 (portrait), 3:2, 2:3 and other sizes."
        },
        {
          "q": "Can generated images be used commercially?",
          "a": "Yes, all content generated using Nano Banana can be used for commercial purposes."
        }
      ]
    },
    "nanoBanana2": {
      "genType": "Generierungsversion"
    },
    "seedream": {
      "title": "Seedream 4 KI-Bild-Generator",
      "desc": "Seedream 4 ist ein fortschrittliches KI-Bildgenerierungsmodell, das sich auf künstlerische und kreative Bilder spezialisiert. Perfekt für Illustrationen, Konzeptkunst und stilisierte Visuelles.",
      "features": [
        {
          "icon": "🎨",
          "title": "Künstlerischer Stil",
          "desc": "Erstellen Sie atemberaubende künstlerische Bilder mit verschiedenen Mal- und Illustrationsstilen."
        },
        {
          "icon": "🖼️",
          "title": "Hohe Auflösung",
          "desc": "Unterstützt Auflösung bis zu 4K für detaillierte Kunstwerke."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Die meisten Bilder innerhalb von 15 Sekunden erstellt."
        },
        {
          "icon": "🎭",
          "title": "Stilübertragung",
          "desc": "Wenden Sie verschiedene künstlerische Stile auf Ihre Kreationen an."
        },
        {
          "icon": "📐",
          "title": "Mehrere Größen",
          "desc": "Unterstützt verschiedene Seitenverhältnisse für unterschiedliche Bedürfnisse."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Bilder können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wofür ist Seedream 4 am besten?",
          "a": "Seedream 4 glänzt in der Erstellung von künstlerischen und kreativen Bildern, einschließlich Illustrationen, Konzeptkunst und stilisierten Visuelles."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Seedream 4 kostet 8 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Welche Stile werden unterstützt?",
          "a": "Seedream 4 unterstützt verschiedene künstlerische Stile einschließlich Ölgemälde, Aquarell, digitale Kunst, Anime und mehr."
        },
        {
          "q": "Können erstellte Bilder kommerziell genutzt werden?",
          "a": "Ja, alle mit Seedream 4 erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "webSearch": "Web Search",
      "webSearchDesc": "Enable web search for more accurate reference information",
      "watermark": "Add watermark",
      "watermarkDesc": "Add watermark to generated images",
      "sizeModeResolution": "By resolution",
      "sizeModeCustom": "Custom size",
      "customWidth": "Width",
      "customHeight": "Height",
      "sizeHint": "Area 1024×1024–4096×4096, aspect ratio 1/16–16",
      "sizeErrorArea": "Area must be between 1024×1024 and 4096×4096",
      "sizeErrorRatio": "Aspect ratio must be between 1/16 and 16",
      "demoPromptExample": "Afternoon side light illuminates the camping tent, with the rough texture of the tent canvas clearly visible. A German Shepherd lies inside; its owner squats down to shake hands with it."
    },
    "midjourney": {
      "title": "Midjourney KI-Bild-Generator",
      "desc": "Midjourney ist ein führendes KI-Bildgenerierungsmodell, bekannt für seine außergewöhnliche künstlerische Qualität und kreative Fähigkeiten. Perfekt für professionelle Kunstwerke und kreative Projekte.",
      "referenceBoxTitle": "Add reference images for image-to-image",
      "referenceBoxSubtitle": "Supports PNG, JPEG, WEBP (max 100KB). Up to 5 images. Fewer images, more precise results.",
      "demoPrompt": "A mystical floating island in the sky, ancient ruins covered in glowing crystals, waterfalls cascading into clouds below, ethereal lighting, fantasy art style",
      "referenceImages": "Reference images",
      "referenceImagesCount": "Up to 5",
      "refImageMaxSize": "Each image must not exceed 100KB",
      "style": "Style",
      "styleRealistic": "Realistic",
      "styleAnime": "Anime",
      "generationSpeed": "Generation Speed",
      "fastDesc": "Standard speed generation",
      "turboDesc": "Fast generation, priority processing",
      "creative": "Creative",
      "highQuality": "High Quality",
      "fastTurbo": "Fast/Turbo",
      "creativeGeneration": "Creative Generation",
      "speed": "Speed",
      "features": [
        {
          "icon": "🎨",
          "title": "Artistic Excellence",
          "desc": "Industry-leading artistic quality and creative output."
        },
        {
          "icon": "🖼️",
          "title": "High Resolution",
          "desc": "Generate high-quality images suitable for professional use."
        },
        {
          "icon": "🎭",
          "title": "Unique Styles",
          "desc": "Distinctive artistic styles that set your work apart."
        },
        {
          "icon": "⚡",
          "title": "Fast Generation",
          "desc": "Most images generated within 20 seconds."
        },
        {
          "icon": "📐",
          "title": "Multiple Sizes",
          "desc": "Support various aspect ratios and resolutions."
        },
        {
          "icon": "💼",
          "title": "Commercial License",
          "desc": "All generated images can be used for commercial purposes."
        }
      ],
      "faq": [
        {
          "q": "What's the difference between Fast and Turbo?",
          "a": "Fast mode costs 10 credits with standard speed. Turbo mode costs 20 credits with faster generation and priority processing."
        },
        {
          "q": "How does Midjourney work?",
          "a": "Simply enter a text description, and Midjourney will generate artistic images based on your prompt."
        },
        {
          "q": "What image sizes are supported?",
          "a": "Supports 1:1 (square), 4:3, 3:4, 16:9 (landscape), 9:16 (portrait), 3:2, 2:3 and other sizes."
        },
        {
          "q": "Can generated images be used commercially?",
          "a": "Yes, all content generated using Midjourney can be used for commercial purposes."
        }
      ]
    },
    "gptImage": {
      "title": "GPT-Image-1 KI-Bild-Generator",
      "desc": "GPT-Image-1 ist OpenAIs vielseitiges Bildgenerierungsmodell, das eine Vielzahl von Bildern aus Textbeschreibungen erstellen kann. Ideal für die Allzweck-Bildgenerierung.",
      "demoPromptExample": "Tuscan fields at dusk, rolling hills covered in golden wheat, cypress trees and an old stone farmhouse in the distance, the sunset casting a warm red glow across the sky, warm, healing, landscape photography, golden hour.",
      "imageCount": "Image Count",
      "promptEnhance": "Prompt Enhance",
      "promptEnhanceDesc": "Automatically optimize prompts for better generation results",
      "count": "Count",
      "multiPurpose": "Multi-purpose",
      "batchGeneration": "Batch Generation",
      "size1024Square": "1024×1024 (square)",
      "size1536Landscape": "1536×1024 (landscape)",
      "size1024Portrait": "1024×1536 (portrait)",
      "threeSizes": "Three fixed sizes",
      "tagQuality": "High quality",
      "tagCommercialShort": "Commercial use",
      "features": [
        {
          "icon": "🎨",
          "title": "Versatile Generation",
          "desc": "Create a wide variety of images for any purpose."
        },
        {
          "icon": "🖼️",
          "title": "High Quality",
          "desc": "Generate high-quality images with accurate details."
        },
        {
          "icon": "⚡",
          "title": "Fast Generation",
          "desc": "Most images generated within 15 seconds."
        },
        {
          "icon": "📝",
          "title": "Text Understanding",
          "desc": "Excellent understanding of complex text descriptions."
        },
        {
          "icon": "📐",
          "title": "Three fixed sizes",
          "desc": "1024×1024 (square), 1536×1024 (landscape), 1024×1536 (portrait)."
        },
        {
          "icon": "💼",
          "title": "Commercial License",
          "desc": "All generated images can be used for commercial purposes."
        }
      ],
      "faq": [
        {
          "q": "How does GPT-Image-1 work?",
          "a": "Simply enter a text description, and GPT-Image-1 will generate high-quality images based on your prompt."
        },
        {
          "q": "What image sizes are supported?",
          "a": "Supports three fixed sizes: 1024×1024 (square), 1536×1024 (landscape), and 1024×1536 (portrait)."
        },
        {
          "q": "Can generated images be used commercially?",
          "a": "Yes, all content generated using GPT-Image-1 can be used for commercial purposes."
        }
      ]
    },
    "gptImage15": {
      "title": "GPT-Image-1.5 KI-Bild-Generator",
      "desc": "GPT-Image-1.5 ist OpenAIs vielseitiges Bildgenerierungsmodell, das eine Vielzahl von Bildern aus Textbeschreibungen erstellen kann. Ideal für die Allzweck-Bildgenerierung.",
      "demoPromptExample": "Tuscan fields at dusk, rolling hills covered in golden wheat, cypress trees and an old stone farmhouse in the distance, the sunset casting a warm red glow across the sky, warm, healing, landscape photography, golden hour.",
      "imageCount": "Image Count",
      "promptEnhance": "Prompt Enhance",
      "promptEnhanceDesc": "Automatically optimize prompts for better generation results",
      "count": "Count",
      "multiPurpose": "Multi-purpose",
      "batchGeneration": "Batch Generation",
      "size1024Square": "1024×1024 (square)",
      "size1536Landscape": "1536×1024 (landscape)",
      "size1024Portrait": "1024×1536 (portrait)",
      "threeSizes": "Three fixed sizes",
      "tagQuality": "High quality",
      "tagCommercialShort": "Commercial use",
      "features": [
        {
          "icon": "🎨",
          "title": "Versatile Generation",
          "desc": "Create a wide variety of images for any purpose."
        },
        {
          "icon": "🖼️",
          "title": "High Quality",
          "desc": "Generate high-quality images with accurate details."
        },
        {
          "icon": "⚡",
          "title": "Fast Generation",
          "desc": "Most images generated within 15 seconds."
        },
        {
          "icon": "📝",
          "title": "Text Understanding",
          "desc": "Excellent understanding of complex text descriptions."
        },
        {
          "icon": "📐",
          "title": "Three fixed sizes",
          "desc": "1024×1024 (square), 1536×1024 (landscape), 1024×1536 (portrait)."
        },
        {
          "icon": "💼",
          "title": "Commercial License",
          "desc": "All generated images can be used for commercial purposes."
        }
      ],
      "faq": [
        {
          "q": "How does GPT-Image-1.5 work?",
          "a": "Simply enter a text description, and GPT-Image-1.5 will generate high-quality images based on your prompt."
        },
        {
          "q": "What image sizes are supported?",
          "a": "Supports three fixed sizes: 1024×1024 (square), 1536×1024 (landscape), and 1024×1536 (portrait)."
        },
        {
          "q": "Can generated images be used commercially?",
          "a": "Yes, all content generated using GPT-Image-1.5 can be used for commercial purposes."
        }
      ]
    },
    "fluxKontext": {
      "title": "Flux Kontext KI-Bild-Generator",
      "desc": "Eine junge Frau sitzt auf einem Dach zum goldenen Stunde, trägt eine übergroße Denimjacke, weiße Kopfhörer um den Hals, trinkt Eiskaffee aus einem klaren Plastikbecher.",
      "imageCount": "Image Count",
      "count": "Count",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "demoPrompt2": "A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.",
      "demoPrompt3": "A young mother adjusting her baby's beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.",
      "highQuality": "High Quality",
      "fastGen": "Fast Generation",
      "multiSize": "Multiple Sizes",
      "outputStyle": "Output Style",
      "outputStyleDesc": {
        "auto": "Default — the model automatically determines the style, no forced look",
        "photographic": "Photographic — realistic photos, natural light and shadows",
        "digital_art": "Digital Art — CG/illustration look, vivid and rich colors",
        "anime": "Anime — Japanese anime/cartoon style, clean lines"
      },
      "outputStyleLabel": {
        "auto": "Default",
        "photographic": "Photographic",
        "digital_art": "Digital Art",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "High Quality Output",
          "desc": "Generate detailed, high-fidelity images."
        },
        {
          "icon": "🎨",
          "title": "Text to Image",
          "desc": "Accurately generate images from text descriptions."
        },
        {
          "icon": "⚡",
          "title": "Fast Generation",
          "desc": "Most images complete in around 15 seconds."
        },
        {
          "icon": "📐",
          "title": "Multiple Sizes",
          "desc": "Support for 1:1, 3:2, 2:3 aspect ratios."
        },
        {
          "icon": "💼",
          "title": "Commercial License",
          "desc": "Generated images can be used for commercial purposes."
        }
      ],
      "faq": [
        {
          "q": "How does Flux Kontext work?",
          "a": "Enter a text description; Flux Kontext generates high-quality images and supports single or multiple images per request."
        },
        {
          "q": "What image sizes are supported?",
          "a": "Supports 1:1 (square), 3:2 (landscape), 2:3 (portrait)."
        },
        {
          "q": "Can I generate multiple images at once?",
          "a": "Yes, you can generate 1–3 images, each billed separately."
        },
        {
          "q": "Can generated images be used commercially?",
          "a": "Yes, content generated with Flux Kontext can be used for commercial purposes."
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Flux Pro 1.1 Ultra KI-Bild-Generator",
      "desc": "Flux Pro 1.1 Ultra für hochwertige Text-zu-Bild mit mehreren Seitenverhältnissen und Batch-Erstellung.",
      "features": [
        {
          "icon": "✨",
          "title": "Hohe Qualität",
          "desc": "Erstellen Sie detaillierte, hochgetreue Bilder."
        },
        {
          "icon": "🎨",
          "title": "Text zu Bild",
          "desc": "Erstellen Sie genau Bilder aus Textbeschreibungen."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Die meisten Bilder完成 in etwa 15 Sekunden."
        },
        {
          "icon": "📐",
          "title": "Mehrere Größen",
          "desc": "Unterstützung für 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Erstellte Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Flux Pro 1.1 Ultra?",
          "a": "Geben Sie eine Textbeschreibung ein, um hochwertige Bilder zu erstellen; unterstützt 1–4 Bilder pro Anfrage."
        },
        {
          "q": "Welche Bildgrößen werden unterstützt?",
          "a": "Unterstützt 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "Kann ich mehrere Bilder gleichzeitig erstellen?",
          "a": "Ja, Sie können 1–4 Bilder erstellen, jedes separat berechnet."
        },
        {
          "q": "Können erstellte Bilder kommerziell genutzt werden?",
          "a": "Ja, Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "imageCount": "Image Count",
      "count": "Count",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "demoPrompt2": "A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.",
      "demoPrompt3": "A young mother adjusting her baby's beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.",
      "highQuality": "High Quality",
      "fastGen": "Fast Generation",
      "multiSize": "Multiple Sizes",
      "outputStyle": "Output Style",
      "outputStyleDesc": {
        "auto": "Default — the model automatically determines the style, no forced look",
        "photographic": "Photographic — realistic photos, natural light and shadows",
        "digital_art": "Digital Art — CG/illustration look, vivid and rich colors",
        "anime": "Anime — Japanese anime/cartoon style, clean lines"
      },
      "outputStyleLabel": {
        "auto": "Default",
        "photographic": "Photographic",
        "digital_art": "Digital Art",
        "anime": "Anime"
      }
    },
    "fluxSchnell": {
      "title": "Flux Schnell KI-Bild-Generator",
      "desc": "Flux Schnell für schnelle Text-zu-Bild mit mehreren Seitenverhältnissen und Batch-Erstellung.",
      "features": [
        {
          "icon": "✨",
          "title": "Hohe Qualität",
          "desc": "Erstellen Sie detaillierte, hochgetreue Bilder."
        },
        {
          "icon": "🎨",
          "title": "Text zu Bild",
          "desc": "Erstellen Sie genau Bilder aus Textbeschreibungen."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Die meisten Bilder完成 in etwa 15 Sekunden."
        },
        {
          "icon": "📐",
          "title": "Mehrere Größen",
          "desc": "Unterstützung für 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Erstellte Bilder können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Flux Schnell?",
          "a": "Geben Sie eine Textbeschreibung ein, um schnell hochwertige Bilder zu erstellen; unterstützt 1–4 Bilder pro Anfrage."
        },
        {
          "q": "Welche Bildgrößen werden unterstützt?",
          "a": "Unterstützt 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "Kann ich mehrere Bilder gleichzeitig erstellen?",
          "a": "Ja, Sie können 1–4 Bilder erstellen, jedes separat berechnet."
        },
        {
          "q": "Können erstellte Bilder kommerziell genutzt werden?",
          "a": "Ja, Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "imageCount": "Image Count",
      "count": "Count",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "demoPrompt2": "A man in his 20s sitting on a messy art studio floor, surrounded by unfinished canvases and paint tubes. He wears a white tank top stained with color, and ripped jeans.",
      "demoPrompt3": "A young mother adjusting her baby's beanie while seated on a picnic blanket. She wears a cream sweater and long corduroy skirt, barefoot on the grass.",
      "highQuality": "High Quality",
      "fastGen": "Fast Generation",
      "multiSize": "Multiple Sizes",
      "outputStyle": "Output Style",
      "outputStyleDesc": {
        "auto": "Default — the model automatically determines the style, no forced look",
        "photographic": "Photographic — realistic photos, natural light and shadows",
        "digital_art": "Digital Art — CG/illustration look, vivid and rich colors",
        "anime": "Anime — Japanese anime/cartoon style, clean lines"
      },
      "outputStyleLabel": {
        "auto": "Default",
        "photographic": "Photographic",
        "digital_art": "Digital Art",
        "anime": "Anime"
      }
    },
    "flux2": {
      "title": "FLUX.2 KI-Bildgenerator",
      "desc": "FLUX.2 bietet Enterprise-Effizienz und professionelle Präzision für Text-zu-Bild-Generierung mit fotorealistischen Details.",
      "variantLabel": "Modellvariante",
      "variantDesc": {
        "klein-04": "Echtzeit",
        "klein-09": "Ausgeglichen",
        "max": "Höchste Qualität",
        "pro": "Produktion",
        "flex": "Anpassbar"
      },
      "promptUpsampling": "Prompt-Upsampling",
      "promptUpsamplingHint": "Verbessert Prompt-Details für reichhaltigere Ausgabe (nicht für Klein verfügbar).",
      "steps": "Schritte",
      "stepsHint": "Mehr Schritte = mehr Details, aber langsamer. Nur Flex-Variante.",
      "guidance": "Guidance",
      "guidanceHint": "Steuert, wie nah die Ausgabe dem Prompt folgt. Nur Flex-Variante.",
      "tagPhotorealism": "Fotorealismus",
      "tagMultilingual": "Mehrsprachig",
      "tagVariants": "5 Varianten",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "features": [
        { "icon": "✨", "title": "Fotorealistische Details", "desc": "Hände, Gesichter, Stoffe, Logos und kleine Objekte präzise bis 4MP." },
        { "icon": "🎨", "title": "Typografie und Design", "desc": "Klare, lesbare Typografie und komplexe Layout-Anweisungen." },
        { "icon": "🌍", "title": "Mehrsprachig", "desc": "Native Prompt-Unterstützung in Ihrer Sprache mit fortschrittlichem Instruction-Following." },
        { "icon": "🎯", "title": "5 Modellvarianten", "desc": "Klein 4B/9B (Geschwindigkeit), Max (Qualität), Pro (Produktion), Flex (benutzerdefiniert)." },
        { "icon": "⚙️", "title": "Flexible Steuerung", "desc": "Schritte, Guidance, Größe und Sicherheitstoleranz anpassbar." }
      ],
      "faq": [
        { "q": "Welche FLUX.2-Varianten gibt es?", "a": "FLUX.2 bietet 5 Varianten: Klein 4B und 9B (schnell), Max (höchste Qualität mit Grounding-Suche), Pro (Produktion), Flex (Schritte und Guidance anpassbar)." },
        { "q": "Welche Bildgrößen werden unterstützt?", "a": "FLUX.2 verwendet Pixelabmessungen (Breite x Höhe), Vielfache von 16. Presets: 1:1, 4:3, 3:4, 16:9, 9:16, 21:9, 9:21." },
        { "q": "Was ist Prompt-Upsampling?", "a": "Verbessert den Prompt intern für mehr Details. Verfügbar für Max, Pro und Flex (nicht Klein)." },
        { "q": "Was sind Schritte und Guidance im Flex-Modus?", "a": "Schritte (1-50): Inferenzqualität, höher = mehr Details. Guidance (1.5-10): Prompt-Treue, höher = näher an der Beschreibung." },
        { "q": "Können generierte Bilder kommerziell genutzt werden?", "a": "Ja, generierte Inhalte können kommerziell genutzt werden." }
      ]
    },
    "veo": {
      "title": "Veo 3.1 KI-Video-Generator",
      "desc": "Google Veo 3.1 ist ein modernes KI-Videomodell mit nativer Audiogenerierung, ultra-hoher Auflösung und langer Videokreation. Perfekt für professionelle Videoproduktion.",
      "features": [
        {
          "icon": "🎬",
          "title": "Native Audiogenerierung",
          "desc": "Synchron erstellen von Video und Audio, einschließlich Dialog und Soundeffekte."
        },
        {
          "icon": "📺",
          "title": "Ultra HD Auflösung",
          "desc": "Unterstützt Auflösung bis zu 4K für professionelle Videoproduktion."
        },
        {
          "icon": "⏱️",
          "title": "Langes Video",
          "desc": "Erstellen Sie Videos bis zu 2 Minuten Länge, geeignet für verschiedene kreative Bedürfnisse."
        },
        {
          "icon": "🎥",
          "title": "Filmische Bewegung",
          "desc": "Professionelle Kamerabewegungen und sanfte Übergänge."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Optimierte Inferenz-Engine für schnelle Produktion."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Was ist der Unterschied zwischen Fast- und Quality-Typ?",
          "a": "Fast-Typ ist schneller und kosteneffizienter, geeignet für schnelle Iteration. Quality-Typ liefert reichere Details und sanftere Bewegung, ideal für endgültige Output."
        },
        {
          "q": "Wie funktioniert Veo 3.1?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Veo 3.1 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen, optional mit synchronisiertem Audio."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Veo 3.1 kostet 30 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Welche Auflösungen und Dauer werden unterstützt?",
          "a": "Unterstützt 720p- und 1080p-Auflösungen, mit Dauer von 5s, 10s und bis zu 2 Minuten für längere Videos."
        }
      ],
      "fastType": "Fast Type",
      "fastTypeBadge": "Fast speed, lower cost",
      "fastTypeDesc": "(Supports 16:9 reference images)",
      "qualityType": "Quality Type",
      "qualityTypeBadge": "Richer details",
      "qualityTypeDesc": "Smoother motion. End frame is optional for image mode to control the last frame.",
      "imageMode": "Generation Mode",
      "startEndFrames": "Start/End Frames",
      "referenceImage": "Reference Image",
      "startFrame": "Start Frame",
      "startFrameHint": "Set the first frame. Video animates from this frame.",
      "uploadStartFrame": "Click to upload start frame",
      "endFrame": "End Frame",
      "endFrameHint": "Set the last frame. Video ends at this frame.",
      "uploadEndFrame": "Click to upload end frame",
      "negativePrompt": "Negative Prompt",
      "negativePromptPlaceholder": "Describe what you don't want in the video..."
    },
    "veo30": {
      "title": "Veo 3.0 KI-Video-Generator",
      "desc": "Google Veo 3.0 ist ein fortschrittliches KI-Videomodell, das Text-zu-Video und Bild-zu-Video unterstützt, mit 4s/6s/8s Dauer und 720p/1080p Ausgabe.",
      "features": [
        {
          "icon": "🎬",
          "title": "Native Audiogenerierung",
          "desc": "Synchron erstellen von Video und Audio, einschließlich Dialog und Soundeffekte."
        },
        {
          "icon": "📺",
          "title": "HD Auflösung",
          "desc": "Unterstützt 720p- und 1080p-Ausgabe für professionelle Videoproduktion."
        },
        {
          "icon": "⏱️",
          "title": "Mehrere Dauer",
          "desc": "Unterstützt 4s, 6s und 8s Videoerstellung."
        },
        {
          "icon": "🎥",
          "title": "Filmische Bewegung",
          "desc": "Professionelle Kamerabewegungen und sanfte Übergänge."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Optimierte Inferenz-Engine für schnelle Produktion."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Was ist der Unterschied zwischen Fast- und Quality-Typ?",
          "a": "Fast-Typ ist schneller und kosteneffizienter, geeignet für schnelle Iteration. Quality-Typ liefert reichere Details und sanftere Bewegung, ideal für endgültige Output."
        },
        {
          "q": "Wie funktioniert Veo 3.0?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Veo 3.0 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen, optional mit synchronisiertem Audio."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Veo 3.0 kostet 25 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Welche Auflösungen und Dauer werden unterstützt?",
          "a": "Unterstützt 720p- und 1080p-Auflösungen, mit Dauer von 4s, 6s oder 8s."
        }
      ],
      "fastType": "Fast Type",
      "fastTypeBadge": "Faster, lower cost",
      "fastTypeDesc": "(Supports 16:9 reference image)",
      "qualityType": "Quality Type",
      "qualityTypeBadge": "Richer details",
      "qualityTypeDesc": "Smoother motion. End frame in image mode is optional to control the last frame.",
      "imageMode": "Image Mode",
      "startEndFrames": "Start/End Frame",
      "referenceImage": "Reference Image",
      "referenceImageHint": "Upload a reference image; the video will be generated based on it.",
      "uploadReferenceImage": "Click to upload reference image",
      "startFrame": "Start Frame",
      "startFrameHint": "Set the first frame. Video animates from this frame.",
      "uploadStartFrame": "Click to upload start frame",
      "endFrame": "End Frame",
      "endFrameHint": "Set the last frame. Video ends at this frame.",
      "uploadEndFrame": "Click to upload end frame",
      "negativePrompt": "Negative Prompt",
      "negativePromptPlaceholder": "Describe what you don't want in the video...",
      "seedRangeError": "Seed must be an integer between 0 and 2147483647.",
      "duration": "Duration",
      "resolution": "Resolution",
      "demoPrompt": "A teenage girl sketching in a notebook at a café window, rain tapping on the glass..."
    },
    "veo31fast": {
      "title": "Veo 3.1 Fast KI-Video-Generator",
      "desc": "Google Veo 3.1 Fast für schnellere Erstellung, unterstützt Text-zu-Video und Bild-zu-Video mit optionalem Endbild, 4s/6s/8s Dauer und 720p/1080p/4K Ausgabe.",
      "features": [
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Optimiert für schnellere Output."
        },
        {
          "icon": "📺",
          "title": "4K Auflösung",
          "desc": "Unterstützt 720p, 1080p und 4K Ausgabe."
        },
        {
          "icon": "⏱️",
          "title": "Mehrere Dauer",
          "desc": "Unterstützt 4s, 6s und 8s Video."
        },
        {
          "icon": "🖼️",
          "title": "Optionales Endbild",
          "desc": "Bild-zu-Video kann ein Endbild hochladen, um das Ende zu steuern."
        },
        {
          "icon": "🎥",
          "title": "Filmische Bewegung",
          "desc": "Professionelle Kamerabewegungen und sanfte Übergänge."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Was ist der Unterschied zwischen Veo 3.1 Fast und Veo 3.1?",
          "a": "Veo 3.1 Fast ist für Geschwindigkeit und niedrigere Credit-Kosten optimiert, mit 4K und optionalem Endbild-Support."
        },
        {
          "q": "Was ist das Endbild?",
          "a": "Für Bild-zu-Video können Sie ein Endbild hochladen, damit das Video auf diesem Bild endet, was Ihnen Kontrolle über das Ende gibt."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Veo 3.1 Fast kostet 20 Credits pro Erstellung."
        },
        {
          "q": "Welche Auflösungen und Dauer werden unterstützt?",
          "a": "Unterstützt 720p, 1080p und 4K Auflösungen, mit Dauer von 4s, 6s oder 8s."
        }
      ],
      "referenceImage": "Reference Image",
      "referenceImageHint": "Upload a reference image; the video will be generated based on it.",
      "uploadReferenceImage": "Click to upload reference image",
      "endFrame": "Tail Frame",
      "endFrameHint": "Optional. Set the image for the last frame of the video to control the ending.",
      "uploadEndFrame": "Click to upload tail frame",
      "duration": "Duration",
      "resolution": "Resolution",
      "seedRangeError": "Seed must be an integer between 0 and 2147483647.",
      "demoPrompt": "A teenage girl sketching in a notebook at a café window, rain tapping on the glass..."
    },
    "kling": {
      "title": "Kling 2.6 KI-Video-Generator",
      "desc": "Kling 2.6 ist ein Hochleistungs-KI-Videomodell, das Text-zu-Video und Bild-zu-Video unterstützt, mit ausgezeichneter Bewegungsqualität und schneller Erstellungsgeschwindigkeit.",
      "features": [
        {
          "icon": "🎬",
          "title": "Hohe Bewegungsqualität",
          "desc": "Sanfte und natürliche Bewegung mit professioneller Qualität Output."
        },
        {
          "icon": "📱",
          "title": "Mehrere Seitenverhältnisse",
          "desc": "Unterstützt 1:1, 16:9, 9:16 und andere Seitenverhältnisse."
        },
        {
          "icon": "🔊",
          "title": "Audiogenerierung",
          "desc": "Optionale native Audiogenerierung für vollständiges Videoerlebnis."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Die meisten Videos innerhalb von 2 Minuten erstellt."
        },
        {
          "icon": "🖼️",
          "title": "Bild zu Video",
          "desc": "Animieren Sie statische Bilder mit KI-gestützter Bewegung."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Kling 2.6?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Kling 2.6 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Kling 2.6 kostet 28 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Welche Auflösungen und Dauer werden unterstützt?",
          "a": "Unterstützt 720p- und 1080p-Auflösungen, mit Dauer von 5s und 10s."
        },
        {
          "q": "Kann ich erstellte Videos kommerziell nutzen?",
          "a": "Ja, alle mit Kling 2.6 erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ]
    },
    "kling3": {
      "title": "Kling 3.0 KI-Video-Generator",
      "desc": "Kling 3.0 ist ein Hochleistungs-KI-Videomodell, das Text-zu-Video und Bild-zu-Video unterstützt, mit ausgezeichneter Bewegungsqualität und schneller Erstellungsgeschwindigkeit.",
      "features": [
        {
          "icon": "🎬",
          "title": "Hohe Bewegungsqualität",
          "desc": "Sanfte und natürliche Bewegung mit professioneller Qualität Output."
        },
        {
          "icon": "📱",
          "title": "Mehrere Seitenverhältnisse",
          "desc": "Unterstützt 1:1, 16:9, 9:16 und andere Seitenverhältnisse."
        },
        {
          "icon": "🔊",
          "title": "Audiogenerierung",
          "desc": "Optionale native Audiogenerierung für vollständiges Videoerlebnis."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Die meisten Videos innerhalb von 2 Minuten erstellt."
        },
        {
          "icon": "🖼️",
          "title": "Bild zu Video",
          "desc": "Animieren Sie statische Bilder mit KI-gestützter Bewegung."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Kling 3.0?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Kling 3.0 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Kling 3.0 kostet 28 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Welche Auflösungen und Dauer werden unterstützt?",
          "a": "Unterstützt 720p- und 1080p-Auflösungen, mit Dauer von 5s und 10s."
        },
        {
          "q": "Kann ich erstellte Videos kommerziell nutzen?",
          "a": "Ja, alle mit Kling 3.0 erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ]
    },
    "sora": {
      "title": "Sora 2 KI-Video-Generator",
      "desc": "Sora 2 ist OpenAIs fortschrittliches KI-Videomodell, das hochwertige Videos mit realistischer Bewegung und filmischer Qualität erstellen kann.",
      "features": [
        {
          "icon": "🎬",
          "title": "Filmische Qualität",
          "desc": "Erstellen Sie Videos mit professionellem filmischen Look und Feel."
        },
        {
          "icon": "🎥",
          "title": "Realistische Bewegung",
          "desc": "Natürliche und realistische Bewegung für Charaktere und Szenen."
        },
        {
          "icon": "⏱️",
          "title": "Flexible Dauer",
          "desc": "Unterstützt verschiedene Videolängen für unterschiedliche Bedürfnisse."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Optimiert für schnelle Videoproduktion."
        },
        {
          "icon": "🖼️",
          "title": "Multi-Modal-Eingabe",
          "desc": "Unterstützt Text-zu-Video und Bild-zu-Video Modi."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Sora 2?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Sora 2 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Sora 2 kostet 15 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Was macht Sora 2 besonders?",
          "a": "Sora 2 glänzt in der Erstellung von realistischer Bewegung und filmischer Qualität Videos, ideal für professionelle Inhaltserstellung."
        },
        {
          "q": "Kann ich erstellte Videos kommerziell nutzen?",
          "a": "Ja, alle mit Sora 2 erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "demoPromptExample": "@sama OpenAI's CEO, Sam, is introducing this cabinet product, saying it's the same as his own and very useful.",
      "landscape": "Landscape",
      "portrait": "Portrait",
      "removeWatermark": "Remove Watermark",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "noWatermark": "No Watermark",
      "cinematic": "Cinematic Quality",
      "restrictedAccess": "Restricted Access",
      "60secDuration": "Dauer 4 s / 8 s / 12 s",
      "photorealistic": "Photorealistic",
      "physicsSimulation": "Physics Simulation"
    },
    "wan": {
      "title": "Wan KI-Video-Generator",
      "desc": "Wan ist ein vielseitiges KI-Videomodell, das Text-zu-Video und Bild-zu-Video mit ausgezeichneter Qualität und Geschwindigkeit unterstützt.",
      "features": [
        {
          "icon": "🎬",
          "title": "Hohe Qualität",
          "desc": "Erstellen Sie professionelle Qualitätsvideos aus Text oder Bildern."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Schnelle Videoproduktion für effizienten Workflow."
        },
        {
          "icon": "📱",
          "title": "Mehrere Formate",
          "desc": "Unterstützt verschiedene Seitenverhältnisse und Auflösungen."
        },
        {
          "icon": "🖼️",
          "title": "Bildanimation",
          "desc": "Bringen Sie statische Bilder mit KI-Bewegung zum Leben."
        },
        {
          "icon": "🎥",
          "title": "Sanfte Bewegung",
          "desc": "Natürliche und flüssige Bewegung in erstellten Videos."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Wan?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Wan wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen."
        },
        {
          "q": "Welche Wan-Version sollte ich verwenden?",
          "a": "Wan 2.5 und 2.6 bieten die neuesten Funktionen und beste Qualität. Wan 2.2 ist eine kosteneffiziente Option für einfachere Projekte."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Wan 2.6 kostet 70 Credits, Wan 2.5 kostet 60 Credits und Wan 2.2 kostet 10 Credits pro Erstellung."
        },
        {
          "q": "Kann ich erstellte Videos kommerziell nutzen?",
          "a": "Ja, alle mit Wan erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "multiFormat": "Multiple Formats",
      "smoothMotion": "Smooth Motion",
      "referenceAudio": "Reference Audio",
      "uploadAudio": "Click to upload reference audio",
      "uploadAudioHint": "MP3, WAV, M4A (optional, drives video soundtrack)"
    },
    "wan25": {
      "title": "Wan 2.5 KI-Video-Generator",
      "desc": "Wan 2.5 ist ein vielseitiges KI-Videomodell, das Text-zu-Video und Bild-zu-Video mit ausgezeichneter Qualität und Geschwindigkeit unterstützt.",
      "features": [
        {
          "icon": "🎬",
          "title": "Hohe Qualität",
          "desc": "Erstellen Sie professionelle Qualitätsvideos aus Text oder Bildern."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Schnelle Videoproduktion für effizienten Workflow."
        },
        {
          "icon": "📱",
          "title": "Mehrere Formate",
          "desc": "Unterstützt verschiedene Seitenverhältnisse und Auflösungen."
        },
        {
          "icon": "🖼️",
          "title": "Bildanimation",
          "desc": "Bringen Sie statische Bilder mit KI-Bewegung zum Leben."
        },
        {
          "icon": "🎥",
          "title": "Sanfte Bewegung",
          "desc": "Natürliche und flüssige Bewegung in erstellten Videos."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Wan 2.5?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Wan 2.5 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen."
        },
        {
          "q": "Was ist der Unterschied zwischen Wan 2.5 und Wan 2.6?",
          "a": "Wan 2.6 bietet weitere Verbesserungen in Qualität und Stabilität; Wan 2.5 ist kosteneffizient und für die meisten Anwendungsfälle geeignet."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Wan 2.5 kostet 60 Credits pro Erstellung."
        },
        {
          "q": "Kann ich erstellte Videos kommerziell nutzen?",
          "a": "Ja, alle mit Wan 2.5 erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ]
    },
    "wan26": {
      "title": "Wan 2.6 KI-Video-Generator",
      "desc": "Wan 2.6 ist ein verbessertes KI-Videomodell mit verbesserter Qualität und Stabilität, unterstützt Text-zu-Video und Bild-zu-Video.",
      "features": [
        {
          "icon": "🎬",
          "title": "Hohe Qualität",
          "desc": "Erstellen Sie professionelle Qualitätsvideos aus Text oder Bildern mit verbesserter Qualität."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Schnelle Videoproduktion für effizienten Workflow."
        },
        {
          "icon": "📱",
          "title": "Mehrere Formate",
          "desc": "Unterstützt verschiedene Seitenverhältnisse und Auflösungen."
        },
        {
          "icon": "🖼️",
          "title": "Bildanimation",
          "desc": "Bringen Sie statische Bilder mit KI-Bewegung zum Leben."
        },
        {
          "icon": "🎥",
          "title": "Sanfte Bewegung",
          "desc": "Natürliche und flüssige Bewegung in erstellten Videos."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "faq": [
        {
          "q": "Was ist der Unterschied zwischen Wan 2.6 und Wan 2.5?",
          "a": "Wan 2.6 bietet weitere Verbesserungen in Qualität und Stabilität für höherwertige Output."
        },
        {
          "q": "Wie funktioniert Wan 2.6?",
          "a": "Geben Sie eine Textbeschreibung ein oder laden Sie ein Referenzbild hoch, und Wan 2.6 wird hochwertige Videoinhalte basierend auf Ihren Anweisungen erstellen."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Wan 2.6 kostet 70 Credits pro Erstellung."
        },
        {
          "q": "Kann ich erstellte Videos kommerziell nutzen?",
          "a": "Ja, alle mit Wan 2.6 erstellten Inhalte können für kommerzielle Zwecke verwendet werden."
        }
      ]
    },
    "wan22": {
      "title": "Wan 2.2 Klassisch KI-Video-Generator",
      "desc": "Wan 2.2 ist ein klassisches KI-Videomodell für Text-zu-Video und Bild-zu-Video, konzentriert auf stabile Ausgabe und starke Kosteneffizienz.",
      "features": [
        {
          "icon": "🎬",
          "title": "Text/Bild zu Video",
          "desc": "Unterstützt sowohl Text-zu-Video als auch Bild-zu-Video für tägliche Kreation und Batch-Testing."
        },
        {
          "icon": "⚡",
          "title": "Stabile Ergebnisse",
          "desc": "Reifes klassisches Modell mit vorhersagbarer Outputqualität."
        },
        {
          "icon": "💰",
          "title": "Budget-freundlich",
          "desc": "Niedrigerer Credit-Verbrauch für Hochfrequenz-Workflows."
        },
        {
          "icon": "📐",
          "title": "Gängige Verhältnisse",
          "desc": "Unterstützt gängige Seitenverhältnisse wie 16:9 und 9:16."
        },
        {
          "icon": "🎥",
          "title": "Saubere Output",
          "desc": "Liefert klare und stabile Videoqualität."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Erstellte Inhalte können kommerziell genutzt werden."
        }
      ],
      "faq": [
        {
          "q": "Was ist der Unterschied zwischen Wan 2.2 und Wan 2.5?",
          "a": "Wan 2.2 ist besser für kostenempfindliche, hochvolumige Szenarien; Wan 2.5/2.6 bieten stärkere Fähigkeiten und Qualität."
        },
        {
          "q": "Wie funktioniert Wan 2.2?",
          "a": "Geben Sie einen Prompt ein oder laden Sie ein Referenzbild hoch, und das Modell erstellt Video basierend auf Ihrer Anweisung."
        },
        {
          "q": "Können erstellte Videos kommerziell genutzt werden?",
          "a": "Ja, Wan 2.2 Outputs können für kommerzielle Zwecke verwendet werden."
        }
      ],
      "demoPromptExample": "A girl with little freckles and messy red hair sitting on a rooftop during sunset, denim jacket slightly worn, holding a Polaroid camera, city skyline glowing in soft hues behind her.",
      "resolutionBadge": "720p",
      "classicVersion": "Classic Version",
      "stableReliable": "Stable & Reliable",
      "costEffective": "Cost-effective"
    },
    "kling25": {
      "title": "Kling 2.5 KI-Video-Generator",
      "desc": "Kling 2.5 ist ein Standard-KI-Videomodell, das Text-zu-Video und Bild-zu-Video mit stabiler Qualität und gutem Wert unterstützt.",
      "features": [
        {
          "icon": "🎬",
          "title": "Text/Bild zu Video",
          "desc": "Unterstützt sowohl Text-zu-Video als auch Bild-zu-Video mit 5s/10s Dauer-Optionen."
        },
        {
          "icon": "⚡",
          "title": "Zuverlässige Output",
          "desc": "Ein ausgereiftes Standardmodell mit stabiler Leistung."
        },
        {
          "icon": "💰",
          "title": "Großer Wert",
          "desc": "Niedrigerer Credit-Verbrauch als höherwertige Modelle."
        },
        {
          "icon": "📐",
          "title": "Multi-Ratio",
          "desc": "Unterstützt 1:1, 16:9 und 9:16."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Erstellte Inhalte können kommerziell genutzt werden."
        }
      ],
      "faq": [
        {
          "q": "Was ist der Unterschied zwischen Kling 2.5 und Kling 2.6?",
          "a": "Kling 2.5 ist für Kosten und Durchsatz optimiert, während Kling 2.6 stärkere Gesamt-Fähigkeiten bietet."
        },
        {
          "q": "Wie funktioniert Kling 2.5?",
          "a": "Geben Sie einen Prompt ein oder laden Sie ein Referenzbild hoch, und Kling 2.5 erstellt das Video entsprechend."
        },
        {
          "q": "Können erstellte Videos kommerziell genutzt werden?",
          "a": "Ja, Kling 2.5 Outputs können kommerziell genutzt werden."
        }
      ],
      "standard": "Standard",
      "reliable": "Reliable",
      "costEffective": "Cost-effective",
      "standardQuality": "Standard Quality",
      "textToVideo": "Text to Video",
      "imageToVideo": "Image to Video",
      "referenceImage": "Reference Image",
      "referenceImageHint": "Click to upload or drag and drop",
      "referenceImageFormats": "Supports PNG, JPG, JPEG, WEBP (<=10MB)",
      "endFrame": "End Frame",
      "endFrameOptional": "Optional",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "Constrain the ending frame; best when matching reference image aspect ratio",
      "videoPrompt": "Video Prompt",
      "promptPlaceholder": "Describe the video you want to generate...",
      "negativePrompt": "Negative Prompt",
      "negativePromptPlaceholder": "Describe what should be excluded...",
      "duration": "Duration",
      "aspectRatio": "Aspect Ratio",
      "uploading": "Uploading...",
      "clickToUploadReference": "Click to upload reference image",
      "clickToUploadEndFrame": "Click to upload end frame image",
      "remove": "Remove",
      "creditsRequired": "Credits Required:",
      "remaining": "Remaining:",
      "generate": "Generate",
      "generating": "Generating...",
      "demoPrompt": "Demo Prompt",
      "demoPromptExample": "Use the uploaded sci-fi alley image as the first frame. Keep the same alley, neon signs, reflections and the hooded woman walking away. Slowly move the camera forward down the alley...",
      "model": "Model:",
      "durationLabel": "Duration:",
      "introTitle": "Create High-quality AI Videos with Kling 2.5 Standard",
      "featuresBadge": "Core Features",
      "featuresTitle": "What can {name} do?",
      "faqTitle": "FAQ",
      "errorPromptRequired": "Please enter a prompt",
      "errorImageRequired": "Reference image is required in image-to-video mode",
      "errorGenerationFailed": "Generation failed",
      "errorRequestFailed": "Request failed, please try again",
      "errorUploadFailed": "Upload failed, please try again"
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "Charakteranimation aus Referenzbild und Bewegungsvideo. Standard- oder Profiqualität, optionales Wasserzeichen.",
      "refImageLabel": "Referenzbild",
      "refImageHint": "Zu animierende Figur (JPG/PNG/JPEG/BMP/WEBP, max. 5 MB, Kanten 200–4096 px, Seitenverhältnis 1:3–3:1).",
      "refVideoLabel": "Referenzvideo",
      "refVideoHint": "Bewegungsreferenz (MP4/AVI/MOV, 2–30 s, max. 200 MB, Kanten 200–2048 px, Seitenverhältnis 1:3–3:1).",
      "animateModeLabel": "Animationsmodus",
      "modeAnimate": "Bild zu Aktion",
      "modeReplace": "Personentausch im Video",
      "referenceVideo": "Referenzvideo",
      "btnAnimate": "Animieren",
      "animateModeBadgeAnimate": "Motion",
      "animateModeBadgeReplace": "Ersetzen",
      "btnAnimateDesc": "Figur aus dem Bild mit Bewegung aus dem Video kombinieren.",
      "btnReplace": "Ersetzen",
      "btnReplaceDesc": "Die Figur im Video durch die Figur aus dem Bild ersetzen.",
      "qualityLabel": "Qualitätsmodus",
      "qualityStd": "Standard",
      "qualityPro": "Professionell",
      "watermarkLabel": "Wasserzeichen",
      "uploadVideoRequired": "Bitte laden Sie ein Referenzvideo hoch.",
      "uploadImage": "Bild hochladen",
      "uploadVideo": "Video hochladen",
      "uploading": "Wird hochgeladen…",
      "imageUploadHint": "JPG, PNG, JPEG, BMP, WEBP · max. 5 MB",
      "videoUploadHint": "MP4, AVI, MOV · 2–30 s · max. 200 MB",
      "uploadImageRequired": "Bitte laden Sie ein Referenzbild hoch.",
      "errImageFileTooLarge": "Die Bilddatei ist zu groß (max. 5 MB).",
      "errImageDimensions": "Bildbreite und -höhe müssen zwischen 200 und 4096 px liegen.",
      "errImageAspect": "Das Seitenverhältnis des Bildes muss zwischen 1:3 und 3:1 liegen.",
      "errImageInvalid": "Ungültige oder nicht lesbare Bilddatei.",
      "errVideoFileTooLarge": "Die Videodatei ist zu groß (max. 200 MB).",
      "errVideoDuration": "Die Videodauer muss zwischen 2 und 30 Sekunden liegen.",
      "errVideoDimensions": "Video-Breite und -Höhe müssen zwischen 200 und 2048 px liegen.",
      "errVideoAspect": "Das Seitenverhältnis des Videos muss zwischen 1:3 und 3:1 liegen.",
      "errVideoInvalid": "Ungültige oder nicht lesbare Videodatei.",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "Laden Sie ein Charakterbild und ein Bewegungsvideo hoch und erstellen Sie mit Wan Animate beeindruckende Charakteranimationen.",
      "demoEmptyTitle": "Charakteranimation",
      "demoStepCharacter": "Charakter",
      "demoStepMotion": "Bewegung",
      "demoStepAnimate": "Animation",
      "faqCredits": "Der Profimodus verbraucht pro Generierung mehr Credits als der Standardmodus. Siehe die Zeile oben.",
      "characterAnimation": "Charakteranimation",
      "faceSwap": "Gesichtstausch",
      "motionTransfer": "Bewegungsübertragung",
      "identityReplacement": "Identitätsersetzung",
      "motionAccuracy": "Hohe Bewegungstreue",
      "features": [
        { "icon": "🎭", "title": "Zwei Modi", "desc": "Bewegungsübertragung oder vollständiger Charaktertausch." },
        { "icon": "📐", "title": "DashScope offiziell", "desc": "Wan 2.2 Animate auf Alibaba Cloud." },
        { "icon": "⚡", "title": "Std / Pro", "desc": "Standard- oder Profiqualität pro Aufgabe." },
        { "icon": "💧", "title": "Optionales Wasserzeichen", "desc": "Wasserzeichen in der Ausgabe ein- oder ausschalten." }
      ],
      "faq": [
        { "q": "Welche Eingaben sind nötig?", "a": "Nach dem Upload öffentliche HTTPS-URLs für Bild und Video. Größe und Seitenverhältnis einhalten." },
        { "q": "Unterschied Animieren und Ersetzen?", "a": "Animieren überträgt die Bewegung aus dem Video auf Ihre Bildfigur. Ersetzen tauscht die Figur im Video gegen Ihre Bildfigur." },
        { "q": "Wie werden Credits berechnet?", "a": "Der Profimodus kostet pro Generierung mehr als der Standardmodus, wie auf der Seite angezeigt." }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro KI-Video",
      "desc": "Vidu Q3 Pro: Text oder Bild, Auflösung, 1–16 s, Seitenverhältnis und optionaler Ton.",
      "imageUrlHint": "Nur HTTPS-Bild-URLs (Upload liefert eine öffentliche URL). Seitenverhältnis zwischen 1:4 und 4:1.",
      "lengthLabel": "Dauer (s)",
      "optional": "Optional",
      "tagHighQuality": "Hohe Qualität",
      "tagLength": "1–16 s",
      "tagResolution": "Bis 2K",
      "demoPromptExample": "Promenade bei Sonnenaufgang, Jogger, Möwen über dem Wasser, ein Segelboot in der Ferne.",
      "features": [
        { "icon": "🎬", "title": "Text & Bild", "desc": "Generierung aus Prompt oder Referenzbild." },
        { "icon": "📐", "title": "Seitenverhältnis", "desc": "Textmodus: 16:9, 9:16, 1:1, 4:3, 3:4." },
        { "icon": "⏱️", "title": "Länge", "desc": "1 bis 16 Sekunden." },
        { "icon": "🎵", "title": "Audio", "desc": "Optional natürlicher Ton." },
        { "icon": "🎲", "title": "Seed", "desc": "Optionaler Seed für bessere Reproduzierbarkeit." }
      ],
      "faq": [
        { "q": "Anforderungen Bild→Video?", "a": "Öffentliche HTTPS-URL (JPG/PNG). Seitenverhältnis zwischen 1:4 und 4:1." },
        { "q": "Unterschied Text vs. Bild?", "a": "Text nutzt Seitenverhältnis; Bild sendet die Referenz-URL." },
        { "q": "Credits?", "a": "Nach den angezeigten Regeln: Dauer, Auflösung und Audio." }
      ]
    },
    "hailuo": {
      "title": "Hailuo 2.3 KI-Video-Generator",
      "desc": "Hailuo 2.3 ist ein nächstgenerations KI-Videomodell, das für kreative, hochwertige Videogenerierung konzipiert wurde.",
      "features": [
        {
          "icon": "🎬",
          "title": "Text zu Video",
          "desc": "Erstellen Sie hochwertige Videos direkt aus Text-Prompts."
        },
        {
          "icon": "✨",
          "title": "Prompt-Verbesserung",
          "desc": "Prompt-Verbesserung hilft, Konsistenz und Qualität zu verbessern."
        },
        {
          "icon": "🌊",
          "title": "Kreativer Stil",
          "desc": "Großartig für kreative und künstlerische Videoinhalte."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Optimisierte Pipeline für schnellere Umsatz."
        },
        {
          "icon": "🎨",
          "title": "Visuelle Qualität",
          "desc": "Produziert detaillierte und stabile visuelle Output."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Erstellte Inhalte können kommerziell genutzt werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Hailuo 2.3?",
          "a": "Geben Sie einen Prompt ein oder laden Sie ein Referenzbild hoch, und das Modell erstellt das entsprechende Video."
        },
        {
          "q": "Was ist Prompt-Verbesserung?",
          "a": "Prompt-Verbesserung schreibt und bereichert Prompts für bessere Erstellungsqualität."
        },
        {
          "q": "Können erstellte Videos kommerziell genutzt werden?",
          "a": "Ja, Hailuo 2.3 Outputs können kommerziell genutzt werden."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Jede Erstellung wird nach aktuellen Modell-Credit-Regeln berechnet."
        }
      ],
      "demoPromptExample": "A cinematic shot of waves crashing on a rocky shore at sunset, golden light reflecting on the water...",
      "highQuality": "High Quality",
      "highQualityOutput": "High-quality Output"
    },
    "runway": {
      "title": "Runway KI-Video-Generator",
      "desc": "Runway ist ein professionelles KI-Videomodell mit flexiblen Steuerelementen für Verhältnis, Dauer und Seed.",
      "features": [
        {
          "icon": "🎬",
          "title": "Bild zu Video",
          "desc": "Laden Sie ein Referenzbild und Prompt hoch, um schnell hochwertige Videos zu erstellen."
        },
        {
          "icon": "📐",
          "title": "Mehrere Verhältnisse",
          "desc": "Unterstützt 16:9, 9:16, 1:1, 4:3, 3:4 und 21:9."
        },
        {
          "icon": "🎲",
          "title": "Seed-Kontrolle",
          "desc": "Nutzen Sie Seed, um ähnliche Erstellungsergebnisse zu reproduzieren."
        },
        {
          "icon": "⚡",
          "title": "Professionelle Output",
          "desc": "Konsistente Output geeignet für Pro- und kommerzielle Workflows."
        },
        {
          "icon": "🖼️",
          "title": "Bildanimation",
          "desc": "Verwandeln Sie statische Bilder in dynamische Video-Aufnahmen."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Erstellte Inhalte können kommerziell genutzt werden."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Runway?",
          "a": "Laden Sie ein Referenzbild hoch und geben Sie einen Prompt ein; das Modell erstellt das entsprechende Video."
        },
        {
          "q": "Welche Seitenverhältnisse werden unterstützt?",
          "a": "16:9, 9:16, 1:1, 4:3, 3:4 und 21:9 werden unterstützt."
        },
        {
          "q": "Können erstellte Videos kommerziell genutzt werden?",
          "a": "Ja, Runway Outputs können kommerziell genutzt werden."
        }
      ],
      "demoPromptExample": "At dusk, the silhouettes of cranes at a Singaporean construction site are set against a brilliant sunset. Several construction workers wearing hard hats are packing up their tools, getting ready to leave...",
      "professional": "Professional",
      "multiOption": "Multiple Options",
      "highQuality": "High Quality",
      "multiFormat": "Multiple Ratios",
      "reproducibleSeed": "Reproducible Seed"
    },
    "seedance": {
      "title": "Seedance KI-Video-Generator",
      "desc": "Seedance ist ein nächstgenerations KI-Videomodell, das native Audio-Video-Synchronisation, filmische Bewegung und emotionale Expression unterstützt. Umfasst Text-zu-Video, Bild-zu-Video und Videoerweiterungsmodi.",
      "features": [
        {
          "icon": "🎬",
          "title": "Native Audio-Video-Erstellung",
          "desc": "Synchron erstellen von Video und Audio auf einmal, liefert filmische Qualität. Natürliche Lippen-Synchronisation und Dialog-Synchronisation."
        },
        {
          "icon": "😊",
          "title": "Emotionsgesteuerte Expression",
          "desc": "Neue emotionsbewusste Leistung für realistischere Gesichtsausdrücke. Subtile Ausdrücke einschließlich Zögern, Traurigkeit, Spannung oder emotionaler Zurückhaltung."
        },
        {
          "icon": "🎥",
          "title": "Regisseur-Level Kamera-Kontrolle",
          "desc": "Unterstützt Schieben, Ziehen, Schwenken, Drehen und Verfolgen von Kamerabewegungen. Führung von erstem und letztem Bild für sanfte Übergänge."
        },
        {
          "icon": "📱",
          "title": "Multi-Modal-Eingabe",
          "desc": "Unterstützt Text-zu-Video, Bild-zu-Video und andere flexible kreative Workflows."
        },
        {
          "icon": "⚡",
          "title": "Schnelle Erstellung",
          "desc": "Optimierte Inferenz-Engine gewährleistet schnelle Produktion, die meisten Videos完成 innerhalb von Minuten."
        },
        {
          "icon": "💼",
          "title": "Kommerzielle Lizenz",
          "desc": "Alle erstellten Videos können für kommerzielle Zwecke verwendet werden, geeignet für Werbung, soziale Medien und mehr."
        }
      ],
      "faq": [
        {
          "q": "Wie funktioniert Seedance?",
          "a": "Sie können ein Referenzbild hochladen oder direkt eine Textbeschreibung eingeben, und das Seedance-Modell wird hochwertige Videoinhalte basierend auf Ihren Anweisungen mit synchronisiertem Audio erstellen. Der Prozess ist einfach und intuitiv, benötigt keine professionellen Fähigkeiten."
        },
        {
          "q": "Können erstellte Videos kommerziell genutzt werden?",
          "a": "Ja, alle mit Seedance erstellten Inhalte können für kommerzielle Zwecke verwendet werden, einschließlich Marketingmaterialien, sozialen Medien, Produkt-Shows und mehr."
        },
        {
          "q": "Wie viele Credits kostet jede Erstellung?",
          "a": "Die Verwendung von Seedance kostet 18 Credits pro Erstellung. Sie können bessere Credit-Rates durch Abopläne erhalten."
        },
        {
          "q": "Wie schnell ist die Erstellung?",
          "a": "Die durchschnittliche Erstellungsgeschwindigkeit von Seedance beträgt etwa 1,5 Minuten. Wir optimieren kontinuierlich unsere Infrastruktur, um schnelle und stabile Erstellung zu gewährleisten."
        },
        {
          "q": "Welche Ausgabeformate werden unterstützt?",
          "a": "Videos werden im MP4-Format ausgegeben, unterstützen 480p-, 720p- und 1080p-Auflösungen, mit Dauer von 5 oder 10 Sekunden und mehreren Seitenverhältnissen."
        }
      ],
      "textToVideo": "Text to Video",
      "imageToVideo": "Image to Video",
      "videoExtend": "Video Extend",
      "uploadImage": "Click to upload reference image",
      "uploadHint": "PNG, JPG, JPEG (max 20MB)",
      "endFrame": "End Frame Image",
      "endFrameHint": "(Optional) Upload end frame to control video ending",
      "uploadEndFrame": "Click to upload end frame image",
      "uploadVideo": "Click to upload reference video",
      "uploadVideoHint": "MP4, MOV, WebM (max 100MB)",
      "videoPrompt": "Video Prompt",
      "promptPlaceholder": "Describe the video you want to generate...",
      "videoPromptPlaceholder": "Describe the video you want to generate...",
      "negativePrompt": "Negative Prompt",
      "negativePromptPlaceholder": "Describe what you don't want in the video (optional)",
      "duration": "Duration",
      "videoDuration": "Video duration",
      "resolution": "Resolution",
      "aspectRatio": "Aspect Ratio",
      "promptEnhance": "Prompt enhancement",
      "promptEnhanceDesc": "Automatically optimize prompts for better generation results",
      "generateAudio": "Generate Audio",
      "audioOn": "Native audio (voice + sound effects)",
      "audioOff": "Video only, no audio",
      "seedValue": "Seed Value",
      "seedHint": "The seed value is the unique identifier of the overall style. Using the same seed keeps the style consistent, while tweaking other parameters helps refine visual details.",
      "seedPlaceholder": "-1 (random)",
      "characters": "characters",
      "creditsRequired": "Credits Required:",
      "creditsRemaining": "Remaining:",
      "generate": "Generate",
      "generating": "Generating...",
      "demoPrompt": "Demo Prompt",
      "demoPromptExample": "A soft and cute white kitten dances joyfully on tiptoes, its fluffy body swaying gently with tiny pink paws lifted. On a soft carpet under warm yellow lighting, healing cartoon style, exquisite details, soft and gentle colors.",
      "modelLabel": "Model:",
      "durationLabel": "Duration:",
      "techSpecsTitle": "Technical Specifications",
      "techSpecsDesc": "Seedance supports native audio-visual synchronization, cinematic motion, and emotional expression. Covers text-to-video, image-to-video, and video extension modes.",
      "t2vTitle": "Text to Video (T2V)",
      "t2vDesc": "Transform prompts into cinematic video scenes",
      "i2vTitle": "Image to Video (I2V)",
      "i2vDesc": "Animate a single image using AI",
      "input": "Input:",
      "textPrompt": "Text prompt",
      "imagePrompt": "Image + prompt",
      "audio": "Audio:",
      "nativeAudio": "Native audio generation",
      "bestFor": "Best for:",
      "t2vBestFor": "Perfect for cinematic content creation, advertising, and social media videos.",
      "i2vBestFor": "Best for portrait animation, product showcases, and creative content.",
      "featuresDesc": "Whether you're a designer, marketer, content creator, or casual user, Seedance helps you quickly create high-quality AI content.",
      "enterPrompt": "Please enter a prompt",
      "imageRequired": "Image-to-video mode requires a reference image",
      "videoRequired": "Video extend mode requires a reference video",
      "generateFailed": "Generation failed",
      "requestFailed": "Request failed, please try again"
    }
  },
  "seo": {
    "default": {
      "title": "Miral - KI-Bild-, Video- und Musikgenerator",
      "description": "Miral ist eine All-in-One-Plattform mit den besten KI-Modellen wie Seedream 4, Midjourney, GPT Image, Veo 3 und Sora 2.",
      "keywords": "KI-Bildgenerator, KI-Videogenerator, KI-Musikgenerator, Text zu Bild, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": { "title": "Miral: KI-Generator für Bilder, Videos und Musik", "description": "Erstellen Sie KI-Bilder, Videos und Musik auf Miral mit führenden Modellen wie Seedream 5, Midjourney, Veo 3.1, Sora 2 und weiteren auf einer Plattform." },
    "pricing": { "title": "Preise - Miral", "description": "Miral bietet flexible Preisanzeige. Kaufen Sie Credits, zahlen Sie pro Nutzung, kein Abonnement." },
    "profile": { "title": "Profil - Miral", "description": "Verwalten Sie Ihr Miral-Konto, Bestellverlauf anzeigen." },
    "models": { "title": "KI-Modelle - Miral", "description": "Entdecken Sie die besten KI-Modelle auf Miral: Bild, Video und Musik." },
    "music": { "title": "KI-Musikgenerator - Miral", "description": "Erstellen Sie einzigartige Musik aus Textbeschreibungen mit Mirals KI." },
    "tools": { "title": "KI-Bildwerkzeuge - Miral", "description": "Miral bietet KI-Bildverarbeitungswerkzeuge: Wasserzeichenentfernung, Hintergrundentfernung, Verbesserung." },
    "inspiration": { "title": "Inspiration - Miral", "description": "Durchsuchen Sie ausgewählte Werke der Miral-Community." },
    "gallery": { "title": "Meine Galerie - Miral", "description": "Alle Ihre Kreationen auf Miral anzeigen und verwalten." },
    "faq": { "title": "FAQ - Miral", "description": "Häufig gestellte Fragen zur Miral-Plattform." },
    "about": {
      "title": "About Us - Miral",
      "description": "Learn about the Miral AI platform for image, video, and music creation."
    },
    "contact": {
      "title": "Contact Us - Miral",
      "description": "Contact Miral support for help and feedback."
    },
    "terms": { "title": "Nutzungsbedingungen - Miral", "description": "Nutzungsbedingungen und Benutzervereinbarung von Miral." },
    "privacy": { "title": "Datenschutzrichtlinie - Miral", "description": "Datenschutzrichtlinie und Datensicherheit von Miral." },
    "trustSafety": { "title": "Vertrauen und Sicherheit - Miral", "description": "Vertrauens- und Sicherheitsrichtlinien von Miral." },
    "models": {
      "wan25": { "title": "Wan 2.5 - Leistungsstarkes KI-Videomodell", "description": "Wan 2.5 bietet KI-Videogenerierung der nächsten Generation. Erstellen Sie realistische, flüssige Videos mit fortschrittlicher Bewegung und Detail, ideal für Creator und Unternehmen." },
      "wan26": { "title": "Wan 2.6 - Verbesserter KI-Videogenerator", "description": "Verbessern Sie Ihre Videoerstellung mit Wan 2.6. Dieses fortschrittliche KI-Modell generiert ultrarealistische Videos mit verbesserter Bewegung, Detail und Geschwindigkeit für professionelle Inhalte." },
      "wan22": { "title": "Wan 2.2 - Schneller KI-Videogenerator", "description": "Wan 2.2 ist ein schnelles, zuverlässiges KI-Videomodell. Generieren Sie schnell hochwertige Videos, ideal für Creator die effiziente professionelle Produktion benötigen." },
      "wanAnimate": { "title": "Wan Animate - Charakteranimation - Miral", "description": "Animieren Sie Charaktere mit Referenzbild und Bewegungsvideo über Alibaba Wan 2.2 Animate." },
      "veo30": { "title": "Veo 3.0 - Führendes KI-Videomodell", "description": "Veo 3.0 ist ein erstklassiger KI-Videogenerator. Erstellen Sie lebensechte, filmische Videos mit fortschrittlicher KI, perfekt für professionelle Inhaltserstellung." },
      "veo31": { "title": "Veo 3.1 - Top KI-Videogenerierung", "description": "Veo 3.1 ist ein führendes KI-Videomodell für beeindruckende, lebensechte Videos. Erstellen Sie filmische Clips und Animationen mit unvergleichlicher Qualität und Geschwindigkeit." },
      "kling26": { "title": "Kling 2.6 - Premium KI-Videomodell", "description": "Kling 2.6 erweckt professionelle KI-Videogenerierung zum Leben. Generieren Sie hochwertige, flüssige Videos mit fortschrittlicher KI für Creator, Marketer und Unternehmen." },
      "kling25": { "title": "Kling 2.5 - Zuverlässiges KI-Videomodell", "description": "Kling 2.5 bietet leistungsstarke KI-Videogenerierung für Creator. Erstellen Sie hochwertige Videos mit flüssiger Bewegung und Detail, perfekt für Inhalte und Marketing." },
      "seedance": { "title": "Seedance AI - Fortschrittlicher KI-Videogenerator", "description": "Generieren Sie hochwertige KI-Videos mit Seedance AI. Erstellen Sie Clips, Animationen und filmische Inhalte mit modernsten KI-Modellen für schnelle, professionelle Ergebnisse." },
      "sora2": { "title": "Sora 2 KI-Videogenerator – Text und Bild zu Video | Miral", "description": "Erstelle Sora 2 Videos aus Text oder Bildern auf Miral. Teste mit kostenlosen Credits und wähle 4–12 s, 720p/1080p sowie 16:9/9:16." },
      "hailuo23": { "title": "Hailuo 2.3 - Intelligenter KI-Videogenerator", "description": "Hailuo 2.3 bietet intelligente KI-Videogenerierung. Erstellen Sie hochwertige, kreative Videos mit fortschrittlicher KI für Content-Creator und Unternehmen." },
      "runway": { "title": "Runway - KI-Videocreation-Plattform", "description": "Runway ist eine führende KI-Videoplattform für Creator. Bearbeiten, generieren und verbessern Sie Videos mit leistungsstarken KI-Tools für professionelle Produktion." },
      "nanobanana": { "title": "Nano Banana - KI-Bildgenerator - Miral", "description": "Generieren Sie schnell kreative Bilder mit Nano Banana." },
      "seedream4": { "title": "Seedream 4 - KI-Bildgenerator", "description": "Erstellen Sie beeindruckende hochauflösende KI-Bilder mit Seedream 4. Generieren Sie fotorealistische Kunst, Illustrationen und Designs mit fortschrittlicher KI für professionelle kreative Arbeit." },
      "midjourney": { "title": "Midjourney - KI-Kunstgenerator", "description": "Midjourney ist ein führender KI-Kunstgenerator. Erstellen Sie atemberaubende Bilder und Designs aus Text, perfekt für Künstler, Designer und Content-Creator." },
      "gptimage1": { "title": "GPT-Image-1 - OpenAI KI-Bildmodell", "description": "GPT-Image-1 von OpenAI generiert hochwertige KI-Bilder aus Text. Erstellen Sie realistische, kreative Visuals für Design, Marketing und Content-Erstellung." },
      "gptimage15": { "title": "GPT Image 1.5 - OpenAI KI-Bildgenerator - Miral", "description": "Generieren Sie hochwertige KI-Bilder mit OpenAI GPT Image 1.5." },
      "fluxpro11ultra": { "title": "Flux Pro 1.1 Ultra - Premium KI-Bildgenerator", "description": "Flux Pro 1.1 Ultra bietet KI-Bildgenerierung in Ultra-Hochqualität. Erstellen Sie fotorealistische, detaillierte Bilder mit fortschrittlicher KI für professionelles Design." },
      "fluxschnell": { "title": "Flux Schnell - Schneller KI-Bildgenerator", "description": "Flux Schnell ist ein blitzschneller KI-Bildgenerator. Erstellen Sie schnell hochwertige Bilder, ideal für Creator die schnelle professionelle visuelle Inhalte benötigen." },
      "flux2": {
        "title": "FLUX.2 - KI-Bildgenerator - Miral",
        "description": "Generieren Sie professionelle KI-Bilder mit FLUX.2 — 5 Varianten für Geschwindigkeit, Qualität und Kontrolle."
      },
      "zimageturbo": {
        "title": "Z Image Turbo - KI-Bildgenerator - Miral",
        "description": "Generieren Sie hochauflösende Bilder mit dem Z Image Turbo Modell."
      }
    },
    "tools": {
      "watermarkRemover": { "title": "Kostenlos Wasserzeichen mit KI entfernen | Miral", "description": "Entfernen Sie Wasserzeichen, Logos, Datumsangaben, Texte und Entwürfe online per KI. Details bleiben erhalten; Export als saubere JPG-, PNG- oder WebP-Datei." },
      "backgroundRemover": { "title": "KI-Hintergrund kostenlos online entfernen | Miral", "description": "Entfernen Sie Bildhintergründe kostenlos mit KI. Stellen Sie Porträts und Produkte frei, bewahren Sie Haare und Kanten und erstellen Sie transparente PNGs aus JPG, PNG oder WebP." },
      "imageEraser": { "title": "KI-Bildradierer - Objekte aus Fotos entfernen", "description": "Entfernen Sie unerwünschte Objekte, Personen, Wasserzeichen und Text aus Fotos mit KI. Malen Sie über den Bereich und die KI entfernt es nahtlos und füllt die Lücke mit natürlichem Inhalt. Perfekt zum Bereinigen von Bildern." },
      "objectRemover": { "title": "KI-Objekt-Entferner - Objekte aus Fotos entfernen", "description": "Entfernen Sie unerwünschte Objekte aus Fotos mit KI. Malen Sie über das Objekt und die KI entfernt es nahtlos und füllt die Fläche mit natürlichem Inhalt. Perfekt zum Bereinigen Ihrer Fotos." },
      "aiPersonRemover": { "title": "KI-Personen-Entferner - Personen aus Fotos entfernen", "description": "Entfernen Sie Personen aus Fotos mit KI. Malen Sie über eine beliebige Person und die KI entfernt sie nahtlos und füllt die Fläche mit natürlichem Inhalt. Perfekt zum Entfernen von Passanten und Fremden aus Ihren Aufnahmen." },
      "whiteBackground": { "title": "KI-Weißer Hintergrund - Hintergrund durch Weiß ersetzen", "description": "Ersetzen Sie Bildhintergründe automatisch durch Weiß mit KI. Ideal für E-Commerce-Produktfotos, Ausweisfotos und Katalogbilder." },
      "blueBackground": { "title": "KI-Blauer Hintergrund - Hintergrund durch Blau ersetzen", "description": "Ersetzen Sie Bildhintergründe automatisch durch Blau mit KI. Ideal für Ausweisfotos, Passfotos und offizielle Dokumente." },
      "faceSwap": { "title": "KI-Gesichtstausch - Gesichter auf Fotos tauschen", "description": "Tauschen Sie Gesichter auf Fotos mit KI. Laden Sie ein Zielfoto und ein Quellgesicht hoch, um Gesichter nahtlos mit realistischen, natürlichen Ergebnissen zu fusionieren." },
      "imageEnhancer": { "title": "KI-Bildverbesserung - Vergrößern & verbessern", "description": "Verbessern und vergrößern Sie Bilder mit KI. Details schärfen, Unschärfe korrigieren, Auflösung erhöhen und alte Fotos wiederherstellen für professionelle Ergebnisse." },
      "docCropEnhance": { "title": "Dokumente online mit KI zuschneiden und korrigieren | Miral", "description": "Schneiden und korrigieren Sie Dokumente, Tests, Aufgaben und Buchseiten online. Beheben Sie Neigung, Perspektive, Wölbung und Schatten für klare Scans." },
      "handwrittenErase": { "title": "KI-Handschrift aus Tests und Aufgaben entfernen | Miral", "description": "Entfernen Sie handschriftliche Antworten aus Tests, Aufgaben und Heften per KI, ohne Drucktext zu löschen. Mit Drehen, Zuschneiden und Entzerren." }
    },
    imageModels: {
            title: "KI-Bildmodelle – Miral",
            description: "Entdecken Sie die besten KI-Bildmodelle auf Miral und generieren Sie atemberaubende Bilder aus Texteingaben.",
            relatedModelsTitle: "Entdecken Sie weitere KI-Bildmodelle",
            demoPrompt: "Textaufforderung",
            demoOutput: "Generiertes Bild",
            demoPlaceholder: "Beispielbild – bald verfügbar",
            promptLabel: "Erstellen Sie mit",
            usePrompt: "Verwenden Sie diese Eingabeaufforderung →",
            imagePlaceholder: "Beispiel für ein KI-Bild",
            replaceImageHint: "Wird aus der neben diesem Bild angezeigten Eingabeaufforderung generiert",
            flux1: {
                title: "FLUX.1 AI-Bildgenerator kostenlos online | Miral",
                description: "Erstellen Sie mit FLUX.1 online hochwertige KI-Bilder mit Flux Pro 1.1 Ultra oder Flux Schnell. Entdecken Sie neun Seitenverhältnisse, visuelle Stile und kostenlose Credits.",
                heroHeadline: "FLUX.1 AI-Bildgenerator",
                heroIntro: "Nutzen Sie den FLUX.1 AI-Bildgenerator von Black Forest Labs kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und wählen Sie zwischen der hochwertigen Ausgabe von Flux Pro 1.1 Ultra und der schnellen Multi-Style-Erstellung von Flux Schnell.",
                eyebrow: "Schwarzwaldlabore · FLUX.1",
                sectionKicker: "FLUX.1",
                ctaTag: "FLUX.1 · Miral",
                badges: ["Text zu Bild", "9 Seitenverhältnisse", "Pro und Schnell", "Fotografische / digitale Kunst / Anime"],
                previewLabel: "Flux Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9:16", "9 Verhältnisse"],
                previewTitle: "Wählen Sie zwischen ausgefeilter Qualität und schneller kreativer Erkundung",
                previewDesc: "Verwenden Sie Pro 1.1 Ultra für detaillierte Bilder oder Schnell, um schnell fotografische, digitale Kunst- und Anime-Richtungen zu erkunden.",
                keyFeaturesTitle: "Erstellen Sie hochwertige Visuals mit dem FLUX.1 Text-to-Image-Generator",
                keyFeaturesIntro: "Entdecken Sie die Funktionen von Flux Pro 1.1 Ultra und Flux Schnell für schnelles Verständnis, Ausgabegeschwindigkeit, visuelle Stile und flexible Seitenverhältnisse.",
                exploreTitle: "Entdecken Sie weitere KI-Bildmodelle",
                mainFeaturesTitle: "Wichtige FLUX.1-Funktionen",
                generatedImageLabel: "Generiertes Bild",
                versionLabel: "Version",
                featureLabel: "Hauptmerkmale",
                useCaseLabel: "Am besten für",
                controlsTitle: "Wählen Sie das richtige Modell, Verhältnis und den richtigen visuellen Stil",
                controlsIntro: "Verwenden Sie Flux Pro 1.1 Ultra für ausgefeilte Endbilder oder Flux Schnell für eine schnellere Erkundung und passen Sie dann das Seitenverhältnis und den Stil an den gewünschten Kanal an.",
                galleryTitle: "Weitere FLUX.1-Bildbeispiele",
                discussionTitle: "Häufige Fragen zur FLUX.1-Auswahl",
                communityTitle: "Beliebte Möglichkeiten zum Gestalten mit FLUX.1",
                tutorialPrompt: "Ein ruhiger Glashaus-Buchladen am Meer bei Sonnenaufgang, warme Leselampen, helle Eichenregale, sanfte Reflexionen auf dem Boden, realistische Innenaufnahmen.",
                qualityBenefits: [
                    "Geben Sie Materialien, Beleuchtung und räumliche Tiefe mit einem polierteren Finish wieder.",
                    "Befolgen Sie detaillierte Anweisungen, die Thema, Komposition, Kamera und Stil kombinieren.",
                    "Entdecken Sie fotografische, digitale Kunst- und Anime-Anweisungen anhand von Klartextanweisungen."
                ],
                features: [
                    { name: "Hochwertiger FLUX.1-Text zu Bild", short: "Verwandeln Sie schriftliche Eingabeaufforderungen in detaillierte, professionelle Bilder.", desc: "Flux Pro 1.1 Ultra eignet sich für Arbeiten, bei denen es auf Bilddetails, Materialien, Beleuchtung und Gesamtfinish ankommt. Eine klare Beschreibung des Motivs, der Komposition, der Kamera und des Stils hilft dabei, das Bild in die Richtung Ihres Projekts zu lenken.", demo: { type: 'table', rows: [
                        { prompt: "Fassade eines Boutique-Wüstenhotels zur blauen Stunde, Stampflehmwände, warmes Fensterlicht, einheimische Gräser, lange Schatten, realistische Architekturfotografie.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "Redaktionelle Food-Fotografie von handgemachten Ravioli auf einem mattschwarzen Teller, Basilikumöl, Leinenserviette, gerichtetes Fensterlicht, geringe Schärfentiefe.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Schnelle Generation mit Flux Schnell", short: "Erstellen Sie schnelle Entwürfe, testen Sie Eingabeaufforderungen und erkunden Sie Ideen schnell.", desc: "Flux Schnell eignet sich hervorragend für Arbeitsabläufe, die schnelle Kompositions-, Stil- oder Konzepttests erfordern. Erstellen Sie einen Entwurf, überprüfen Sie die Richtung und verfeinern Sie dann die Aufforderung für eine weitere Iteration.", prompt: "Ein modulares Messestandkonzept aus Pappe für ein Öko-Startup, einfache Produktsockel, Texturen aus Recyclingpapier, helle Ausstellungsbeleuchtung, klares Layout.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "Neun Bildseitenverhältnisse", short: "Decken Sie die Formate Ultrabreit, Querformat, Quadrat, Hochformat und Hochformat ab.", desc: "Flux Pro 1.1 Ultra und Flux Schnell unterstützen beide 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 und 9:21 für Banner, Produktbilder, soziale Inhalte, Poster und mobile Visuals.", prompt: "Ein 21:9-Panorama-Alpenobservatorium über einem Wolkenmeer, eine gläserne Aussichtsplattform, frühes Morgenlicht, winzige Wanderer als Maßstab, filmisches Mattgemälde.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Mehrere visuelle Stile in Schnell", short: "Wählen Sie „Auto“, „Foto“, „Digitale Kunst“ oder „Anime“.", desc: "Flux Schnell bietet Richtungen im Auto-, Foto-, Digitalkunst- und Anime-Stil, sodass Sie ganz einfach zwischen fotorealistischen, illustrierten und Anime-Visuals wechseln können, ohne das Modell wechseln zu müssen.", demo: { type: 'table', rows: [
                        { prompt: "Fotografischer Stil: Ein Fahrradmechaniker, der in einer sonnenbeschienenen Garage ein Oldtimer-Rennrad justiert, fettverschmierte Hände, realistische Chromreflexionen.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "Anime-Stil: ein gemütliches Katzencafé in einem Skytrain, pastellfarbene Sonnenuntergangswolken vor den Fenstern, ausdrucksstarke Charaktere, klare Strichzeichnungen.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "Flexible kreative Anwendungsfälle", short: "Erstellen Sie Produkt-, Marketing-, Porträt-, Konzept- und Social-Visuals.", desc: "Die FLUX.1-Familie unterstützt ausgefeilte Produkt- und Markenbilder sowie schnelle Kampagnenkonzepte, Porträts, Umgebungsdesigns und plattformspezifische Seitenverhältnisse.", prompt: "Nachhaltiges Sneaker-Launch-Visual mit recycelter Stoffstruktur, schwebenden Spitzendetails, moosgrünem Hintergrund mit Farbverlauf und auffälligem Leerraum für Social-Media-Werbetexte.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "FLUX.1-Eingabeaufforderungsbeispiele für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese FLUX.1-Eingabeaufforderungen als Ausgangspunkt. Beschreiben Sie klar und deutlich das Motiv, die Komposition, die Beleuchtung, die Kamera, die Materialien, die Farbpalette und den visuellen Stil.",
                variantsKicker: "Modellführer",
                variantsTitle: "Flux Pro 1.1 Ultra vs. Flux Schnell",
                variantsIntro: "Wählen Sie ein FLUX.1-Modell basierend auf der Qualität, Geschwindigkeit und Stilkontrolle, die Ihr Projekt benötigt.",
                variants: [
                    { name: "Flux Pro 1.1 Ultra", tag: "Hohe Qualität", desc: "Entwickelt für detaillierte, realistische und ausgefeilte Text-Bild-Arbeiten mit neun unterstützten Seitenverhältnissen.", bestFor: "Ideal für Produktfotografie, Kampagnen-Heldenbilder und ausgefeilte endgültige Visuals" },
                    { name: "Flux Schnell", tag: "Schnell", desc: "Entwickelt für eine schnelle Iteration mit neun Seitenverhältnissen und den Stilen Auto, Foto, Digitale Kunst und Anime.", bestFor: "Am besten geeignet für Entwürfe, schnelle Tests, soziale Inhalte und schnelle Erkundung" }
                ],
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte FLUX.1-Anwendungsfälle",
                useCases: [
                    { name: "FLUX.1 für Produktfotografie", desc: "Erstellen Sie Produktheldenbilder, Lifestyle-Szenen und visuelle E-Commerce-Konzepte." },
                    { name: "FLUX.1 für Marketing und Werbung", desc: "Generieren Sie Social Ads, Kampagnenbanner und Markenmarketing-Visuals." },
                    { name: "FLUX.1 für fotorealistische Porträts", desc: "Erstellen Sie fotoähnliche Porträts mit kontrollierter Beleuchtung, Hintergründen und Komposition." },
                    { name: "FLUX.1 für digitale Kunst", desc: "Nutzen Sie Schnell, um schnell Illustrations-, Fantasy- und digitale Kunstrichtungen zu erkunden." },
                    { name: "FLUX.1 für Anime-Bilder", desc: "Verwenden Sie den Schnell-Anime-Stil für Charaktere und Anime-Szenen." },
                    { name: "FLUX.1 für Konzeptkunst", desc: "Entdecken Sie filmische Umgebungen, Spielszenen, Charaktere und visuelle Welten." },
                    { name: "FLUX.1 für Social-Media-Bilder", desc: "Verwenden Sie neun Seitenverhältnisse für Plattforminhalte im Quer-, Quadrat- und Hochformat." },
                    { name: "FLUX.1 für Poster und Banner", desc: "Wählen Sie ein geeignetes Verhältnis für Veranstaltungen, Werbeaktionen und mobile Seitenlayoutkonzepte." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So nutzen Sie den FLUX.1 AI Image Generator kostenlos online",
                howToIntro: "Melden Sie sich an, um kostenlose Credits zu erhalten und Flux Pro 1.1 Ultra oder Flux Schnell online auf Miral zu nutzen.",
                howToSteps: [
                    { title: "Geben Sie eine detaillierte Eingabeaufforderung ein", desc: "Beschreiben Sie das Motiv, die Umgebung, die Komposition, die Beleuchtung, die Kamera, die Materialien, die Farben und den Zielstil." },
                    { title: "Wählen Sie Modell und Verhältnis", desc: "Wählen Sie Pro 1.1 Ultra für ausgefeilte Qualität oder Schnell für schnelle Erkundungen und legen Sie dann ein Seitenverhältnis und einen Schnell-Stil fest." },
                    { title: "Generieren und verfeinern", desc: "Erstellen Sie das Bild, überprüfen Sie es und laden Sie es herunter oder passen Sie Eingabeaufforderung, Verhältnis oder Stil für eine andere Version an." }
                ],
                howToCta: "Nutzen Sie den FLUX.1 AI Image Generator kostenlos",
                faqTitle: "Häufig gestellte Fragen zu FLUX.1",
                faqs: [
                    { q: "Was ist der FLUX.1 AI-Bildgenerator?", a: "FLUX.1 ist eine Bilderzeugungsmodellfamilie von Black Forest Labs. Verwenden Sie auf Miral Flux Pro 1.1 Ultra und Flux Schnell, um Textaufforderungen in Produkt-, Marketing-, Porträt-, Anime- und Konzeptkunstbilder umzuwandeln." },
                    { q: "Kann ich den FLUX.1 AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem FLUX.1 AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Was ist der Unterschied zwischen Flux Pro 1.1 Ultra und Flux Schnell?", a: "Flux Pro 1.1 Ultra eignet sich für polierte Endbilder, bei denen es auf Details und Finish ankommt. Flux Schnell eignet sich für schnelle Entwürfe, schnelle Tests und die Erkundung mehrerer Stile mit den Stilen Auto, Fotografie, digitale Kunst und Anime." },
                    { q: "Welche Bildseitenverhältnisse unterstützt FLUX.1?", a: "Flux Pro 1.1 Ultra und Flux Schnell auf Miral unterstützen 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 und 9:21, also insgesamt neun Seitenverhältnisse." },
                    { q: "Welche Stile unterstützt Flux Schnell?", a: "Flux Schnell unterstützt Auto, Fotografie, digitale Kunst und Anime für den automatischen Abgleich, fotorealistische Bilder, digitale Illustrationen und Anime-Visuals." },
                    { q: "Wie verwende ich den FLUX.1 AI-Bildgenerator online?", a: "Geben Sie eine Textaufforderung ein, wählen Sie Flux Pro 1.1 Ultra oder Flux Schnell und legen Sie ein Seitenverhältnis fest. Mit Schnell können Sie auch einen visuellen Stil auswählen, bevor Sie auf „Generieren“ klicken." },
                    { q: "Was sind die besten Beispiele für FLUX.1-Eingabeaufforderungen?", a: "Effektive FLUX.1-Eingabeaufforderungen beschreiben klar und deutlich das Motiv, die Einstellung, die Komposition, die Beleuchtung, die Kamera, die Materialien, die Farbpalette und den Zielstil. Nutzen Sie die Beispiele auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." },
                    { q: "FLUX.1 vs. FLUX.2: Welches soll ich verwenden?", a: "Wählen Sie FLUX.1 für eine polierte Ausgabe mit Flux Pro 1.1 Ultra oder eine schnelle Multi-Style-Erstellung mit Flux Schnell. Wählen Sie die FLUX.2-Seite auf Miral, wenn Sie die Varianten Klein, Max, Pro und Flex benötigen." },
                    { q: "FLUX.1 vs. Midjourney: Was soll ich verwenden?", a: "FLUX.1 eignet sich hervorragend für explizite Seitenverhältnisse, den schnellen Schnell-Workflow oder die ausgefeilte Pro 1.1 Ultra-Ausgabe. Midjourney eignet sich möglicherweise für Benutzer, die den künstlerischen Stil, den Referenzbild-Workflow und den kreativen Prozess bevorzugen." }
                ],
                ctaTitle: "Nutzen Sie FLUX.1 kostenlos auf Miral!",
                ctaDesc: "Melden Sie sich an, um kostenlose Credits zu erhalten. Wählen Sie Flux Pro 1.1 Ultra oder Flux Schnell und erstellen Sie Bilder mit dem Verhältnis und Stil, die Ihr Projekt benötigt."
            },
            flux2: {
                title: "FLUX.2 AI-Bildgenerator kostenlos online | Miral",
                description: "Erstellen Sie online fotorealistische KI-Bilder mit FLUX.2. Wählen Sie fünf Modellvarianten für Produktfotos, Poster, Kunstwerke und ausgefeilte Marketingvisualisierungen.",
                heroHeadline: "FLUX.2 AI-Bildgenerator",
                heroIntro: "Nutzen Sie den FLUX.2 AI-Bildgenerator von Black Forest Labs kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort hochwertige fotorealistische Bilder, Produktfotografien, Poster und Marketingvisualisierungen zu erstellen.",
                eyebrow: "Schwarzwaldlabore · FLUX.2",
                sectionKicker: "FLUX.2",
                ctaTag: "FLUX.2 · Miral",
                badges: ["Text zu Bild", "Fotorealistisch", "Präzise Typografie", "Mehrere Seitenverhältnisse"],
                previewLabel: "FLUX.2",
                previewMeta: ["1:1", "1024 × 1024", "PNG"],
                previewTitle: "Von der präzisen Eingabeaufforderung bis zum produktionsreifen Bild",
                previewDesc: "Erstellen Sie detaillierte Produktaufnahmen, Kampagnenkonzepte, Porträts und textreiche Designs in einem optimierten Workflow.",
                keyFeaturesTitle: "Erstellen Sie professionelle Visuals mit dem FLUX.2 Text-to-Image-Generator",
                keyFeaturesIntro: "Entdecken Sie die wichtigsten Funktionen des FLUX.2 AI-Bildgenerators für präzise Eingabeaufforderungen, ausgefeilte Details, realistische Ausgabe und zuverlässige visuelle Kontrolle.",
                exploreTitle: "Entdecken Sie weitere KI-Bildmodelle",
                mainFeaturesTitle: "Wichtige FLUX.2-Funktionen",
                generatedImageLabel: "Generiertes Bild",
                versionLabel: "Version",
                featureLabel: "Hauptmerkmale",
                useCaseLabel: "Am besten für",
                controlsTitle: "Wählen Sie die richtige FLUX.2-Version und die richtigen Ausgabeeinstellungen",
                controlsIntro: "Verwenden Sie Klein für eine schnelle Iteration, Max für höchste Endqualität, Pro für Produktionsabläufe oder Flex für Typografie und feine Detailkontrolle.",
                galleryTitle: "Weitere FLUX.2-Bildbeispiele",
                discussionTitle: "Häufige Fragen zum FLUX.2-Modell",
                communityTitle: "Beliebte Möglichkeiten zum Erstellen mit FLUX.2",
                tutorialPrompt: "Premium-Kampagnenfoto einer durchscheinenden smaragdgrünen Parfümflasche auf hellem Kalkstein, sanftes Morgenlicht, realistische Glasbrechung, raffinierte Typografie, großzügiger Negativraum.",
                qualityBenefits: [
                    "Befolgen Sie detaillierte Anweisungen und haben Sie eine bessere Kontrolle über Motiv, Komposition, Beleuchtung und Stil.",
                    "Erstellen Sie realistische Texturen, Tiefe und ausgefeilte Details für professionelle visuelle Arbeit.",
                    "Behandeln Sie textreiche Poster, Produktetiketten und Kampagnengrafiken mit klarerer Typografie."
                ],
                features: [
                    { name: "High-End-Bildsynthese", short: "Bietet eine verbesserte sofortige Adhärenz und Bildqualität ohne zusätzliche Latenz.", desc: "FLUX.2 verbessert die sofortige Ausrichtung erheblich und unterstützt sogar lange Eingaben wie detaillierte Skripte und Szenenbeschreibungen. Dadurch wird sichergestellt, dass die generierten Bilder eine höhere Wiedergabetreue bieten, ohne Kompromisse bei der Geschwindigkeit einzugehen, wodurch die Notwendigkeit iterativer Anpassungen verringert wird und die Ersteller schneller zu einem fertigen Ergebnis gelangen können.", demo: { type: 'table', rows: [
                        { prompt: "Eine atemberaubende Landschaft mit leuchtenden Farben und komplizierten Details, die einen Sonnenuntergang über einer Bergkette zeigt.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "Abstrakte Kunst zum Übersetzen zwischen funktionalen Sprachen und Low-Level-Sprachen." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "Ein Porträtfoto einer Anime-/Cartoon-Figur, detailliert und gut gemacht, sieht aber trotzdem wie von Menschenhand geschaffen aus." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "Überlegene Details und Realismus", short: "Erzeugt lebensechte Texturen, Beleuchtung und Tiefe für Bilder in Studioqualität.", desc: "FLUX.2 erfasst feine Texturen, realistische Beleuchtung und natürliche Tiefe, sodass die generierten Bilder wirklich fotografisch aussehen. Dadurch eignet es sich hervorragend für Produktaufnahmen, Porträts und filmische Visuals, bei denen die Glaubwürdigkeit am wichtigsten ist.", prompt: "Studioproduktfoto einer silbernen mechanischen Uhr auf dunklem Schiefer, sanfte Seitenbeleuchtung, realistische Textur aus gebürstetem Metall, geringe Schärfentiefe, subtile Reflexionen, erstklassige redaktionelle Komposition." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "Starke sofortige Haftung", short: "Befolgt genau komplexe Anweisungen, einschließlich spezifischer Themen, Stile und Kompositionen.", desc: "FLUX.2 interpretiert geschichtete, mehrteilige Eingabeaufforderungen mit beeindruckender Genauigkeit und behandelt spezifische Themen, Kunststile, Farbpaletten und Kompositionsanweisungen in einer einzigen Generation. Dies gibt den Erstellern mehr Kontrolle und weniger Wiederholungen, wenn sie genau beschreiben, was sie wollen.", prompt: "Eine rote Straßenbahn überquert in der Abenddämmerung einen verregneten europäischen Platz, drei Radfahrer im Vordergrund, warme Caféfenster auf der linken Seite, blauer Stundenhimmel, symmetrische Komposition, filmische Fotografie.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "Erweiterter Umgang mit Typografie", short: "Stellt Text in Bildern mit klarerer Rechtschreibung und Stilkonsistenz dar.", desc: "FLUX.2 bietet eine verbesserte Textgenerierung und -steuerung für alle Bilder sowie eine genauere Konsistenz der Schriftarten. Dadurch ist es möglich, textbasierte Materialien und Beschilderungen für Plakate, Anzeigen, Comics und Markengrafiken mit weitaus weniger Artefakten zu erstellen.", demo: { type: 'table', rows: [
                        { prompt: "Ein wunderschönes mystisches Landschaftsfoto mit dem Text „FLUX 2“, subtile Schönheit, eingearbeitete Blaubeeren." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "Eine Schwarzwälder Kirschtorte mit der Aufschrift „FLUX 2 Pro“, leckere Food-Fotografie." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "Schnelle und skalierbare Generierung", short: "Wählen Sie zwischen einer Iteration in weniger als einer Sekunde und einer Ausgabe mit maximaler Qualität.", desc: "FLUX.2 umfasst schnelle Klein-Modelle und produktionsorientierte Pro-, Max- und Flex-Varianten. Dieses Sortiment eignet sich hervorragend für schnelle Entwürfe, die Produktion von Batch-Inhalten sowie für Marketing- oder Kreativ-Assets in Endqualität.", prompt: "Ein sauberes redaktionelles Produktfoto einer durchscheinenden grünen Parfümflasche auf Kalkstein, sanftes Morgenlicht, subtile Schatten, erstklassige Kampagnenästhetik." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "FLUX.2-Eingabeaufforderungsbeispiele für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese FLUX.2-Prompt-Beispiele als Ausgangspunkt, passen Sie das Motiv, die Komposition, die Beleuchtung und den Stil an und senden Sie dann Ihr Prompt direkt an den Generator.",
                variantsKicker: "Modellführer",
                variantsTitle: "FLUX.2-Modellvergleich: Klein vs. Max vs. Pro vs. Flex",
                variantsIntro: "Vergleichen Sie FLUX.2 Klein, Max, Pro und Flex, um das richtige KI-Bildmodell für schnelle Iteration, Assets in Endqualität, Produktionsmaßstab oder feine Typografiesteuerung auszuwählen.",
                variants: [
                    { name: "FLUX.2 Klein 4B / 9B", tag: "Am schnellsten", desc: "Wählen Sie FLUX.2 Klein für die schnelle, großvolumige Bilderzeugung, Entwürfe und Rapid Prototyping.", bestFor: "Am besten für Entwürfe, Stapel und schnelle Iteration geeignet" },
                    { name: "FLUX.2 Max", tag: "Höchste Qualität", desc: "Wählen Sie FLUX.2 Max für endgültige Assets, die stärkste Prompt-Following-Funktion und eine fundierte Generation.", bestFor: "Am besten für Premium-Kampagnen und Heldenbilder geeignet" },
                    { name: "FLUX.2 Pro", tag: "Produktion", desc: "Wählen Sie FLUX.2 Pro für ein produktionstaugliches Gleichgewicht aus Bildqualität, Durchlaufzeit und skalierbarer Ausgabe.", bestFor: "Am besten für Marketing und Content-Produktion geeignet" },
                    { name: "FLUX.2 Flex", tag: "Kontrolle", desc: "Wählen Sie FLUX.2 Flex für anpassbare Führung, Typografie, Textwiedergabe und den Erhalt kleiner Details.", bestFor: "Am besten geeignet für Poster, Etiketten und Design-Assets" }
                ],
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte FLUX.2-Anwendungsfälle",
                useCases: [
                    { name: "FLUX.2 für Produktfotografie", desc: "Erstellen Sie ausgefeilte Produktaufnahmen, Lifestyle-Szenen und E-Commerce-Bildvariationen." },
                    { name: "FLUX.2 für Marketing & Werbung", desc: "Verwandeln Sie Kampagnenkonzepte in soziale Anzeigen, Banner und konsistente Markenvisualisierungen." },
                    { name: "FLUX.2 für Poster und Typografie", desc: "Verwenden Sie die Textwiedergabe von FLUX.2, um klarere Schlagzeilen, Etiketten, Poster und textbasierte Grafiken zu erstellen." },
                    { name: "FLUX.2 für fotorealistische Porträts", desc: "Erstellen Sie detaillierte KI-Porträts mit kontrollierter Beleuchtung, Stil und Komposition." },
                    { name: "FLUX.2 für Konzeptkunst", desc: "Erkunden Sie schnell filmische Umgebungen, Charaktere und visuelle Richtungen." },
                    { name: "FLUX.2 für Editorial Design", desc: "Erstellen Sie unverwechselbare Illustrationen und Cover für Artikel und Präsentationen." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So verwenden Sie den FLUX.2 AI Image Generator online",
                howToIntro: "Verwenden Sie den FLUX.2 AI-Bildgenerator online auf Miral, um von einer detaillierten Textaufforderung zu einem generierten Bild zu gelangen.",
                howToSteps: [
                    { title: "Geben Sie Ihre Eingabeaufforderung ein", desc: "Beschreiben Sie das Motiv, die Komposition, die Beleuchtung, die Farben, den Stil und den Text, der im Bild erscheinen soll." },
                    { title: "Wählen Sie FLUX.2-Einstellungen", desc: "Öffnen Sie den Generator, wählen Sie Klein, Max, Pro oder Flex und wählen Sie dann die Ausgabegröße, die zu Ihrem Projekt passt." },
                    { title: "Generieren Sie Ihr Bild", desc: "Beginnen Sie mit der Generierung, überprüfen Sie das Ergebnis und laden Sie das Bild herunter oder verfeinern Sie Ihre Eingabeaufforderung für eine andere Version." }
                ],
                howToCta: "Probieren Sie FLUX.2 AI Image Generator aus",
                faqTitle: "Häufig gestellte Fragen zu FLUX.2",
                faqs: [
                    { q: "Was ist FLUX.2?", a: "FLUX.2 ist das Text-zu-Bild-KI-Modell der nächsten Generation von Black Forest Labs. Es wandelt schriftliche Eingabeaufforderungen in hochwertige, detaillierte Bilder um und ist auf Miral für Kunst, Design, Marketing und visuelle Produkterstellung direkt in Ihrem Browser verfügbar." },
                    { q: "Mit welchem Tool kann ich Produktfotografie und textreiche Marketingvisualisierungen erstellen?", a: "FLUX.2 kombiniert sofortige Kohärenz, Detailgenauigkeit, Fotorealismus und Typografie-Handhabung für professionelle Produktfotografie und textreiche Marketingvisualisierungen, die Treue und Genauigkeit erfordern." },
                    { q: "Kann ich den FLUX.2 AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem FLUX.2 AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den FLUX.2 AI-Bildgenerator online?", a: "Geben Sie eine detaillierte Textaufforderung ein, wählen Sie FLUX.2 Klein, Max, Pro oder Flex, wählen Sie eine Bildgröße aus und klicken Sie auf „Generieren“. FLUX.2 eignet sich gut für Marketingmaterialien, Produktfotografie, Filmkonzepte, Social Creatives und Posterdesigns." },
                    { q: "Wie lange dauert die Generierung von FLUX.2?", a: "Die Generierungszeit hängt von der ausgewählten FLUX.2-Variante, der Bildgröße und der aktuellen Dienstlast ab. Klein ist für eine sehr schnelle Iteration konzipiert, während Max, Pro und Flex unterschiedliche Balancen zwischen Qualität und Kontrolle priorisieren." },
                    { q: "Wie kann ich ein FLUX.2-Bild reparieren, das meiner Aufforderung nicht folgt?", a: "Beschreiben Sie das Thema, die Einstellung, die Komposition, die Beleuchtung, die Kamera oder den Kunststil, die Farben und den erforderlichen Text genauer. Nutzen Sie die FLUX.2-Eingabeaufforderungsbeispiele auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." },
                    { q: "Welches FLUX.2-Modell soll ich wählen?", a: "Wählen Sie FLUX.2 Klein für schnelle Entwürfe und Stapel, Max für die Endergebnisse höchster Qualität, Pro für die Bilderzeugung im Produktionsmaßstab oder Flex, wenn Typografie und Feinsteuerung am wichtigsten sind." },
                    { q: "FLUX.2 Max vs. Pro: Was ist der Unterschied?", a: "FLUX.2 Max legt Wert auf maximale Qualität, starke Direktverfolgung und fundierte Generierung. FLUX.2 Pro vereint Qualität auf Produktionsniveau, schnellere Durchlaufzeiten und skalierbare Ausgabe für alltägliche kreative Arbeitsabläufe." },
                    { q: "FLUX.2 vs. Midjourney: Was soll ich verwenden?", a: "Wählen Sie basierend auf dem Workflow und nicht auf der Grundlage eines universellen Gewinners. FLUX.2 eignet sich hervorragend für präzise Eingabeaufforderungen, Typografie, Produktvisualisierungen und API-basierte Produktion. Midjourney eignet sich möglicherweise für Kreative, die den unverwechselbaren künstlerischen Workflow und die Community-Tools bevorzugen." }
                ],
                ctaTitle: "Testen Sie FLUX.2 kostenlos auf Miral!",
                ctaDesc: "Geben Sie oben Ihre Idee ein und erstellen Sie mit dem FLUX.2 AI-Bildgenerator detaillierte Bilder mit der Modellvariante, die zu Ihrem Workflow passt."
            },
            seedream: {
                title: "Seedream AI-Bildgenerator kostenlos online | Miral",
                description: "Generieren Sie mit Seedream online hochwertige KI-Bilder. Erhalten Sie präzises, schnelles Verständnis, klare Textwiedergabe und detaillierte 2K-4K-Ausgabe für kreative Projekte.",
                heroHeadline: "Seedream AI-Bildgenerator",
                heroIntro: "Nutzen Sie den Seedream AI-Bildgenerator kostenlos. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort hochwertige Produktvisualisierungen, Poster, Porträts und Marketingbilder zu erstellen.",
                eyebrow: "ByteDance Seed · Seedream AI",
                sectionKicker: "Seedream-KI",
                ctaTag: "Seedream · Miral",
                badges: ["Text zu Bild", "Absichtsverständnis", "2K / 3K / 4K-Ausgabe", "Klare Textwiedergabe"],
                previewLabel: "Seedream-KI",
                previewMeta: ["1:1", "2K / 3K / 4K", "Benutzerdefinierte Größe"],
                previewTitle: "Von der kreativen Absicht bis hin zu einem präzisen, hochauflösenden Bild",
                previewDesc: "Erstellen Sie komplexe Kompositionen, Produktaufnahmen, Porträts und textreiche Designs mit raffinierten Details und zuverlässiger sofortiger Kontrolle.",
                keyFeaturesTitle: "Erstellen Sie präzise Bilder mit dem AI-Text-zu-Bild-Generator von Seedream",
                keyFeaturesIntro: "Entdecken Sie die KI-Funktionen von Seedream für ein tieferes Absichtsverständnis, komplexe Komposition, hochauflösende Ausgabe, realistische Details und genaue Textwiedergabe durch Text-zu-Bild-Generierung.",
                exploreTitle: "Entdecken Sie die KI-Modelle von Seedream",
                mainFeaturesTitle: "Wichtige Text-zu-Bild-Funktionen von Seedream AI",
                seedream5Desc: "Nutzen Sie das neueste Seedream-Modell für präzise Eingabeaufforderungen, raffinierten Realismus, Textwiedergabe und hochauflösende Ausgabe.",
                seedream4Desc: "Öffnen Sie den etablierten Seedream 4-Workflow für eine zuverlässige Text-zu-Bild-Erstellung und flexible Ausgabeeinstellungen.",
                features: [
                    { name: "Tiefergehendes, schnelles Verständnis", short: "Interpretiert kreative Absichten, räumliche Beziehungen und detaillierte Anweisungen.", desc: "Seedream AI geht über das Abgleichen isolierter Eingabeaufforderungsbegriffe hinaus. Es untersucht die Beziehungen zwischen Themen, Layout, Attributen und visuellem Kontext, um aus komplexen Textanweisungen kohärentere Ergebnisse zu erzielen.", demo: { type: 'table', rows: [
                        { prompt: "Ein 3x3 großes Ausstellungsregal, Vorderansicht, mit neun verschiedenen Objekten, geordnet nach Material und Farbe, gleichmäßiger Studiobeleuchtung und präziser räumlicher Ausrichtung.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "Redaktionelles Produktfoto einer Uhr neben gefaltetem Leinen und einer Keramiktasse, ausgewogene dreieckige Komposition, sanftes Morgenlicht.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "Eine filmische Marktszene mit Käufern im Vordergrund, einem klaren zentralen Motiv, geschichteter Tiefe und warmem Licht, das auf nassem Asphalt reflektiert wird.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "Komplexe Kompositionskontrolle", short: "Behandelt mehrere Themen, Attribute und strukturierte Layouts mit größerer Kohärenz.", desc: "Der AI-Bildgenerator von Seedream folgt mehrteiligen Anweisungen in komplexen Szenen und hilft dabei, die gewünschten Objektattribute, Positionen, Farben und Beziehungen in einer einzigen Komposition beizubehalten.", prompt: "Eine nach vorne gerichtete redaktionelle Szene mit drei Keramikvasen in verschiedenen Formen auf versetzten Steinplattformen, einer roten Kugel hinter der höchsten Vase, sanfter Seitenbeleuchtung, ausgewogenen Abständen und neutralem Studiohintergrund.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "2K-, 3K- und 4K-Ausgabe", short: "Wählen Sie eine Ausgabeauflösung basierend auf den Details und Abmessungen, die Ihr Projekt benötigt.", desc: "Seedream AI unterstützt die wählbare 2K-, 3K- und 4K-Ausgabe auf Miral sowie benutzerdefinierte Bildgrößen. Wählen Sie basierend auf den Abmessungen und dem Detaillierungsgrad, die für Ihre endgültige Verwendung erforderlich sind.", prompt: "Eine weite filmische Landschaft einer futuristischen Küstenstadt bei Sonnenaufgang, vielschichtige Architektur, spiegelndes Wasser, atmosphärische Tiefe, komplizierte Gebäudedetails, Panoramakomposition.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "Verbesserte Textwiedergabe", short: "Erstellt klareren Text für Poster, Layouts, Etiketten und Präsentationsgrafiken.", desc: "Seedream AI kombiniert visuelles Denken mit verbesserter Texterstellung und eignet sich daher für Poster, Präsentationsgrafiken, Anzeigen, Verpackungskonzepte und andere Layouts, bei denen lesbarer Text Teil des Bildes ist.", demo: { type: 'table', rows: [
                        { prompt: "Minimalistisches Veranstaltungsplakat mit der Überschrift „DESIGN FOR TOMORROW“, kräftiger geometrischer Schrift, weißem Hintergrund, grünem Akzentraster.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "Premium-Kaffeepaket mit der Aufschrift „MIRAL ROAST“, prägnante Verkostungsnotizen, warme Papierstruktur, Studio-Produktfotografie.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "Raffinierte Details und Realismus", short: "Erzeugt überzeugende Beleuchtung, Materialien, Tiefe und Produktpräsentation.", desc: "Seedream AI rendert raffinierte Texturen und kohärente Beleuchtung für Produktfotografie, Porträts, redaktionelle Visuals und Filmkonzepte, bei denen es auf Klarheit und glaubwürdige Struktur ankommt.", prompt: "Ein sauberes redaktionelles Produktfoto einer durchscheinenden grünen Parfümflasche auf Kalkstein, sanftes Morgenlicht, subtile Schatten, erstklassige Kampagnenästhetik.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "Beispiele für AI-Eingabeaufforderungen von Seedream für bessere KI-Bilder",
                showcaseIntro: "Nutzen Sie diese Seedream AI-Eingabeaufforderungsbeispiele als Ausgangspunkt. Beschreiben Sie Themen, räumliche Beziehungen, Text, Beleuchtung und Layout klar und deutlich und senden Sie die Eingabeaufforderung dann direkt an den Generator.",
                variantsKicker: "Anleitung zur Auflösung",
                variantsTitle: "Seedream AI-Auflösungsleitfaden: 2K vs. 3K vs. 4K",
                variantsIntro: "Wählen Sie eine Seedream AI-Ausgabeauflösung basierend darauf, wie schnell Sie iterieren möchten und wie viele Details das endgültige Asset erfordert.",
                variants: [
                    { name: "2K", tag: "Standardausgabe", desc: "Eine praktische Lösung für soziale Inhalte, alltägliche kreative Arbeit und digitale Standardlayouts.", bestFor: "Am besten für normale digitale Inhalte geeignet" },
                    { name: "3K", tag: "Mehr Details", desc: "Fügt mehr Bilddetails hinzu und unterstützt größere Layouts für Marketing- und Präsentationsarbeiten.", bestFor: "Am besten für Marketing- und Präsentationsressourcen geeignet" },
                    { name: "4K", tag: "Maximale Detailgenauigkeit", desc: "Verwenden Sie die höchste Voreinstellung, wenn feine Texturen, textlastige Layouts oder eine erstklassige Lieferqualität wichtig sind.", bestFor: "Ideal für finale Kampagnen und hochauflösende Ausgabe" }
                ],
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte Seedream-KI-Anwendungsfälle",
                useCases: [
                    { name: "Seedream AI für Produktfotografie", desc: "Erstellen Sie ausgefeilte Produktaufnahmen, Lifestyle-Szenen und E-Commerce-Bildkonzepte." },
                    { name: "Seedream AI für Marketing", desc: "Verwandeln Sie strukturierte Kampagnenideen in soziale Anzeigen, Banner und Markenvisualisierungen." },
                    { name: "Seedream AI für Poster und Text", desc: "Erstellen Sie Plakatkonzepte, Präsentationsgrafiken, Etiketten und textbasierte Layouts." },
                    { name: "Seedream AI für komplexe Kompositionen", desc: "Ordnen Sie mehrere Themen und gewünschte Attribute in einer zusammenhängenden visuellen Struktur an." },
                    { name: "Seedream AI für Konzeptkunst", desc: "Entdecken Sie filmische Umgebungen, Charaktere und detaillierte visuelle Anweisungen." },
                    { name: "Seedream AI für redaktionelle Visuals", desc: "Erstellen Sie Cover, Illustrationen, Infografiken und präsentationsfertige Bilder." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So nutzen Sie den Seedream AI-Bildgenerator kostenlos online",
                howToIntro: "Melden Sie sich an, um kostenlose Credits zu erhalten und den Seedream AI-Bildgenerator online mit einer klaren Eingabeaufforderung und der für Ihr Projekt erforderlichen Auflösung zu nutzen.",
                howToSteps: [
                    { title: "Geben Sie Ihre kreative Absicht ein", desc: "Beschreiben Sie die Themen, räumlichen Beziehungen, Komposition, Beleuchtung, Stil und den erforderlichen Text so klar wie möglich." },
                    { title: "Wählen Sie Auflösung und Größe", desc: "Öffnen Sie den Generator und wählen Sie 2K, 3K, 4K oder eine unterstützte benutzerdefinierte Größe basierend auf Ihrer endgültigen Verwendung." },
                    { title: "Generieren und überprüfen", desc: "Beginnen Sie mit der Generierung, überprüfen Sie die Zusammensetzung und Details, laden Sie dann das Ergebnis herunter oder passen Sie Ihre Eingabeaufforderung an." }
                ],
                howToCta: "Nutzen Sie den Seedream AI Image Generator kostenlos",
                faqTitle: "Häufig gestellte Fragen zu Seedream AI",
                faqs: [
                    { q: "Was ist der Seedream AI-Bildgenerator?", a: "Seedream AI ist ein intelligentes Bilderstellungsmodell des Seed-Teams von ByteDance. Auf Miral werden detaillierte Textaufforderungen in hochauflösende Bilder für Design, Marketing, Produktkonzepte, Poster und redaktionelle Visuals umgewandelt." },
                    { q: "Mit welchem Tool kann ich hochauflösende Poster mit Klartext erstellen?", a: "Seedream AI kombiniert ein tieferes Absichtsverständnis, eine präzise Komposition, eine verbesserte Texterstellung und eine wählbare hochauflösende Ausgabe für Poster und andere textreiche Layouts." },
                    { q: "Kann ich den Seedream AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem Seedream AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den Seedream AI-Bildgenerator online?", a: "Geben Sie eine detaillierte Textaufforderung ein, wählen Sie die Ausgabe in 2K, 3K oder 4K, wählen Sie optional eine benutzerdefinierte Größe aus und klicken Sie auf „Generieren“. Um bessere Ergebnisse zu erzielen, beschreiben Sie die Themen, räumlichen Beziehungen, Attribute, Beleuchtung, Text und Layout klar." },
                    { q: "Unterstützt Seedream AI 2K-, 3K- und 4K-Bilder?", a: "Ja. Miral stellt 2K-, 3K- und 4K-Auflösungsvoreinstellungen für Seedream AI bereit, zusammen mit unterstützten benutzerdefinierten Abmessungen für verschiedene Seitenverhältnisse und Bereitstellungsanforderungen." },
                    { q: "Wie kann ich Seedream-Bilder mit falschem Text oder falscher Komposition reparieren?", a: "Beschreiben Sie das Thema, die Beziehungen zwischen Objekten, die Komposition, die Beleuchtung, die Farben, den Stil und den erforderlichen Text genauer. Nutzen Sie die Seedream-Beispiele auf dieser Seite als Ausgangspunkt und formulieren Sie jede visuelle Anforderung klar und deutlich." },
                    { q: "Welche Seedream AI-Auflösung soll ich wählen?", a: "Wählen Sie 2K für standardmäßige digitale Inhalte, 3K, wenn Marketing- oder Präsentationslayouts mehr Details erfordern, und 4K, wenn maximale Details für große Abschlusskampagnen, Poster oder Premium-Design-Assets wichtig sind." },
                    { q: "Seedream AI vs. Midjourney: Was soll ich verwenden?", a: "Seedream AI eignet sich hervorragend für strukturierte Eingabeaufforderungen, komplexe Kompositionen, textreiche Layouts und auswählbare hochauflösende Ausgaben in Miral. Midjourney eignet sich möglicherweise für Kreative, die den unverwechselbaren künstlerischen Workflow und die Community-Tools bevorzugen." }
                ],
                ctaTitle: "Nutzen Sie Seedream AI kostenlos auf Miral!",
                ctaDesc: "Melden Sie sich an, um kostenlose Credits zu erhalten. Beschreiben Sie Ihre Idee, wählen Sie die richtige Auflösung und verwenden Sie den Seedream AI-Bildgenerator, um präzise, ​​hochauflösende Bilder zu erstellen."
            },
            gptImage: {
                title: "GPT Image AI Image Generator kostenlos online | Miral",
                description: "Generieren Sie online hochwertige KI-Bilder mit GPT Image und GPT-Image-1.5 auf Miral AI. Wählen Sie praktische Größen und Qualitätsstufen für Poster, Produkte und Porträts.",
                heroHeadline: "GPT Image AI-Bildgenerator",
                heroIntro: "Nutzen Sie den GPT Image AI-Bildgenerator kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und mit GPT-Image-1.5 sofort hochwertige Produktbilder, Poster, Porträts und Marketingvisualisierungen zu erstellen.",
                eyebrow: "OpenAI · GPT-Image-1.5",
                sectionKicker: "GPT-Bild",
                ctaTag: "GPT-Bild · Miral",
                badges: ["Text zu Bild", "Wählbare Qualität", "Querformat / Hochformat / Quadratisch", "Präzises, schnelles Verständnis"],
                previewLabel: "GPT-Image-1.5",
                previewMeta: ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
                previewTitle: "Von einer schriftlichen Idee bis hin zu einem ausgefeilten, praktischen KI-Bild",
                previewDesc: "Verwenden Sie klare Anweisungen und wählbare Qualität, um Produktvisualisierungen, Poster, Porträts und Markeninhalte zu erstellen.",
                keyFeaturesTitle: "Erstellen Sie hochwertige Grafiken mit dem GPT Image AI Image Generator",
                keyFeaturesIntro: "Entdecken Sie die Funktionen von GPT-Image-1.5 für schnelles Verständnis, Qualitätskontrolle, praktische Bildgrößen und professionelle visuelle Erstellung.",
                features: [
                    { name: "Eingabeaufforderungen in natürlicher Sprache und mit mehreren Themen", short: "Beschreiben Sie Themen, Komposition, Beleuchtung, Stil und visuelle Beziehungen in natürlicher Sprache.", desc: "Der GPT Image AI-Bildgenerator unterstützt Eingabeaufforderungen in natürlicher Sprache mit mehreren Themen, Attributen und Kompositionsanforderungen. Beginnen Sie mit einer einfachen Eingabeaufforderung oder geben Sie die Position, Farbe und Beziehung jedes Motivs an, um kohärentere Bilder mit mehreren Motiven zu erstellen.", demo: { type: 'table', rows: [
                        { prompt: "Redaktionelle Produktfotografie einer transparenten Parfümflasche auf einem hellen Steinsockel, sanftes Morgenlicht von links, klarer Hintergrund, geringe Schärfentiefe, erstklassige Markenästhetik.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "Eine verregnete Stadtstraße bei Nacht, drei Fußgänger im Vordergrund mit Regenschirmen in verschiedenen Farben, eine in der Ferne vorbeifahrende Straßenbahn, Neonreflexionen auf nassem Asphalt, filmische Gesamtkomposition.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "GPT-Image-1.5 Qualitätskontrolle", short: "Wählen Sie je nach Geschwindigkeits- und Detailanforderungen „Auto“, „Niedrig“, „Mittel“ oder „Hoch“.", desc: "GPT-Image-1.5 bietet automatische, niedrige, mittlere und hohe Qualitätseinstellungen. Verwenden Sie eine niedrigere Qualität für eine schnelle Erkundung und eine höhere Qualität für endgültige Produktbilder, Poster oder Marketingressourcen.", prompt: "Hochwertige Food-Werbung für einen Erdbeerkuchen vor schwarzem Hintergrund, knackige Cremetextur, weiches Randlicht, detaillierte Food-Fotografie, kommerzielle Komposition.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "Drei praktische Bildgrößen", short: "Erstellen Sie Ausgaben im Quadrat-, Quer- und Hochformat.", desc: "Wählen Sie 1024×1024, 1536×1024 oder 1024×1536 für Social-Media-Beiträge, Banner und Präsentationsvisualisierungen oder Porträtplakate und mobile Inhalte.", prompt: "Ein Reiseplakat im Porträtformat 1024×1536 mit einer Klippe am Meer und einem Leuchtturm im Morgennebel, Platz für eine Überschrift oben und modernem redaktionellen Layout.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "Übersichtliche Text- und Layouterstellung", short: "Erstellen Sie Poster-, Etiketten- und Markenkonzepte mit Text.", desc: "Durch die klare Angabe des erforderlichen Textes, der Platzierung, der typografischen Stimmung und der Layoutbeziehungen kann GPT Image dabei helfen, Poster, Verpackungen, Veranstaltungsgrafiken und Marketingbilder mit Schlagzeilen zu erkunden.", demo: { type: 'table', rows: [
                        { prompt: "Minimalistisches Technologie-Event-Poster mit der Überschrift „CREATE THE FUTURE“, fetter serifenloser Schrift, tiefblauem Hintergrund, grünem geometrischem Raster, klarer zentrierter Überschrift.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "Premium-Kaffeeverpackungskonzept mit dem Text „MIRAL ROAST“ auf der Vorderseite, warmer brauner Papierstruktur, sauberem Etikett, Studioproduktfotografie.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "Detail und Realismus", short: "Stellen Sie glaubwürdige Materialien, Beleuchtung, Personen und Produktdetails dar.", desc: "GPT Image eignet sich gut für Produktfotografie, Porträts, Innenräume und redaktionelle Bilder, wenn in der Eingabeaufforderung Materialien, Kameraauswahl, Beleuchtung und Schärfentiefe klar beschrieben werden.", prompt: "Enges redaktionelles Porträt eines Keramikkünstlers bei natürlichem Fensterlicht, realistischer Hautstruktur, Tonstaub auf den Händen, Werkstatthintergrund, geringer Schärfentiefe, warmer redaktioneller Fotografie.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "Beispiele für GPT-Bildaufforderungen für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese GPT-Bild-Eingabeaufforderungen als Ausgangspunkt. Beschreiben Sie klar und deutlich das Thema, die Komposition, die Beleuchtung, den Stil, die Materialien und den erforderlichen Text.",
                variantsKicker: "Versionsleitfaden",
                variantsTitle: "GPT-Image-1.5 vs. GPT-Image-1",
                variantsIntro: "Wählen Sie eine GPT-Bildversion basierend darauf, ob Sie eine Qualitätskontrolle benötigen. Beide unterstützen praktische Formate im Quadrat-, Quer- und Hochformat.",
                variants: [
                    { name: "GPT-Image-1.5", tag: "Empfohlen", desc: "Unterstützt 1024×1024, 1536×1024 und 1024×1536 mit den Optionen Auto, Niedrig, Mittel und Hoch.", bestFor: "Ideal für alltägliche und professionelle Arbeiten, die eine Qualitätskontrolle erfordern" },
                    { name: "GPT-Bild-1", tag: "Klassisch", desc: "Unterstützt die gleichen drei praktischen Bildgrößen mit einfacheren Steuerelementen.", bestFor: "Ideal für die unkomplizierte, universelle Text-zu-Bild-Erstellung" }
                ],
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte Anwendungsfälle für GPT-Bilder",
                useCases: [
                    { name: "GPT-Bild für Produktfotografie und Mockups", desc: "Erstellen Sie Produktheldenbilder, Lifestyle-Szenen, Produktmodelle und visuelle E-Commerce-Konzepte." },
                    { name: "GPT-Bild für E-Commerce-Eintragsbilder", desc: "Entdecken Sie Produktlistenbilder, Feature-Grafiken, Verpackungsdisplays und Werbekonzepte." },
                    { name: "GPT-Bild für Marketing- und Social-Media-Anzeigen", desc: "Erstellen Sie Social-Media-Anzeigen, Kampagnenbanner, E-Mail-Banner und Markenmarketing-Visuals." },
                    { name: "GPT-Bild für UI/UX und Website-Layouts", desc: "Erstellen Sie visuelle Konzepte für App-Oberflächen, Website-Layouts, Landingpages und Produktpräsentationsseiten." },
                    { name: "GPT-Bild für Infografiken und visuelle Berichte", desc: "Entdecken Sie Layoutkonzepte für Infografiken, visuelle Berichte und Präsentationsgrafiken. Überprüfen Sie alle Texte und Daten vor der endgültigen Verwendung." },
                    { name: "GPT-Bild für Poster und Produktverpackungen", desc: "Entdecken Sie Poster, Produktetiketten und Verpackungsdesigns mit Anforderungen an Überschrift und Layout." },
                    { name: "GPT-Bild für Buchcover und Blog-Bilder", desc: "Erstellen Sie Buchcover, redaktionelle Illustrationen, Blog-Header und veröffentlichen Sie visuelle Konzepte." },
                    { name: "GPT-Bild für Porträts", desc: "Erstellen Sie redaktionelle Porträts mit kontrollierter Beleuchtung, Hintergründen und Styling." },
                    { name: "GPT-Bild für Spielcharakterkonzepte", desc: "Entdecken Sie schnell Spielcharaktere, Kostüme, Requisiten und verschiedene künstlerische Richtungen." },
                    { name: "GPT-Image für Spielumgebungen", desc: "Generieren Sie Spielumgebungen, Filmszenen und weltbildende Konzepte für frühe kreative Erkundungen." },
                    { name: "GPT-Bild für soziale Inhalte", desc: "Generieren Sie Bilder im Quadrat-, Quer- und Hochformat für verschiedene Plattformen." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So nutzen Sie den GPT Image AI Image Generator kostenlos online",
                howToIntro: "Melden Sie sich an, um kostenlose Credits zu erhalten und den GPT Image AI-Bildgenerator online auf Miral zu nutzen.",
                howToSteps: [
                    { title: "Geben Sie eine detaillierte Eingabeaufforderung ein", desc: "Beschreiben Sie das Thema, die Umgebung, die Komposition, die Beleuchtung, den Stil, die Materialien und den erforderlichen Text." },
                    { title: "Wählen Sie Größe und Qualität", desc: "Wählen Sie ein Quadrat-, Quer- oder Hochformat und stellen Sie die GPT-Image-1.5-Qualität entsprechend Ihren Anforderungen ein." },
                    { title: "Generieren und überprüfen", desc: "Beginnen Sie mit der Generierung, überprüfen Sie das Bild und laden Sie es herunter, oder passen Sie die Eingabeaufforderung an und erstellen Sie eine andere Version." }
                ],
                howToCta: "Nutzen Sie den GPT Image AI Image Generator kostenlos",
                faqTitle: "Häufig gestellte Fragen zum GPT-Image",
                faqs: [
                    { q: "Was ist der GPT Image AI-Bildgenerator?", a: "GPT Image ist die universelle Text-zu-Bild-Modellfamilie von OpenAI. Auf Miral wandelt der GPT Image AI-Bildgenerator schriftliche Eingabeaufforderungen in hochwertige Bilder für Design, Marketing, Produktkonzepte, Poster und soziale Inhalte um." },
                    { q: "Kann ich den GPT Image AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem GPT Image AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den GPT Image AI-Bildgenerator online?", a: "Geben Sie eine detaillierte Eingabeaufforderung ein und wählen Sie 1024×1024, 1536×1024 oder 1024×1536. Bei GPT-Image-1.5 können Sie vor dem Klicken auf „Generieren“ auch die Qualität „Automatisch“, „Niedrig“, „Mittel“ oder „Hoch“ auswählen." },
                    { q: "Was ist der Unterschied zwischen GPT-Image-1.5 und GPT-Image-1?", a: "Beide Versionen unterstützen die gleichen drei praktischen Bildgrößen. GPT-Image-1.5 auf Miral bietet außerdem automatische, niedrige, mittlere und hohe Qualitätskontrolle, während GPT-Image-1 über einen einfacheren Parametersatz verfügt." },
                    { q: "Welche Bildgrößen unterstützt GPT Image?", a: "Auf Miral unterstützen GPT-Image-1 und GPT-Image-1.5 1024×1024 Quadratbilder, 1536×1024 Querformate und 1024×1536 Hochformatbilder." },
                    { q: "Welche GPT-Bildqualität soll ich wählen?", a: "Wählen Sie „Niedrig“ oder „Mittel“, wenn Sie Eingabeaufforderungen schnell testen möchten, „Hoch“ für endgültige Produktbilder, Poster oder Marketingressourcen und „Automatisch“, wenn Sie sich nicht sicher sind. Qualitätsoptionen gelten für GPT-Image-1.5." },
                    { q: "Wie behebe ich GPT-Bildergebnisse, die nicht mit meiner Eingabeaufforderung übereinstimmen?", a: "Beschreiben Sie das Thema, die Umgebung, die Komposition, die Beleuchtung, die Kamera, die Materialien, den Stil und den erforderlichen Text genauer. Nutzen Sie die GPT-Bildbeispiele auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." },
                    { q: "Benötige ich schnelle technische Erfahrung, um GPT Image zu verwenden?", a: "Nein. Beginnen Sie mit einer einfachen Eingabeaufforderung in natürlicher Sprache und fügen Sie dann nach Bedarf Motivpositionen, Komposition, Beleuchtung, Farben, Materialien und Textanforderungen hinzu. Klarere Beschreibungen tragen im Allgemeinen dazu bei, dass das Ergebnis besser zu Ihrer kreativen Absicht passt." },
                    { q: "Mit welchem Tool kann ich E-Commerce-Produktbilder, Poster und UI-Konzepte erstellen?", a: "GPT Image kann E-Commerce-Eintragsbilder, Produktmodelle, Poster, UI/UX-Konzepte, Website-Layouts, Infografik-Layouts, Buchcover, Blog-Bilder, E-Mail-Banner und Spielkonzepte erstellen. Überprüfen Sie Texte, Daten, Markenelemente und strukturelle Details vor der endgültigen Verwendung." },
                    { q: "GPT-Image vs. Midjourney: Welches soll ich verwenden?", a: "GPT Image eignet sich hervorragend für klare Eingabeaufforderungssteuerung, praktische Bildgrößen und direkte Browsergenerierung. Midjourney eignet sich möglicherweise für Benutzer, die den künstlerischen Stil, den Referenzbild-Workflow und den kreativen Prozess bevorzugen." }
                ],
                ctaTitle: "Nutzen Sie das GPT-Bild kostenlos auf Miral!",
                ctaDesc: "Melden Sie sich an, um kostenlose Credits zu erhalten. Beschreiben Sie Ihre Idee, wählen Sie eine Größe und Qualität und verwenden Sie den GPT Image AI-Bildgenerator, um hochwertige Bilder zu erstellen."
            },
            qwenImage2Pro: {
                title: "Qwen Image 2.0 Pro AI-Bildgenerator kostenlos online | Miral",
                description: "Erstellen Sie KI-Bilder online mit Qwen Image 2.0 Pro. Nutzen Sie negative Eingabeaufforderungen, Eingabeaufforderungsverbesserungen und flexible Seitenverhältnisse und generieren Sie bis zu vier Bilder pro Durchlauf.",
                heroHeadline: "Qwen Image 2.0 Pro AI-Bildgenerator",
                heroIntro: "Nutzen Sie den Qwen Image 2.0 Pro AI-Bildgenerator kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und schnell hochwertige Bilder mit negativen Eingabeaufforderungen, sofortiger Verbesserung und flexiblen Seitenverhältnissen zu erstellen.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen Image 2.0 Pro",
                ctaTag: "Qwen Image 2.0 Pro · Miral",
                badges: ["Text zu Bild", "Negative Aufforderung", "Prompte Verbesserung", "1-4 Bilder / Lauf", "Flexible Seitenverhältnisse"],
                previewLabel: "Qwen Image 2.0 Pro",
                previewMeta: ["1:1", "2048 × 2048", "Bis zu 1-4 Bilder"],
                previewTitle: "Von einer präzisen Eingabeaufforderung mit Ausschlüssen bis hin zu ausgefeilten Bildern",
                previewDesc: "Kombinieren Sie positive Eingabeaufforderungen mit negativen Eingabeaufforderungen und Eingabeaufforderungsverbesserungen, um in einem Durchlauf mehrere zielgerichtete Bilder zu generieren.",
                keyFeaturesTitle: "Erstellen Sie präzise Bilder mit dem Qwen Image 2.0 Pro Text-to-Image-Generator",
                keyFeaturesIntro: "Entdecken Sie die wichtigsten Funktionen des KI-Bildgenerators Qwen Image 2.0 Pro für Feinsteuerung, negative Eingabeaufforderungen, sofortige Verbesserung, Stapelausgabe und flexible Seitenverhältnisse.",
                mainFeaturesTitle: "Wichtige Qwen Image 2.0 Pro-Funktionen",
                promptLabel: "Positive Aufforderung",
                negativePromptLabel: "Negative Aufforderung",
                shortPromptLabel: "Kurze Aufforderung",
                negativePromptFallback: "geringe Klarheit, verzerrte Details, unübersichtliche Komposition",
                features: [
                    { name: "Negative Sofortkontrolle", short: "Beschreiben Sie, was Sie ausschließen sollten, um sauberere, zielgerichtete Ergebnisse zu erzielen.", desc: "Der KI-Bildgenerator Qwen Image 2.0 Pro unterstützt eine spezielle Negativaufforderung, sodass Sie dem Modell sagen können, was es vermeiden soll – beispielsweise geringe Klarheit, deformierte Hände oder unübersichtliche Komposition. Dies gibt Ihnen eine genauere Kontrolle über das endgültige Bild und reduziert die Notwendigkeit, wiederholt zu drehen.", demo: { type: 'table', rows: [
                        { prompt: "Ein Premium-Produktfoto einer Hautpflegeflasche aus Glas auf nassem Stein, sanftes Morgenlicht, sauberer Hintergrund. (Negativ: unübersichtlicher Hintergrund, niedrige Auflösung, deformierte Reflexionen.)", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "Ein Porträt einer jungen Frau im Herbstlicht, natürliche Hautstruktur, geringe Schärfentiefe. (Negativ: übermäßig glatte Haut, wachsartiges Aussehen, übersättigte Farben.)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "Prompte Verbesserung", short: "Erweitern Sie optional eine kurze Eingabeaufforderung mit detaillierteren Angaben.", desc: "Wenn Sie die Verbesserung der Eingabeaufforderung aktivieren, reichert Qwen Image 2.0 Pro eine kurze Eingabeaufforderung vor der Generierung automatisch mit zusätzlichen Details an. Dadurch können auch nicht fachkundige Eingabeaufforderungen vollständigere, lebendigere Bilder erzeugen, ohne dass manuelles Umschreiben erforderlich ist.", demo: { type: 'table', rows: [
                        { prompt: "Eine gemütliche Leseecke an einem verregneten Fenster.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "Ein hölzerner Lesetisch neben einem regengeschützten Fenster in der Nacht, eine warme Schreibtischlampe, die ein offenes Buch und dampfenden Tee beleuchtet, ein ruhiges und gemütliches Interieur.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "Generieren Sie 1–4 Bilder gleichzeitig", short: "Produzieren Sie mehrere Variationen in einem einzigen Durchgang.", desc: "Qwen Image 2.0 Pro kann bis zu vier Bilder pro Anfrage generieren, sodass Sie Variationen eines Konzepts, eines Blickwinkels oder eines Stils nebeneinander vergleichen und das beste auswählen können. Dies beschleunigt die kreative Erkundung von Marketing- und Produktvisualisierungen.", prompt: "Eine minimalistische Tischlampe aus Keramik auf einem Beistelltisch aus Walnussholz, warmes Abendinterieur, cremefarbene Wand, weiche Schatten, skandinavische Produktfotografie.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "Flexible Seitenverhältnisse", short: "Wählen Sie Querformat, Hochformat, Quadrat oder benutzerdefinierte Größen.", desc: "Wählen Sie aus vorgefertigten Seitenverhältnissen wie 2688×1536 Querformat, 1536×2688 Hochformat, 2048×2048 Quadrat und 2368×1728/1728×2368, oder geben Sie eine benutzerdefinierte Größe von 512×512 bis 2048×2048 ein. Dadurch eignet sich der Text-zu-Bild-Generator Qwen Image 2.0 Pro gleichermaßen für Banner, Poster, Social-Media-Beiträge und quadratische Miniaturansichten.", prompt: "Eine filmische weite Landschaftsaufnahme einer Küstenklippe zur goldenen Stunde, dramatische Wolken, feine Felsdetails, 2688×1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "Raffinierte Details und Realismus", short: "Rendern Sie lebensechte Texturen, Beleuchtung und Tiefe.", desc: "Qwen Image 2.0 Pro erzeugt feine Texturen, realistische Beleuchtung und natürliche Tiefe und eignet sich daher hervorragend für Produktfotografie, Porträts und redaktionelle Visuals, bei denen es auf Glaubwürdigkeit ankommt.", prompt: "Nahaufnahme eines redaktionellen Porträts eines älteren Keramikkünstlers in einer sonnendurchfluteten Werkstatt, natürliche Hautstruktur, Tonstaub auf den Händen, warmes Fensterlicht, geringe Schärfentiefe.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "Qwen Image 2.0 Pro Prompt-Beispiele für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese Qwen Image 2.0 Pro-Eingabeaufforderungsbeispiele als Ausgangspunkt. Kombinieren Sie jede positive Eingabeaufforderung mit einer negativen Eingabeaufforderung, um unerwünschte Elemente zu entfernen, und senden Sie sie dann direkt an den Generator.",
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte Anwendungsfälle für Qwen Image 2.0 Pro",
                useCases: [
                    { name: "Qwen Image 2.0 Pro für Produktfotografie", desc: "Erstellen Sie klare Produktaufnahmen mit kontrollierten Hintergründen und verwenden Sie negative Aufforderungen, um Unordnung zu vermeiden." },
                    { name: "Qwen Image 2.0 Pro für Marketing", desc: "Generieren Sie Kampagnenkonzepte, Social Ads und Banner mit mehreren Seitenverhältnissen." },
                    { name: "Qwen Image 2.0 Pro für Poster und Typografie", desc: "Erstellen Sie Posterlayouts und textreiche Designs mit klaren Überschriften und Beschriftungen." },
                    { name: "Qwen Image 2.0 Pro für Porträts", desc: "Erstellen Sie mithilfe negativer Eingabeaufforderungen detaillierte Porträts mit natürlicher Hautstruktur, um Artefakte zu vermeiden." },
                    { name: "Qwen Image 2.0 Pro für Konzeptkunst", desc: "Erkunden Sie Charaktere, Umgebungen und visuelle Richtungen mit 1–4 Variationen pro Lauf." },
                    { name: "Qwen Image 2.0 Pro für E-Commerce", desc: "Erstellen Sie in einer einzigen Generation mehrere Bildvarianten für Einträge und Anzeigen." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So verwenden Sie den Qwen Image 2.0 Pro AI Image Generator online",
                howToIntro: "Nutzen Sie den KI-Bildgenerator Qwen Image 2.0 Pro online auf Miral mit positiven Eingabeaufforderungen, negativen Eingabeaufforderungen und flexiblen Ausgabesteuerungen.",
                howToSteps: [
                    { title: "Geben Sie Ihre Hauptaufforderung ein", desc: "Beschreiben Sie das gewünschte Motiv, die gewünschte Szene, die gewünschte Komposition, die Beleuchtung, den Stil und die visuellen Details." },
                    { title: "Konfigurieren Sie Generierungskontrollen", desc: "Fügen Sie bei Bedarf eine negative Eingabeaufforderung hinzu, aktivieren Sie die Eingabeaufforderungsverbesserung, wählen Sie die Größe und ein bis vier Bilder aus." },
                    { title: "Generieren und vergleichen", desc: "Beginnen Sie mit der Generierung, vergleichen Sie die zurückgegebenen Varianten und laden Sie das Bild herunter, das Ihrer Absicht am besten entspricht." }
                ],
                howToCta: "Probieren Sie Qwen Image 2.0 Pro AI Image Generator aus",
                faqTitle: "Häufig gestellte Fragen zu Qwen Image 2.0 Pro",
                faqs: [
                    { q: "Was ist der Qwen Image 2.0 Pro AI-Bildgenerator?", a: "Qwen Image 2.0 Pro ist das Text-zu-Bild-Modell Tongyi Qwen von Alibaba. Der KI-Bildgenerator Qwen Image 2.0 Pro wandelt schriftliche Eingabeaufforderungen in hochwertige, detaillierte Bilder um und ist auf Miral für Kunst, Design, Marketing und visuelle Produkterstellung direkt in Ihrem Browser verfügbar." },
                    { q: "Mit welchem Tool kann ich mehrere Produktbildvarianten mit negativen Aufforderungen erstellen?", a: "Qwen Image 2.0 Pro bietet eine spezielle Negativaufforderung, optionale Aufforderungsverbesserung, 1–4 Bilder pro Durchlauf und flexible Seitenverhältnisse für Produktfotografie, Marketing und visuelle Variationen im E-Commerce." },
                    { q: "Kann ich den Qwen Image 2.0 Pro AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem Qwen Image 2.0 Pro AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den Qwen Image 2.0 Pro AI-Bildgenerator online?", a: "Geben Sie eine detaillierte Textaufforderung ein, fügen Sie optional eine negative Aufforderung hinzu, die beschreibt, was vermieden werden soll, aktivieren Sie bei Bedarf die Aufforderungsverbesserung, wählen Sie ein Seitenverhältnis oder eine benutzerdefinierte Größe, legen Sie fest, wie viele Bilder generiert werden sollen (1–4), und klicken Sie auf „Generieren“. Qwen Image 2.0 Pro eignet sich gut für Marketingmaterialien, Produktfotografie, Porträts und Posterdesigns." },
                    { q: "Wie behebt man unerwünschte Elemente in den Ergebnissen von Qwen Image 2.0 Pro?", a: "Fügen Sie eine negative Eingabeaufforderung hinzu, die unerwünschte Elemente beschreibt, z. B. schlechte Klarheit, deformierte Hände oder ein unübersichtlicher Hintergrund. Qwen Image 2.0 Pro nutzt es, um die Generierung dieser Ergebnisse zu verhindern." },
                    { q: "Wie viele Bilder kann Qwen Image 2.0 Pro gleichzeitig generieren?", a: "Qwen Image 2.0 Pro kann bis zu 4 Bilder in einer einzigen Anfrage generieren (n = 1 bis 4), sodass Sie Variationen eines Konzepts, eines Blickwinkels oder eines Stils vergleichen und das beste auswählen können." },
                    { q: "Welche Größen und Seitenverhältnisse unterstützt Qwen Image 2.0 Pro?", a: "Auf Miral bietet Qwen Image 2.0 Pro vorgefertigte Verhältnisse wie 2688×1536, 1536×2688, 2048×2048, 2368×1728 und 1728×2368 sowie eine benutzerdefinierte Größe von 512×512 bis 2048×2048. Dies umfasst Quer-, Hoch- und Quadratausgaben für Banner, Poster, Social-Media-Beiträge und Miniaturansichten." },
                    { q: "Was sind die besten Beispiele für Qwen Image 2.0 Pro-Eingabeaufforderungen?", a: "Effektive Qwen Image 2.0 Pro-Eingabeaufforderungen beschreiben klar das Motiv, die Einstellung, die Komposition, die Beleuchtung und den Stil und koppeln dann eine positive Eingabeaufforderung mit einer negativen Eingabeaufforderung, um unerwünschte Details zu entfernen. Nutzen Sie die Qwen Image 2.0 Pro-Eingabeaufforderungsbeispiele auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." },
                    { q: "Qwen Image 2.0 Pro vs. Midjourney: Welches soll ich verwenden?", a: "Wählen Sie basierend auf dem Workflow und nicht auf der Grundlage eines universellen Gewinners. Qwen Image 2.0 Pro eignet sich hervorragend, wenn Sie explizite negative Eingabeaufforderungen, Eingabeaufforderungsverbesserung, 1–4 Bilder pro Durchlauf und flexible Seitenverhältnisse in einem browserbasierten Generator auf Miral benötigen. Midjourney eignet sich möglicherweise für Kreative, die den unverwechselbaren künstlerischen Workflow und die Community-Tools bevorzugen." }
                ],
                ctaTitle: "Testen Sie Qwen Image 2.0 Pro kostenlos auf Miral!",
                ctaDesc: "Geben Sie oben Ihre Idee ein und verwenden Sie den Qwen Image 2.0 Pro AI-Bildgenerator mit optionalen Steuerelementen, um präzise Bildvariationen zu erstellen."
            },
            stableDiffusion: {
                title: "Stable Diffusion 3.5 AI Image Generator kostenlos online | Miral",
                description: "Generieren Sie KI-Bilder online mit Stable Diffusion 3.5. Verwenden Sie auf Miral negative Eingabeaufforderungen, voreingestellte Seitenverhältnisse und benutzerdefinierte Größen von 512 bis 2048 Pixel.",
                heroHeadline: "Stabiler Diffusion 3.5 AI-Bildgenerator",
                heroIntro: "Nutzen Sie den Stable Diffusion 3.5 AI-Bildgenerator kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und schnell hochwertige Bilder mit detaillierten Eingabeaufforderungen, negativen Eingabeaufforderungen und flexiblen Größen zu erstellen.",
                eyebrow: "Stabilität KI · Stabile Diffusion 3.5",
                sectionKicker: "Stabile Diffusion 3.5",
                ctaTag: "Stabile Diffusion 3,5 · Miral",
                badges: ["Text zu Bild", "Negative Aufforderung", "Flexible Seitenverhältnisse", "Benutzerdefinierte Größe"],
                previewLabel: "Stabile Diffusion 3.5",
                previewMeta: ["1:1", "512 – 2048", "Vielfache von 64"],
                previewTitle: "Von einer detaillierten Aufforderung bis hin zu einem kontrollierten, ausgefeilten Bild",
                previewDesc: "Kombinieren Sie positive Aufforderungen mit negativen Aufforderungen und wählen Sie das richtige Seitenverhältnis, um Stable Diffusion 3.5 zu sauberen, zielgerichteten Bildern zu führen.",
                keyFeaturesTitle: "Erstellen Sie kontrollierte visuelle Darstellungen mit dem Stable Diffusion 3.5 Text-to-Image-Generator",
                keyFeaturesIntro: "Entdecken Sie die wichtigsten Funktionen des Stable Diffusion 3.5 AI-Bildgenerators für negative Eingabeaufforderungen, flexible Seitenverhältnisse, benutzerdefinierte Größen und detailliertes Eingabeaufforderungsverständnis.",
                exploreTitle: "Entdecken Sie weitere KI-Bildmodelle",
                mainFeaturesTitle: "Wichtige Funktionen von Stable Diffusion 3.5",
                generatedImageLabel: "Generiertes Bild",
                versionLabel: "Kontrolle",
                featureLabel: "Was es ändert",
                useCaseLabel: "Am besten für",
                variantsTitle: "Stabile Diffusion 3.5-Ausgabesteuerung",
                variantsIntro: "Kombinieren Sie das Stable Diffusion 3.5-Modell mit voreingestellten Seitenverhältnissen oder genau benutzerdefinierten Abmessungen basierend auf dem endgültigen Layout, das Sie benötigen.",
                variants: [
                    { name: "Stabile Diffusion 3.5", desc: "Detaillierte Text-zu-Bild-Generierung mit positiver und negativer Prompt-Kontrolle.", bestFor: "Produktvisualisierungen, Porträts, Konzeptzeichnungen und Marketingbilder." },
                    { name: "Voreingestellte Seitenverhältnisse", desc: "Vorgefertigte Ausgabeformate im Quer-, Hoch- und Quadratformat.", bestFor: "Soziale Beiträge, Banner, Poster und Miniaturansichten." },
                    { name: "Benutzerdefinierte Bildgröße", desc: "Genaue Breite und Höhe von 512 bis 2048 in Vielfachen von 64.", bestFor: "Layoutslots und Projekte, die präzise Pixelabmessungen erfordern." }
                ],
                controlsTitle: "Wählen Sie die richtigen Eingabeaufforderungssteuerelemente und die richtige Bildgröße",
                controlsIntro: "Verwenden Sie eine negative Eingabeaufforderung, um unerwünschte Details zu reduzieren, und wählen Sie dann ein voreingestelltes Verhältnis aus oder geben Sie benutzerdefinierte Abmessungen für den beabsichtigten Kanal ein.",
                galleryTitle: "Bildbeispiele für eine stabilere Diffusion 3.5",
                discussionTitle: "Häufige Fragen zu Stable Diffusion 3.5",
                communityTitle: "Beliebte Möglichkeiten zum Erstellen mit stabiler Diffusion 3.5",
                tutorialPrompt: "Redaktionelles Produktfoto eines skulpturalen Keramiklautsprechers auf hellem Stein, sanftes Morgenlicht am Fenster, realistische Textur, ausgewogene Komposition, subtile Schatten, klarer Hintergrund.",
                qualityBenefits: [
                    "Verwenden Sie negative Eingabeaufforderungen, um Unordnung, fehlerhafte Details und unerwünschte visuelle Stile zu reduzieren.",
                    "Folgen Sie den vielschichtigen Beschreibungen des Themas, der Komposition, der Beleuchtung, der Materialien und der Stimmung.",
                    "Erstellen Sie Quer-, Hoch- und Quadratbilder mit Voreinstellungen oder präzisen benutzerdefinierten Abmessungen."
                ],
                features: [
                    { name: "Negative Sofortkontrolle", short: "Beschreiben Sie, was Sie ausschließen sollten, um sauberere, zielgerichtete Ergebnisse zu erzielen.", desc: "Der AI-Bildgenerator Stable Diffusion 3.5 unterstützt eine spezielle Negativaufforderung, sodass Sie dem Modell sagen können, was es vermeiden soll – beispielsweise geringe Klarheit, deformierte Hände oder ein unübersichtlicher Hintergrund. Dies gibt Ihnen eine genauere Kontrolle über das endgültige Bild und reduziert die Notwendigkeit, wiederholt zu drehen.", demo: { type: 'table', rows: [
                        { prompt: "Ein Premium-Produktfoto einer mattschwarzen Keramikvase auf einem Marmorsockel, sanftes Studiolicht, sauberer Hintergrund. (Negativ: unübersichtlicher Hintergrund, niedrige Auflösung, deformierte Reflexionen.)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "Ein Porträt eines jungen Mannes im sanften Fensterlicht, mit natürlicher Hautstruktur und geringer Schärfentiefe. (Negativ: übermäßig glatte Haut, wachsartiges Aussehen, übersättigte Farben.)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "Flexible Seitenverhältnisse", short: "Wählen Sie Querformat, Hochformat, Quadrat oder eine benutzerdefinierte Größe.", desc: "Wählen Sie aus vorgefertigten Seitenverhältnissen wie 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 und 1536×1536 oder geben Sie eine benutzerdefinierte Größe von 512×512 bis ein 2048×2048. Dadurch eignet sich der Text-zu-Bild-Generator Stable Diffusion 3.5 gleichermaßen für Banner, Poster, Social-Media-Beiträge und quadratische Miniaturansichten.", prompt: "Eine filmische weite Landschaftsaufnahme einer Küstenklippe zur goldenen Stunde, dramatische Wolken, feine Felsdetails, 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "Benutzerdefinierte Bildgrößen", short: "Legen Sie genaue Pixelabmessungen für eine präzise Ausgabe fest.", desc: "Wenn eine Voreinstellung nicht passt, wechseln Sie zu einer benutzerdefinierten Größe und geben Sie eine beliebige Breite und Höhe von 512 bis 2048 in Vielfachen von 64 ein. Dadurch können Sie ein bestimmtes Layout, einen Bannerplatz oder ein bestimmtes Druckformat ohne manuelles Zuschneiden anpassen.", prompt: "Ein minimalistischer Posterhintergrund mit einer zentrierten geometrischen Komposition, tiefblauem Farbverlauf, subtiler Körnung, 1280 x 1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "Detailliertes, schnelles Verständnis", short: "Folgt vielschichtigen Beschreibungen von Thema, Licht und Stil.", desc: "Stable Diffusion 3.5 liest mehrschichtige Textanweisungen und gibt das von Ihnen beschriebene Motiv, die Umgebung, die Beleuchtung und die Stimmung wieder. Kombinieren Sie eine klare positive Aufforderung mit einer negativen Aufforderung, um das Ergebnis in weniger Versuchen Ihrer Absicht näher zu bringen.", demo: { type: 'table', rows: [
                        { prompt: "Redaktionelles Produktfoto einer Armbanduhr neben gefaltetem Leinen und einer Keramiktasse, ausgewogene dreieckige Komposition, sanftes Morgenlicht.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "Eine gemütliche Leseecke an einem verregneten Fenster, warmes Lampenlicht, gestapelte Bücher, eine strukturierte Decke, Kinostimmung.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "Raffinierte Details und Realismus", short: "Stellen Sie Beleuchtung, Materialien und Tiefe glaubwürdig dar.", desc: "Stable Diffusion 3.5 erzeugt feine Texturen, realistische Beleuchtung und natürliche Tiefe, wodurch der Stable Diffusion 3.5 AI-Bildgenerator eine solide Lösung für Produktfotografie, Porträts, Konzeptzeichnungen und redaktionelle Visuals ist, bei denen es auf Glaubwürdigkeit ankommt.", prompt: "Nahaufnahme eines redaktionellen Porträts eines älteren Keramikkünstlers in einer sonnendurchfluteten Werkstatt, natürliche Hautstruktur, Tonstaub auf den Händen, warmes Fensterlicht, geringe Schärfentiefe.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "Stable Diffusion 3.5 Prompt-Beispiele für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese Stable Diffusion 3.5-Eingabeaufforderungsbeispiele als Ausgangspunkt. Beschreiben Sie das Thema, die Komposition, die Beleuchtung und den Stil klar, koppeln Sie jede Eingabeaufforderung mit einer negativen Eingabeaufforderung und senden Sie sie dann direkt an den Generator.",
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte Stable Diffusion 3.5-Anwendungsfälle",
                useCases: [
                    { name: "Stabile Diffusion 3.5 für die Produktfotografie", desc: "Erstellen Sie klare Produktaufnahmen mit kontrollierten Hintergründen und verwenden Sie negative Aufforderungen, um Unordnung zu vermeiden." },
                    { name: "Stabile Verbreitung 3.5 für Marketing", desc: "Generieren Sie Kampagnenkonzepte, Social Ads und Banner mit mehreren Seitenverhältnissen." },
                    { name: "Stabile Diffusion 3.5 für Poster und Layouts", desc: "Erstellen Sie Posterhintergründe und Layout-fähige Grafiken in benutzerdefinierten Pixelabmessungen." },
                    { name: "Stabile Diffusion 3.5 für Porträts", desc: "Erstellen Sie detaillierte Porträts mit natürlicher Hautstruktur und nutzen Sie negative Eingabeaufforderungen, um Artefakte zu vermeiden." },
                    { name: "Stabile Verbreitung 3.5 für Konzeptkunst", desc: "Erkunden Sie Charaktere, Umgebungen und visuelle Richtungen mit mehrschichtigen Eingabeaufforderungen." },
                    { name: "Stabile Verbreitung 3.5 für soziale Inhalte", desc: "Erstellen Sie Bilder im Quadrat-, Hoch- und Querformat für verschiedene soziale Plattformen." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So verwenden Sie den Stable Diffusion 3.5 AI Image Generator online",
                howToIntro: "Nutzen Sie den Stable Diffusion 3.5 AI-Bildgenerator online auf Miral mit einer klaren Eingabeaufforderung, einer negativen Eingabeaufforderung und dem Seitenverhältnis, das Ihr Projekt benötigt.",
                howToSteps: [
                    { title: "Geben Sie Ihre Hauptaufforderung ein", desc: "Beschreiben Sie das gewünschte Motiv, die gewünschte Szene, die gewünschte Komposition, die Beleuchtung, den Stil und die visuellen Details." },
                    { title: "Konfigurieren Sie Generierungskontrollen", desc: "Fügen Sie bei Bedarf eine negative Eingabeaufforderung hinzu und wählen Sie dann ein vorgefertigtes Seitenverhältnis oder geben Sie eine benutzerdefinierte Größe ein." },
                    { title: "Generieren und überprüfen", desc: "Beginnen Sie mit der Generierung, überprüfen Sie das Ergebnis und laden Sie das Bild herunter oder passen Sie Ihre Eingabeaufforderung für einen weiteren Durchgang an." }
                ],
                howToCta: "Probieren Sie Stable Diffusion 3.5 AI Image Generator aus",
                faqTitle: "Häufig gestellte Fragen zur stabilen Diffusion 3.5",
                faqs: [
                    { q: "Was ist der Stable Diffusion 3.5 AI-Bildgenerator?", a: "Stable Diffusion 3.5 ist ein Text-zu-Bild-Modell von Stability AI. Der AI-Bildgenerator Stable Diffusion 3.5 wandelt schriftliche Eingabeaufforderungen in detaillierte Bilder um und ist auf Miral für Kunst, Design, Marketing und visuelle Produkterstellung direkt in Ihrem Browser verfügbar." },
                    { q: "Mit welchem Tool kann ich Bilder in benutzerdefinierter Größe mit negativen Eingabeaufforderungen erstellen?", a: "Stable Diffusion 3.5 bietet eine spezielle Negativaufforderung, vorgefertigte Seitenverhältnisse und benutzerdefinierte Größen von 512 bis 2048 für Produktfotografie, Marketingvisualisierungen, Porträts und Konzeptkunst." },
                    { q: "Kann ich den Stable Diffusion 3.5 AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem Stable Diffusion 3.5 AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den Stable Diffusion 3.5 AI-Bildgenerator online?", a: "Geben Sie eine ausführliche Textaufforderung ein, fügen Sie optional eine negative Aufforderung hinzu, die beschreibt, was Sie vermeiden sollten, wählen Sie ein vorgefertigtes Seitenverhältnis oder geben Sie eine benutzerdefinierte Größe ein und klicken Sie auf „Generieren“. Stable Diffusion 3.5 eignet sich gut für Marketingmaterialien, Produktfotografie, Porträts und Posterlayouts." },
                    { q: "Wie können unerwünschte oder deformierte Details in Stable Diffusion 3.5-Bildern korrigiert werden?", a: "Fügen Sie eine negative Eingabeaufforderung hinzu, die unerwünschte Elemente beschreibt, z. B. schlechte Klarheit, deformierte Hände oder ein unübersichtlicher Hintergrund. Stable Diffusion 3.5 nutzt es, um die Generierung von diesen Ergebnissen abzulenken." },
                    { q: "Welche Größen und Seitenverhältnisse unterstützt Stable Diffusion 3.5?", a: "Auf Miral bietet Stable Diffusion 3.5 vorgefertigte Verhältnisse wie 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 und 1536×1536 sowie eine benutzerdefinierte Größe von 512×512 bis 2048×2048 in Vielfachen von 64. Dies umfasst Quer-, Hoch- und Quadratausgaben für Banner, Poster, Social-Media-Beiträge und Miniaturansichten." },
                    { q: "Was sind die besten Beispiele für Stable Diffusion 3.5-Eingabeaufforderungen?", a: "Effektive Stable Diffusion 3.5-Eingabeaufforderungen beschreiben das Motiv, die Umgebung, die Komposition, die Beleuchtung und den Stil klar und deutlich und koppeln dann eine positive Eingabeaufforderung mit einer negativen Eingabeaufforderung, um unerwünschte Details zu entfernen. Nutzen Sie die Beispiele für Stable Diffusion 3.5-Eingabeaufforderungen auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." },
                    { q: "Stable Diffusion 3.5 vs. Midjourney: Welches soll ich verwenden?", a: "Wählen Sie basierend auf dem Workflow und nicht auf der Grundlage eines universellen Gewinners. Stable Diffusion 3.5 eignet sich hervorragend, wenn Sie explizite negative Eingabeaufforderungen, vorgefertigte Seitenverhältnisse und benutzerdefinierte Pixelgrößen in einem browserbasierten Generator auf Miral benötigen. Midjourney eignet sich möglicherweise für Kreative, die den unverwechselbaren künstlerischen Workflow und die Community-Tools bevorzugen." }
                ],
                ctaTitle: "Testen Sie Stable Diffusion 3.5 kostenlos auf Miral!",
                ctaDesc: "Geben Sie oben Ihre Idee ein und verwenden Sie den AI-Bildgenerator Stable Diffusion 3.5 mit negativen Eingabeaufforderungen und flexiblen Größen, um kontrollierte Bilder zu erstellen."
            },
            zImageTurbo: {
                title: "Z Image Turbo AI-Bildgenerator kostenlos online | Miral",
                description: "Erstellen Sie mit Z Image Turbo online hochwertige KI-Bilder. Erweitern Sie Eingabeaufforderungen, wählen Sie flexible Seitenverhältnisse, legen Sie benutzerdefinierte Abmessungen fest und steuern Sie Seeds auf Miral.",
                heroHeadline: "Z Image Turbo AI-Bildgenerator",
                heroIntro: "Nutzen Sie den Bildgenerator Z Image Turbo AI kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und schnell hochwertige Bilder mit sofortiger Erweiterung, flexiblen Seitenverhältnissen und Seed-Kontrolle zu erstellen.",
                eyebrow: "Z Image Turbo",
                sectionKicker: "Z Image Turbo",
                ctaTag: "Z Image Turbo · Miral",
                badges: ["Text zu Bild", "Prompte Verlängerung", "Flexible Seitenverhältnisse", "Benutzerdefinierte Größe", "Saatgutkontrolle"],
                previewLabel: "Z Image Turbo",
                previewMeta: ["1:1", "512 – 2048", "Saatgutkontrolle"],
                previewTitle: "Von einer kurzen Aufforderung bis hin zu einem ausgefeilten, hochauflösenden Bild",
                previewDesc: "Lassen Sie eine kurze Idee durch die Prompt-Erweiterung bereichern, wählen Sie das richtige Seitenverhältnis und verwenden Sie einen Seed wieder, um einen einheitlichen Stil über alle Bilder hinweg beizubehalten.",
                keyFeaturesTitle: "Erstellen Sie mit dem Z Image Turbo Text-to-Image-Generator ausgefeilte Grafiken",
                keyFeaturesIntro: "Entdecken Sie die wichtigsten Funktionen des Z Image Turbo AI-Bildgenerators für schnelle Erweiterung, flexible Seitenverhältnisse, benutzerdefinierte Größen und Seed-basierte Konsistenz.",
                exploreTitle: "Entdecken Sie weitere KI-Bildmodelle",
                mainFeaturesTitle: "Wichtige Z Image Turbo-Funktionen",
                generatedImageLabel: "Generiertes Bild",
                versionLabel: "Kontrolle",
                featureLabel: "Was es ändert",
                useCaseLabel: "Am besten für",
                variantsTitle: "Steuerelemente für die Z Image Turbo-Erstellung",
                variantsIntro: "Kombinieren Sie schnelle Erweiterung, flexible Abmessungen und Seed-Kontrolle, je nachdem, wie viele Details und visuelle Konsistenz Ihr Projekt benötigt.",
                variants: [
                    { name: "Z Image Turbo", desc: "Schnelle Text-zu-Bild-Generierung mit detaillierter hochauflösender Ausgabe.", bestFor: "Produktvisualisierungen, Porträts, Konzeptzeichnungen und Marketingbilder." },
                    { name: "Prompte Verlängerung", desc: "Reichert kurze Eingabeaufforderungen automatisch mit zusätzlichen visuellen Details an.", bestFor: "Schnelle Ideen in umfassendere Generierungsanweisungen umwandeln." },
                    { name: "Saatgutkontrolle", desc: "Verwendet denselben Startwert wieder, während Sie andere Einstellungen verfeinern.", bestFor: "Beibehaltung eines koordinierten Stils über Bildvariationen oder Kampagnen hinweg." }
                ],
                controlsTitle: "Wählen Sie die richtige Eingabeaufforderung, Größe und Saatguteinstellungen",
                controlsIntro: "Aktivieren Sie die Eingabeaufforderungserweiterung, wenn eine Idee mehr Details benötigt, wählen Sie die beabsichtigten Ausgabedimensionen aus und verwenden Sie einen Startwert wieder, wenn visuelle Konsistenz wichtig ist.",
                galleryTitle: "Weitere Beispiele für Z Image Turbo-Bilder",
                discussionTitle: "Häufige Fragen zu Z Image Turbo",
                communityTitle: "Beliebte Möglichkeiten zum Erstellen mit Z Image Turbo",
                tutorialPrompt: "Ein kompakter Elektroroller, ausgestellt in einem hellen Architekturstudio, heller Betonboden, sanftes Oberlicht, raffinierte Produktfotografie, ausgewogene Komposition, realistische Materialien.",
                qualityBenefits: [
                    "Erweitern Sie kurze Ideen in umfassendere Eingabeaufforderungen, ohne jedes visuelle Detail manuell neu schreiben zu müssen.",
                    "Wählen Sie Querformat, Hochformat, Quadrat oder präzise benutzerdefinierte Abmessungen für den endgültigen Kanal.",
                    "Verwenden Sie einen Seed erneut, um Beleuchtung, Farbpalette und Komposition über alle Iterationen hinweg konsistenter zu halten."
                ],
                features: [
                    { name: "Prompte Verlängerung", short: "Erweitern Sie optional eine kurze Eingabeaufforderung mit detaillierteren Angaben.", desc: "Wenn Sie die Eingabeaufforderungserweiterung aktivieren, reichert Z Image Turbo eine kurze Eingabeaufforderung vor der Generierung automatisch mit zusätzlichen Details an. Dies trägt dazu bei, dass kurze oder einfache Eingabeaufforderungen vollständigere, lebendigere Bilder erzeugen, ohne dass manuelles Umschreiben erforderlich ist.", demo: { type: 'table', rows: [
                        { prompt: "Ein Glasgewächshaus voller tropischer Pflanzen auf der Marsoberfläche.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "Eine kleine, handwerklich hergestellte Bäckerei, die in einem alten Eisenbahnwaggon untergebracht ist.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "Flexible Seitenverhältnisse", short: "Wählen Sie Querformat, Hochformat, Quadrat oder eine benutzerdefinierte Größe.", desc: "Wählen Sie aus vorgefertigten Seitenverhältnissen wie 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 und 1536×1536 oder geben Sie eine benutzerdefinierte Größe von 512×512 bis ein 2048×2048. Dadurch eignet sich der Text-zu-Bild-Generator Z Image Turbo gleichermaßen für Banner, Poster, Social-Media-Beiträge und quadratische Miniaturansichten.", prompt: "Eine ultraweite Luftaufnahme eines Nachtmarkts in Tokio im Regen, leuchtende Papierlaternen, überfüllte Essensstände, reflektierende Straßen, filmische Atmosphäre, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "Benutzerdefinierte Bildgrößen", short: "Legen Sie genaue Pixelabmessungen für eine präzise Ausgabe fest.", desc: "Wenn eine Voreinstellung nicht passt, wechseln Sie zu einer benutzerdefinierten Größe und geben Sie eine beliebige Breite und Höhe zwischen 512 und 2048 ein. Dadurch können Sie ein bestimmtes Layout, einen Bannerplatz oder ein Druckformat ohne manuelles Zuschneiden anpassen.", prompt: "Ein vertikales botanisches Ausstellungsplakat, übergroße orangefarbene Typografie, seltene tropische Blätter, warme cremefarbene Papierstruktur, präzises redaktionelles Raster, 1152 x 1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "Saatgutkontrolle für Konsistenz", short: "Verwenden Sie einen Seed erneut, um einen stabilen Stil über alle Bilder hinweg beizubehalten.", desc: "Legen Sie einen festen Startwert (0 bis 2147483647) fest, und der Z Image Turbo AI-Bildgenerator stützt sich bei allen Durchläufen auf denselben Startpunkt, wodurch es einfacher wird, ein einheitliches Erscheinungsbild beizubehalten, während Sie die Eingabeaufforderung verfeinern. Belassen Sie den Startwert bei 0, um jedes Mal ein neues, zufälliges Ergebnis zu erhalten.", prompt: "Eine koordinierte Hautpflegekampagne mit drei Milchglasflaschen auf blassgrünem Stein, weichem diffusem Licht und Eukalyptusakzenten – verwenden Sie denselben Samen wieder, um die Beleuchtung, Palette und Zusammensetzung in der gesamten Produktserie beizubehalten.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "Raffinierte Details und Realismus", short: "Stellen Sie Beleuchtung, Materialien und Tiefe glaubwürdig dar.", desc: "Z Image Turbo erzeugt feine Texturen, realistische Beleuchtung und natürliche Tiefe und eignet sich daher hervorragend für Produktfotografie, Porträts, Konzeptzeichnungen und redaktionelle Visuals, bei denen es auf Glaubwürdigkeit ankommt.", prompt: "Dokumentarische Nahaufnahme eines Geigenbauers, der in einer ruhigen Werkstatt einen Ahornsteg schnitzt, feine Holzspäne, abgenutzte Handwerkzeuge, natürliche Hautstruktur, weiches Nordfensterlicht, geringe Schärfentiefe.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "Beispiele für Z Image Turbo-Eingabeaufforderungen für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese Z Image Turbo-Eingabeaufforderungsbeispiele als Ausgangspunkt. Beschreiben Sie das Motiv, die Komposition, die Beleuchtung und den Stil klar, aktivieren Sie optional die sofortige Erweiterung und senden Sie sie dann direkt an den Generator.",
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte Z Image Turbo-Anwendungsfälle",
                useCases: [
                    { name: "Z Image Turbo für die Produktfotografie", desc: "Erstellen Sie klare Produktaufnahmen mit kontrollierten Hintergründen und einem festen Startpunkt für ein einheitliches Erscheinungsbild." },
                    { name: "Z Image Turbo für das Marketing", desc: "Generieren Sie Kampagnenkonzepte, Social Ads und Banner mit mehreren Seitenverhältnissen." },
                    { name: "Z Image Turbo für Poster und Layouts", desc: "Erstellen Sie Posterhintergründe und Layout-fähige Grafiken in benutzerdefinierten Pixelabmessungen." },
                    { name: "Z Image Turbo für Porträts", desc: "Erstellen Sie detaillierte Porträts mit natürlicher Hautstruktur und glaubwürdiger Beleuchtung." },
                    { name: "Z Image Turbo für Konzeptkunst", desc: "Erkunden Sie Charaktere, Umgebungen und visuelle Richtungen mit mehrschichtigen Eingabeaufforderungen." },
                    { name: "Z Image Turbo für soziale Inhalte", desc: "Erstellen Sie Bilder im Quadrat-, Hoch- und Querformat für verschiedene soziale Plattformen." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So verwenden Sie den Z Image Turbo AI-Bildgenerator online",
                howToIntro: "Nutzen Sie den Z Image Turbo AI-Bildgenerator online auf Miral mit einer klaren Eingabeaufforderung, einer optionalen Eingabeaufforderungserweiterung und dem Seitenverhältnis, das Ihr Projekt benötigt.",
                howToSteps: [
                    { title: "Geben Sie Ihre Hauptaufforderung ein", desc: "Beschreiben Sie das gewünschte Motiv, die gewünschte Szene, die gewünschte Komposition, die Beleuchtung, den Stil und die visuellen Details." },
                    { title: "Konfigurieren Sie Generierungskontrollen", desc: "Aktivieren Sie optional die Eingabeaufforderungserweiterung, wählen Sie ein vorgefertigtes Seitenverhältnis oder geben Sie eine benutzerdefinierte Größe ein und legen Sie einen Startwert fest, wenn Sie Konsistenz wünschen." },
                    { title: "Generieren und überprüfen", desc: "Beginnen Sie mit der Generierung, überprüfen Sie das Ergebnis und laden Sie das Bild herunter oder passen Sie Ihre Eingabeaufforderung für einen weiteren Durchgang an." }
                ],
                howToCta: "Probieren Sie den Z Image Turbo AI Image Generator aus",
                faqTitle: "Häufig gestellte Fragen zu Z Image Turbo",
                faqs: [
                    { q: "Was ist der Z Image Turbo AI-Bildgenerator?", a: "Z Image Turbo ist ein Text-zu-Bild-Modell zur Erzeugung hochauflösender Bilder. Der Z Image Turbo AI-Bildgenerator wandelt schriftliche Eingabeaufforderungen in detaillierte Bilder um und ist auf Miral für Kunst, Design, Marketing und visuelle Produkterstellung direkt in Ihrem Browser verfügbar." },
                    { q: "Mit welchem Tool kann ich eine konsistente Serie von Produktbildern erstellen?", a: "Z Image Turbo kombiniert schnelle Erweiterung, flexible Bildgrößen und Seed-Kontrolle, um eine konsistente Serie von Produktfotografien oder Marketingvisualisierungen zu erstellen." },
                    { q: "Kann ich den Z Image Turbo AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem Z Image Turbo AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den Z Image Turbo AI-Bildgenerator online?", a: "Geben Sie eine detaillierte Textaufforderung ein, aktivieren Sie optional die Eingabeaufforderungserweiterung, wählen Sie ein vorgefertigtes Seitenverhältnis oder geben Sie eine benutzerdefinierte Größe ein, legen Sie einen Startwert fest, wenn Sie ein einheitliches Erscheinungsbild wünschen, und klicken Sie auf „Generieren“. Z Image Turbo eignet sich gut für Marketingmaterialien, Produktfotografie, Porträts und Posterlayouts." },
                    { q: "Was ist die Prompt-Erweiterung in Z Image Turbo?", a: "Die Eingabeaufforderungserweiterung ist ein optionaler Schalter, mit dem Z Image Turbo eine kurze oder einfache Eingabeaufforderung vor der Generierung automatisch mit zusätzlichen Details anreichern kann. Dadurch können auch nicht fachkundige Eingabeaufforderungen vollständigere, lebendigere Bilder erzeugen, ohne dass manuelles Umschreiben erforderlich ist." },
                    { q: "Wie kann man inkonsistente Ergebnisse in Z Image Turbo beheben?", a: "Verwenden Sie denselben Seed wieder und verfeinern Sie gleichzeitig andere Parameter, um einen einheitlichen Stil in allen Bildern beizubehalten. Lassen Sie den Startwert nur dann auf 0, wenn Sie jedes Mal ein neues, zufälliges Ergebnis wünschen." },
                    { q: "Welche Größen und Seitenverhältnisse unterstützt Z Image Turbo?", a: "Auf Miral bietet Z Image Turbo vorgefertigte Verhältnisse wie 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 und 1536×1536 sowie eine benutzerdefinierte Größe von 512×512 bis zu 2048×2048. Dies umfasst Quer-, Hoch- und Quadratausgaben für Banner, Poster, Social-Media-Beiträge und Miniaturansichten." },
                    { q: "Was sind die besten Beispiele für Z Image Turbo-Eingabeaufforderungen?", a: "Effektive Z Image Turbo-Eingabeaufforderungen beschreiben klar und deutlich das Motiv, die Einstellung, die Komposition, die Beleuchtung und den Stil. Aktivieren Sie für kurze Ideen die Eingabeaufforderungserweiterung, damit das Modell die Eingabeaufforderung automatisch anreichern kann. Nutzen Sie die Z Image Turbo-Eingabeaufforderungsbeispiele auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." }
                ],
                ctaTitle: "Testen Sie Z Image Turbo kostenlos auf Miral!",
                ctaDesc: "Geben Sie oben Ihre Idee ein und verwenden Sie den Z Image Turbo AI-Bildgenerator mit prompter Erweiterung, flexiblen Größen und Seed-Steuerung, um ausgefeilte Bilder zu erstellen."
            },
            midjourney: {
                title: "Midjourney AI-Bildgenerator kostenlos online | Miral",
                description: "Erstellen Sie KI-Kunst online mit Midjourney auf Miral AI. Wählen Sie realistische oder Anime-Stile, leiten Sie die Ergebnisse mit Referenzbildern und verwandeln Sie Textaufforderungen in lebendige Bilder.",
                heroHeadline: "KI-Bildgenerator für unterwegs",
                heroIntro: "Nutzen Sie den Midjourney AI-Bildgenerator kostenlos auf Miral AI. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort hochwertige Bilder mit realistischen oder Anime-Stilen und optionaler Anleitung für Referenzbilder zu erstellen.",
                eyebrow: "Mitten auf der Reise",
                sectionKicker: "Mitten auf der Reise",
                ctaTag: "Midjourney · Miral",
                badges: ["Text zu Bild", "Realistische und Anime-Stile", "Referenzbildanleitung", "Künstlerische Leitung"],
                previewLabel: "Mitten auf der Reise",
                previewMeta: ["Realistisch", "Anime", "Bis zu 5 Referenzen"],
                previewTitle: "Von einer lebendigen Aufforderung zu einem filmischen, künstlerischen Bild",
                previewDesc: "Wählen Sie einen Stil, beschreiben Sie die Stimmung und Beleuchtung und lassen Sie Midjourney den künstlerischen Look Ihres Konzepts, Posters oder Ihrer Figur gestalten.",
                keyFeaturesTitle: "Erstellen Sie künstlerische Visuals mit dem Midjourney Text to Image Generator",
                keyFeaturesIntro: "Entdecken Sie die wichtigsten Midjourney AI-Bildgeneratorfunktionen für Stilwechsel, Referenzbildführung und umfassende künstlerische Ausrichtung.",
                features: [
                    { name: "Realistische und Anime-Stile", short: "Wechseln Sie den visuellen Stil mit einem Fingertipp.", desc: "Der Midjourney AI-Bildgenerator auf Miral stellt zwei vorgefertigte Stile zur Verfügung: Realistisch und Anime. Wählen Sie „Realistisch“ für fotografische Details, natürliches Licht und lebensechte Texturen oder „Anime“ für stilisierte Linien, kräftige Farben und ein handgezeichnetes Gefühl. Der Stil wird im Bedienfeld ausgewählt, sodass sich Ihre Eingabeaufforderung auf die Szene selbst konzentrieren kann.", demo: { type: 'table', rows: [
                        { prompt: "Ein einsamer Reisender, der bei Sonnenaufgang am Rand eines nebligen Bergrückens steht, volumetrisches Licht, filmische Totalaufnahme, feine Stoff- und Felsdetails.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "Eine entschlossene junge Schwertkämpferin auf einem Dach in der Abenddämmerung, wallendes Haar, leuchtende Laternen, ausdrucksstarke Anime-Linien, lebendige Cel-Shading.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "Referenzbildanleitung", short: "Laden Sie bis zu fünf Bilder hoch, um den Look zu steuern.", desc: "Führen Sie den Midjourney AI-Bildgenerator mit bis zu fünf Referenzbildern (PNG, JPG, JPEG oder WebP). Verwenden Sie sie, um eine Farbpalette, ein Zeichenbild, eine Produktform oder eine Gesamtästhetik zu übertragen, sodass das Ergebnis eher einer Referenzrichtung als dem Text allein entspricht.", prompt: "Ein Premium-Produktfoto einer mattschwarzen Keramikvase auf einem Marmorsockel, sanftes Studiolicht, sauberer Hintergrund, passend zur Stimmung und Farbpalette der hochgeladenen Referenzen.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "Filmische Beleuchtung und Stimmung", short: "Erzeugen Sie dramatisches Licht, Atmosphäre und Tiefe.", desc: "Midjourney ist bekannt für kunstvolle Beleuchtung und Atmosphäre. Beschreiben Sie goldene Stunde, Neonlicht, Nebel, Randlicht oder Kerzenlicht, und das Modell erhält einen filmischen Look, der zu Postern, Schlüsselkunst und Konzeptvisualisierungen passt.", demo: { type: 'table', rows: [
                        { prompt: "Eine regennasse Neongasse bei Nacht, reflektierende Pfützen, sanftes Bokeh von entfernten Schildern, stimmungsvolle Kinoatmosphäre, eine einzelne Figur mit Regenschirm.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "Ein goldenes Stundenporträt eines Musikers auf einem Dach, warmes Gegenlicht, Blendenfleck, geringe Schärfentiefe, Filmkörnung.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "Charakter- und Konzeptkunst", short: "Bauen Sie ausdrucksstarke Charaktere und Welten.", desc: "Der Midjourney-Text-zu-Bild-Generator eignet sich hervorragend für Charakterdesign, Fantasy-Szenen und Konzeptkunst. Beschreiben Sie die Pose, das Outfit, den Ausdruck und die Umgebung einer Figur, wählen Sie einen Stil und wiederholen Sie den Vorgang, bis der Look stimmig ist.", prompt: "Ein wandernder Alchemist in einem mehrlagigen Reiseumhang, der eine Messinglaterne und leuchtende Fläschchen trägt, ein uralter Waldweg, gesprenkeltes Licht, komplizierte Kostümdetails.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "Poster und redaktionelle Kunst", short: "Erstellen Sie auffällige Layouts und Keyvisuals.", desc: "Von der Schlüsselkunst der Kampagne bis hin zu redaktionellen Illustrationen gestaltet Midjourney mutige Kompositionen und eine ausgefeilte Ästhetik. Kombinieren Sie ein klares Schwerpunktthema mit einer beschriebenen Stimmung und lassen Sie das Modell künstlerische Bilder für Marketing- und redaktionelle Zwecke liefern.", prompt: "Ein auffälliges Kampagnen-Keyvisual mit einem Kolibri, der über einer leuchtenden tropischen Blume schwebt, gesättigten Juwelentönen, klarem Negativraum und kontrastreicher Studiobeleuchtung.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "Schnelle Beispiele",
                showcaseTitle: "Beispiele für Eingabeaufforderungen während der Fahrt für bessere KI-Bilder",
                showcaseIntro: "Verwenden Sie diese Midjourney-Eingabeaufforderungsbeispiele als Ausgangspunkt. Beschreiben Sie das Motiv, die Stimmung, die Beleuchtung und den Stil der Szene, wählen Sie dann auf dem Bedienfeld „Realistisch“ oder „Anime“ und senden Sie es an den Generator.",
                useCasesKicker: "Für echte Arbeit gemacht",
                useCasesTitle: "Beliebte Midjourney-Anwendungsfälle",
                useCases: [
                    { name: "Midjourney für Konzeptkunst", desc: "Erstellen Sie Charaktere, Fantasiewelten und visuelle Richtungen mit kunstgesteuerter Beleuchtung und Stimmung." },
                    { name: "Midjourney für wichtige Kunst und Poster", desc: "Erstellen Sie auffällige Key Visuals, Poster und redaktionelle Illustrationen für Kampagnen mit einem eleganten Look." },
                    { name: "Midjourney für Produkt- und Markenvisualisierungen", desc: "Gestalten Sie Premium-Produktkonzepte und Markenbilder und orientieren Sie sich dabei an Referenzbildern, um Konsistenz zu gewährleisten." },
                    { name: "Midjourney für Porträts", desc: "Erstellen Sie filmische Porträts mit natürlichem Licht, Filmkörnung oder stilisierten Anime-Schattierungen." },
                    { name: "Midjourney für Anime und Illustration", desc: "Wechseln Sie zum Anime-Stil für ausdrucksstarke Linienführung, kräftige Farben und handgezeichnete Charaktere." },
                    { name: "Midjourney für soziale Inhalte", desc: "Erstellen Sie eindrucksvolle, teilbare Visuals für Feeds, Miniaturansichten und kreative Social-Media-Beiträge." }
                ],
                howToKicker: "Drei einfache Schritte",
                howToTitle: "So verwenden Sie den Midjourney AI Image Generator online",
                howToIntro: "Nutzen Sie den Midjourney AI-Bildgenerator online auf Miral mit einer anschaulichen Aufforderung, einem ausgewählten Stil und optionalen Referenzbildern.",
                howToSteps: [
                    { title: "Beschreiben Sie Ihre Szene", desc: "Schreiben Sie eine anschauliche Aufforderung, die das Thema, die Umgebung, die Stimmung, die Beleuchtung und den gewünschten künstlerischen Look abdeckt." },
                    { title: "Wählen Sie Stil und Referenzen", desc: "Wählen Sie im Bedienfeld „Realistisch“ oder „Anime“ aus und laden Sie optional bis zu fünf Referenzbilder hoch, um den Look zu bestimmen." },
                    { title: "Generieren und verfeinern", desc: "Beginnen Sie mit der Generierung, überprüfen Sie das Ergebnis und laden Sie das Bild herunter oder passen Sie Ihre Eingabeaufforderung und Referenzen für einen weiteren Durchgang an." }
                ],
                howToCta: "Probieren Sie den Midjourney AI Image Generator aus",
                faqTitle: "Häufig gestellte Fragen zu Midjourney",
                faqs: [
                    { q: "Was ist der Midjourney AI-Bildgenerator?", a: "Midjourney ist ein weit verbreitetes Text-zu-Bild-Modell, das für seine künstlerischen, filmischen Visuals bekannt ist. Auf Miral verwandelt der Midjourney AI-Bildgenerator schriftliche Eingabeaufforderungen direkt in Ihrem Browser in eindrucksvolle Bilder für Konzeptzeichnungen, Key Visuals, Poster und redaktionelle Arbeiten." },
                    { q: "Mit welchem ​​Tool kann ich filmische Konzeptzeichnungen mit Referenzbildern erstellen?", a: "Midjourney kombiniert eine reichhaltige künstlerische Leitung, dramatische Beleuchtung, realistische und Anime-Stile sowie Referenzbildführung für filmische Konzeptkunst, Key Visuals und Markenbilder." },
                    { q: "Kann ich den Midjourney AI-Bildgenerator kostenlos nutzen?", a: "Ja. Melden Sie sich an, um kostenlose Credits zu erhalten und sofort mit der Erstellung hochwertiger Bilder mit dem Midjourney AI-Bildgenerator zu beginnen. Für die Generierung von Bildern werden die entsprechenden Credits verwendet." },
                    { q: "Wie verwende ich den Midjourney AI-Bildgenerator online?", a: "Geben Sie eine anschauliche Textaufforderung ein, die das Motiv, die Stimmung, die Beleuchtung und den Stil beschreibt, wählen Sie im Bedienfeld „Realistisch“ oder „Anime“, laden Sie optional bis zu fünf Referenzbilder hoch und klicken Sie auf „Generieren“. Midjourney eignet sich gut für Konzeptzeichnungen, Key Visuals, Poster, Porträts und redaktionelle Illustrationen." },
                    { q: "Was ist der Unterschied zwischen dem realistischen und dem Anime-Stil?", a: "„Realistisch“ setzt auf fotografische Details, natürliches Licht und lebensechte Texturen, während „Anime“ stilisierte Linien, kräftige Farben und einen handgezeichneten Look bevorzugt. Sie wählen den Stil im Bedienfeld aus, sodass sich Ihre Eingabeaufforderung auf die Szene selbst konzentrieren kann." },
                    { q: "Wie kann ich Midjourney-Bilder reparieren, die nicht mit meiner Referenz übereinstimmen?", a: "Laden Sie bis zu fünf klare Referenzbilder (PNG, JPG, JPEG oder WebP) hoch und beschreiben Sie, welcher Farbpalette, Charakteroptik, Produktform oder Gesamtästhetik das Ergebnis folgen soll." },
                    { q: "Was sind die besten Midjourney-Prompt-Beispiele?", a: "Effektive Midjourney-Eingabeaufforderungen beschreiben das Thema, die Umgebung, die Stimmung, die Beleuchtung und den künstlerischen Look im Detail und koppeln diese Eingabeaufforderung dann mit dem richtigen Stil auf dem Panel. Nutzen Sie die Beispiele für Midjourney-Eingabeaufforderungen auf dieser Seite als Ausgangspunkt und passen Sie sie an Ihr Projekt an." },
                    { q: "Midjourney vs. Stable Diffusion 3.5: Welches sollte ich verwenden?", a: "Wählen Sie basierend auf dem Workflow und nicht auf der Grundlage eines universellen Gewinners. Midjourney eignet sich hervorragend für künstlerische Konzepte, filmische Beleuchtung und referenzbasierte Visuals mit vorgefertigten realistischen und Anime-Stilen auf Miral. Stable Diffusion 3.5 eignet sich möglicherweise für Entwickler, die explizite negative Eingabeaufforderungen und flexible Seitenverhältnisse mit benutzerdefinierten Größen benötigen." }
                ],
                ctaTitle: "Probieren Sie Midjourney kostenlos auf Miral aus!",
                ctaDesc: "Geben Sie oben Ihre Idee ein und verwenden Sie den Midjourney AI-Bildgenerator mit realistischen oder Anime-Stilen und Referenzbildführung, um künstlerische Visuals zu erstellen."
            }
        }
  }
}
